import { Component, OnInit,AfterViewInit, ElementRef, QueryList, ViewChild, ViewChildren, NgZone,ViewEncapsulation,OnChanges, OnDestroy,Input, Output,EventEmitter,SimpleChanges,HostListener} from '@angular/core';
import {BrowserModule, DomSanitizer, Title} from '@angular/platform-browser'
import { ReportService } from '../inservice/report.service';
import { CookieService } from '../_services/cookie.service';
import { FmeService } from '../inservice/fme.service';
import { FrmService } from '../inservice/frm.service';
import { environment } from '../../environments/environment';
import {Utils} from '../_util/utils';
import {CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { DOCUMENT, Location } from '@angular/common';
import { Table } from 'primeng/table';
//import { Console } from 'console';
//import { threadId } from 'worker_threads';
declare var WEBSPELLCHECKER: any;
declare var $: any;
@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TemplateComponent implements OnInit, OnChanges, OnDestroy  {
	itemIndex=0;
	addon:string;
	logoInfo=[];
	userInfo:any;
	userId:string;
	userName="User";
	tempInfo:any;
	r:string;
	types=[];
	templateCols;

	libraries=[];
	libLabels=[];
	slots=[];
	cols1:any[];
	cols2:any[];
	cols3:any[];
	cols4:any[];
	cols5:any[];
	public cols6:any[];
	selectedSlot:any;
	selectedRptType:string;
	selectedType="";
	selectedCover="";
	selectedHeader="";
	selectedFooter="";
	selectedPHeader="";
	selectedPFooter="";
	selectedTHeader="";
	selectedTFooter="";
	selectedFrmFooter='';
	selectedFrmHeader="";
	selectedProfile=-1;
	selectedIden="";
	tempName="";
	categories:any[];
	temps:any[];
	sections:any[];
	chosenSec:any[];
	addedSec:any[];
	tempContents:any[];
	contents:any[];	
	frontpages=[];
	appendices={'SECTION_SEQUENCE': "",'SECTION_TITLE': 'APPENDICES','SUB_SECTIONS':[]};
	tempAppendices:any;
	tempIndex:number;
	curIndex=[];
	pageIndex=[];
	slotCategories:any[];
	slotTypes:any[];
	groupSlots=[];
	templateSlots=[];
	public expandedRows = {};
	isExpanded=false;
	slotCheckAll=false;
	curTemp:any;
	addedLib=[];
	addedLibs=[];
	libToSlot=false;
	slotToLib=false;
	curLib=[];
	curLibId=[];
	curSlot=[];
	curSlotId=[];
	newSlotLabel="";
	newSlotCat="";
	newSlotType="";
	newSlotMultiple="N";
	newSlotFile={'url':'', 'name':'', 'ext':''};
	newSlotContent="";
	newSlotOp="";
	newSlotOps=[];
	slotTableType=-1;
	tableSlots=[];
	erisSlots=[];
	selSlots=[];
	pdfSlots=[];
	slotGroup='A';
	filteredData:any[];
	otherTypes=['TABLE','MAP','PHOTOS','LOCKED_CONTENT','COSTTABLE', 'PCATABLE','UNITTABLE','SEALS','SIGNS','PDFSEC', 'PCASUMMARY', 'PISUMMARY','PITABLE'];
	curTableData:any;
	curCostTable:any;
	rowNo=0;
	colNo=0;
	colType=[];
	newLibPara=[];
	addedItem:any;
	addBefore=false;
	addLibWarn=false;
	tableContent=[];
	addLib=false;
	loading=false;
	pdfs=[];
	appOp='O';
	isEven=true;
	allEditor=[];
	selectedCell:any;
	selectedRow:number;
	inputLabels='';
	imgGroup='other';
	uploadFiles=0;
	uploadTotal=0;
	uploadNo=0;	
	showCat=false;
	public current:any;
	public covers=[];
	public bks=[];
	public others=[];
	public photos=[];
	public logos=[];
	public headers=[];
	public footers=[];
	public uploadedFiles=[];
	public selectedEditor:string;
	public selectIndex:number;
	public selectedImage;
	public selectedInsert=[];
	public logOutFlag=0;
	public convertDocs=[];
	private fileReader: FileReader;
	public pageMargin={'top':'80', 'bottom':"40", 'left':"25", 'right':"25"};
	public tocMargin={'top':'80', 'bottom':"40", 'left':"25", 'right':"25"};
	public portraitSize={'width':'816','height':'1054'};
	public landscapeSize={'width':'1054','height':'816'};
	public selectpage={'type':'portrait', 'size':{'width':'816','height':'1054'}};
	public selectPdi='600';
	public content='';;
	public showLogo=0;
	public rowData;
	public outData:string;
	public uploadType:string;
	public logoUrl="";
	public bimageurl="";
	public currencies=[];
	public multipliers=['Square Feet (Gross)','Square Feet (NRSF)','Units','Beds','Guestrooms','Pads','Spaces','Acreage/Land Size','Room'];
	public pcaOp={'term':'Include','multiplier':"", 'reserve':12, 'decimal':0,'currency':'USD','inflation':'2.5','round':'Round'};
	public reserveTerm=12
	public pcaLibraries=[];
	public pcaIdentifiers=[];
	public costTables=[];
	public curCost=[];
	public curCostId=[];
	public addedCost=[];
    public filterText="";
	public repairKeys=['Item','EUL','EFF','RUL','Quantity','Unit','Cost','Cycle','Percent','Year', 'Total'];
	//public repairCols=['Item','EUL','EFF AGE','RUL','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Year x', 'Total'];
	public repairCols=['Item','EUL','EFF AGE','RUL','Quantity','Unit','Unit Cost','Cycle Replace','Replace Percent','Year x', 'Total'];
	public repairWidth=['25','3','3','3','5','3','3','5','4.5','3.5', '8'];//total 58 for no year data
	public costCols1=['Item','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Reserve Total','Immediate Total','Short Term Total'];
	public costKeys1=['Item','Quantity','Unit','Cost','Cycle','Percent','Reserve','Immediate','Short'];
	public costCols2=['Recommendation','EUL','EFF AGE','RUL','Year','Cost'];
	public costKeys2=['Item','EUL','EFF','RUL','Year','Total'];	
	public rowItem={'index':[],'Item': '','Quantity': 0,'Unit': '','Cost': 0,'Cycle': 0,'Percent': 100,'Immediate': 0,'Short': 0, 'EFF':0,'EUL':0,'RUL':0,"Total":0, 'Reserve':0,'reserve':0,'averageReserve':0,'inReserve':0,'averageINReserve':0,'allocate':[],'allow':false,'Year':10, 'data':{'COST':[]}};
	public newRow={'index':[],'Item': '','Quantity': 0,'Unit': '','Cost': 0,'Cycle': 0,'Percent': 100,'Immediate': 0,'Short': 0, 'EFF':0,'EUL':0,'RUL':0,"Total":0, 'Reserve':0,'reserve':0,'averageReserve':0,'inReserve':0,'averageINReserve':0,'allocate':[],'allow':false,'Year':10,'data':{'COST':[]}};
	public clipBoard:any;
	addLibShow=false;
	newLib=false;
	dragDisabled=true;
	autoFlag=false;
	curId:string;
	curSec:any;
	curDoc:any;
	cellShow=false;
	curCol:any;
	curCell:any;
	curCellBK:any;
	curColBK:any;
	curHeader=false
	intext=false;
	public uploading=false;
	allRow=false;
	allCol=false;
	pcaType:string;
	blackText=false;
	acceptType=[];
	moveShow=false;
	profiles=[];
	printnodataforAppendix='Y';
	lpagesize="legal-landscape";
	summaryCategory=[];//["Executive Summary","Code Information and Accessibility", "Site Improvements", "Architectural and Structural Systems", "Interior Components"];
	isOnline = navigator.onLine;
	//@ViewChild(InjectDirective) injectComp: InjectDirective;
	@ViewChild("viewer") viewer: ElementRef;
	@ViewChild('file') file: ElementRef;
	@ViewChild('file1') file1: ElementRef;
	@ViewChild('file3') file3: ElementRef;
	@ViewChild('file4') file4: ElementRef;
	@ViewChild("dt5", { static: false }) public dt5: Table;
	@ViewChild('pdfspin') pdfspin: ElementRef;
	@ViewChild('hotkeyIcon') hotkeyIcon: ElementRef;
	@ViewChild('edittableContainer') edittableContainer: ElementRef;	
		
  constructor(private elementRef: ElementRef, private location: Location, private titleService :Title, private sanitizer: DomSanitizer, private router: Router,
  public  reportService: ReportService, public fmeService:FmeService, public frmService:FrmService, private zone: NgZone, private cookieService:CookieService,private route: ActivatedRoute,
              ) { 
	router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = router.parseUrl(router.url);
        if (tree.fragment) {
          const element = document.querySelector("#" + tree.fragment);
          if (element) { element.scrollIntoView(); }
        }
      }
    });
	
	let id=decodeURI(this.route.snapshot.paramMap.get('id')); 
	if(this.cookieService.getCookie("userID")) {
						this.userInfo=JSON.parse(this.cookieService.getCookie("userInfo"));
						this.userId = this.cookieService.getCookie("userID");
						this.userName = this.cookieService.getCookie("userName");
						this.r=this.cookieService.getCookie("r");
						if(id!='null'){
							let startJson={"PROCEDURE":"gettemplateeditstatus","USER_ID":this.userId,"TEMPLATE_ID":id}
							this.reportService.univeralService(JSON.stringify(startJson)).subscribe(response => {
								
								if(response.RESPONSE_STATUS=='Y'){
									if(response.EDIT_TEMPLATE=='Y'){
										this.getAllCover();
										this.getTemplate(id);
										//this.getProfile(id);
										this.getCompanyProfiles(id)
										this.getSignStyles(id);
										this.getSignInfo(id);
										
									}else{
										this.router.navigate(['complete-temp/'+id])
											.then(nav => {
												console.log(nav); // true if navigation is successful
											}, err => {
												console.log(err) // when there's an error
											});
									}
								}else{
									
										this.throwError(response)
									 
								}
							})							
						}else{
							let that=this;
							setTimeout(() => {
								$('#overlay').css('display','none');
							},1000);
							Swal.fire({
								title: 'What would you like to do today?',								
								confirmButtonText: 'Create New Template',
								showLoaderOnConfirm: true,
								showCancelButton: true,
								cancelButtonText: 'Edit a Template',
								//denyButtonText: 'Choose Saved Template',
								//allowOutsideClick:false,
								backdrop:false,
								}).then((result) => {
									if (result.isConfirmed) {
										that.startNew();
										
									}else if (	result.dismiss === Swal.DismissReason.cancel){
										this.expandcollapse();
									}

							})
												
						}
						
						this.getAllHeader();
						this.getAllFooter();
						this.getAllBk(parseInt(this.userId));
						this.getLogo();
						this.getSlots();
						this.getSlotPara();
						this.getslotType();
						this.getTableSlots("Table");
						this.getTableSlots("Selection");
						this.getTableSlots("File");
						//this.getLibraries(parseInt(this.userId));
						//this.getLibLabels(parseInt(this.userId));
	}else{
		this.router.navigate(['/']);
	} 
	this.contents=[];
	
		this.acceptType=this.reportService.acceptFileType.split(',');
	}
	getSlots(){
		let inputJson={"PROCEDURE":"getslots", "USER_ID":parseInt(this.userId)};
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.slots=data.RW_SLOTS;
		}
		})
	}
	getGroupSlots(){
		let inputJson={"PROCEDURE":"getslotsbycategory", "USER_ID":parseInt(this.userId)};
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.groupSlots=data.RW_SLOT_CATEGORIES;
			  }			
		})
	}
	getSlotPara(){
		let inputJson={"PROCEDURE":"getslotcategories","USER_ID":parseInt(this.userId)};
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			
			this.slotCategories=data.RW_SLOT_CATEGORIES;			
		})
	}
	getslotType(){
		let inputJson={"PROCEDURE":"getslottypes","CREATE_NEW_RF":"Y"};
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.slotTypes=data.RW_SLOT_TYPES;	
			  }		
		})
	}
	getLibraries(){
		this.loading=true
		this.zone.run(()=>{this.loading=true;})
		//let inputJson={"PROCEDURE":"getlibrary", "USER_ID":parseInt(this.userId), "KEYWORD":"", "REPORT_TYPE":"ESA"};
		let inputJson={"PROCEDURE":"getlibrarysimple", "USER_ID":parseInt(this.userId), "KEYWORD":"", "REPORT_TYPE":"ESA"};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.libraries=data.RW_LIBRARY;
			this.filted=false;
			this.zone.run(()=>{this.loading=false;})
			  }
		})
	}
	getLibLabels(){
		let inputJson={"PROCEDURE":"getlibrarylabels","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			//this.libLabels=data.RW_LABELS;
			this.libLabels=[];
			let that=this;			
			data.RW_LABELS.forEach(name => {
				that.libLabels.push({ label: name.LABEL, value: name.LABEL });
			});
		}
		})
	}
	getTableSlots(type){
		let inputJson={"PROCEDURE":"getslotsbytype", "USER_ID":parseInt(this.userId), "SLOT_TYPE":type,"ACTIVE_ONLY":"Y"};
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			if(type=='Table'){
				this.erisSlots=data.RW_SLOTS;
			}else if(type=='Selection'){
				this.selSlots=data.RW_SLOTS;
			}else if(type=='File'){
				this.pdfSlots=data.RW_SLOTS;
			}
		}
		})
	}
	/*getProfile(id){
		let inputJson={"PROCEDURE":"getcompanyprofile","USER_ID":parseInt(this.userId),"TEMPLATE_ID":id};
				
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			
			if(response.RESPONSE_STATUS=="Y"){
				if(response.PCA_TABLE_STYLE&&response.PCA_TABLE_STYLE.length>0){
					this.pcaType=response.PCA_TABLE_STYLE;
				}					
			}else{
				this.throwError(response)
				}
		})
			
	}*/
	ngOnInit(): void {
		this.isOnline = navigator.onLine;
		this.titleService.setTitle("Template");
		let w = Math.floor(Utils.mmToPx(279, this.reportService.dpi)); 
		let h = Math.floor(Utils.mmToPx(216, this.reportService.dpi)); 
//		this.newCover();
		this.getCompanyGroupIndicator();
		this.cols1 = [			
			//{ field: 'SLOT_ID', header: 'Id' },
         	{ field: 'KEY', header: 'label', width: '20%' },
			{ field: 'CONTENT', header: 'Content', width: '50%' },
			{ field: 'CATEGORY', header: 'Category', width: '20%' },
			{ field: '', header: '' , width: '10%' },
				
        ];
		this.cols2 = [			
			{ field: 'CATEGORY', header: 'Category', width: '92%' },
			//{ field: '', header: '' , width: '10%' },
				
        ];
		this.cols3 = [			
			{ field: 'KEY', header: 'label', width: '30%' },
			{ field: 'CONTENT', header: 'Content', width: '60%' },		
			{ field: '', header: '' , width: '10%' },
				
        ];
		this.cols4 = [			
			{ field: 'LABELS', header: 'Title', width: '92%' },
			//{ field: '', header: '' , width: '10%' },
				
        ];
		this.cols5 = [			
			//{ field: 'SLOT_ID', header: 'Id' },
         	{ field: 'ITEM_TITLE', header: 'label', width: '10%' },
			{ field: 'LABELS', header: 'Content', width: '10%' },
			{ field: 'INSTRUCTIONS', header: 'Category', width: '30%' },
			{ field: 'CONTENT', header: '' , width: '50%' },
				
        ];
		this.cols6 = [			
			//{ field: 'SLOT_ID', header: 'Id' },
         	{ field: 'FILE_NAME', header: 'File Name', width: '40%' },
			{ field: 'FILE_TYPE', header: 'File Type', width: '11%' },
			{ field: 'PROJECT_ID', header: 'Project Name', width: '15%' },
			{ field: 'REPORT_ID', header: 'Report Type ' , width: '14%' },
			{ field: 'USER_ID', header: 'Upload By ' , width: '12%' },
			{ field: 'FILE_ID', header: 'Date ' , width: '8%' },
				
        ];
		this.templateCols=[

			{ field: 'TEMPLATE_TITLE', header: 'Template Name', width: '20%', filterMatchMode: 'contains'},
			{ field: 'CATEGORY_NAME', header: 'Template Type', width: '7%'},
			{ field: 'SUBCATEGORY_NAME', header: 'Template Identifier', width: '20%'},
			{ field: 'CREATED_BY', header: 'Created By', width: '10%'},
			{ field: 'DATE_CREATED', header: 'Date Created', width: '10%', filterMatchMode: 'contains'},
			{ field: 'DATE_UPDATED', header: 'Modified Date', width: '10%', filterMatchMode: 'contains'},
			{ field: 'STATUS', header: 'Status', width: '5%'},
		
				{field: 'EDIT', header:'Edit', width:"5%"}
		  ]
		$(document).ready(function () {
			$('#tableModal').draggable();
			$('#fileModal').draggable();
			$('#libraryModal').draggable();
			$('#costLibModal').draggable();
			//$('#costDetailModal').draggable();			
		});
		if(this.reportService.autoSaveFlag=='Y'){
			this.autoFlag=true;
		}
		if(this.autoFlag){
			this.autoSave();
		};
	}
	ngOnChanges(changes: SimpleChanges): void {
      
	}
	ngOnDestroy(): void {
  }

	

	public onInfo(e){
	  //this.getOrderDetail();
	}
	saveTemplate(type?){
		if(this.contents.length==0&&this.frontpages.length==0){
			return
		}
		let content='';
		if(this.contents.length>0){//console.log(this.contents)
			content=JSON.stringify(this.contents);
		}
		
		let app=JSON.stringify(this.appendices);
		let beforeToc='';
		if(this.frontpages.length>0){
			beforeToc=JSON.stringify(this.frontpages);
		}
		let saveType='N';
		if(type){
			saveType=type;
		}
		let pdfInfo={'text':this.pdfFname.text, "name":this.pdfFname.name};
		let inputJson={"PROCEDURE":"updatetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID, "TEMPLATE_TITLE":this.tempInfo.TEMPLATE_TITLE, "TEMPLATE_URL":this.tempInfo.TEMPLATE_URL, "TEMPLATE_DATA":content, "TEMPLATE_TYPE_ID":this.tempInfo.TEMPLATE_TYPE_ID, "COVERPAGE_ID":parseInt(this.selectedCover),"APPENDIX_DATA":app, "HEADER_ID":parseInt(this.selectedHeader),"FOOTER_ID":parseInt(this.selectedFooter),"PHOTOLOG_HEADER_ID":parseInt(this.selectedPHeader),"PHOTOLOG_FOOTER_ID":parseInt(this.selectedPFooter),'PCA_DATA':JSON.stringify(this.pcaOp), 'PDF_FILE_NAME':JSON.stringify(pdfInfo), "BEFORE_TOC":JSON.stringify(this.frontpages),'AUTO_SAVE':saveType, "TOC_FOOTER_ID":parseInt(this.selectedTFooter),"TOC_HEADER_ID":parseInt(this.selectedTHeader)};
		//console.log(inputJson)
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{
			
			if(result.RESPONSE_STATUS=='N'){
				if(result.ERRORCODE=='9'){
					this.throwError(result)
				}else{
				window.clearInterval(this.saveTimer);
				Swal.fire({
					html: '<span style="color:red">'+result.MESSAGE+'</span>',							
					confirmButtonText: 'OK',
					showLoaderOnConfirm: true,
					showCancelButton: false,
					preConfirm: () => {						       
						//window.location.reload();
						let url='/template/'+this.current.toString();
						//this.router.navigate([url]);
						window.location.reload();
					}       
				})
			}
			}else{
				if(this.autoFlag){
					window.clearInterval(this.saveTimer);			
					this.autoSave();
				};
			}
			if(this.replacing){
				this.replacing=false;
			}
	 })		
 }
 @HostListener('document:keydown', ['$event'])
 handleTheKeyboardEvent(event: KeyboardEvent) {
	 if(this.tableShow&&this.preCell&&(!this.curCell)&&event.ctrlKey){
		 switch (event.key) {
			 case "ArrowRight":
				 this.naviCell(event.key);
				 event.preventDefault();
				 break;
			 
			 case "ArrowDown":
				 this.naviCell(event.key);
				 event.preventDefault();
				 break;
			 
			 case "ArrowLeft":
				 this.naviCell(event.key);
				 event.preventDefault();
				 break;
			 
			 case "ArrowUp":
				 this.naviCell(event.key);
				 event.preventDefault();
				 break;

			 case "Enter":
				 this.editCell();
				 event.preventDefault();
				 break;

			 case "c":
				 this.shortCut('c');
				 event.preventDefault();
				 break;
			 
			 case "v":
				 this.shortCut('v');
				 event.preventDefault();
				 break;
			 
			 case " ":
				 this.shortCut(' ');
				 event.preventDefault();
				 break;
			 
			 case "m":
					 this.shortCut('m');
					 event.preventDefault();
					 break;
		 }
	 
	 }else if(this.tableShow&&this.preCell&&this.curCell&&event.ctrlKey){console.log(event)
		 switch (event.key) {
			 case "m":
					 this.shortCut('m');
					 event.preventDefault();
					 break;
		 }
			 
	 }else if(this.tableShow&&this.preCell&&this.curCell&&event.altKey){
		 switch (event.key) {
			 case "s":
				 $('#overlay2').css('display','block');
				 this.saveCell(this.curSec);
				 this.zone.run(()=>{
					 $('#overlay2').css('display','none');
				 })
				 event.preventDefault();
				 break;
			 
			 /*case "c":
				 this.closeCell();
				 event.preventDefault();
				 break;
			 */
			 case "ArrowRight":
				 $('#overlay2').css('display','block');
				 this.itemIndex++;
				 this.curCell['reqIndex']=this.itemIndex;
				 this.toCell(this.curSec.id);					
				 setTimeout(() => {				
					 this.naviCell(event.key);
					 this.editCell();
					 $('#overlay2').css('display','none');
				 }, 300);	
				 
				 event.preventDefault();
				 break;
			 
			 case "ArrowDown":
				 $('#overlay2').css('display','block');
				 this.saveCell(this.curSec);
				 setTimeout(() => {				
					 this.naviCell(event.key);
					 this.editCell();
					 $('#overlay2').css('display','none');
				 }, 300);	
				 event.preventDefault();
				 break;
			 
			 case "ArrowLeft":
				 $('#overlay2').css('display','block');
				 this.saveCell(this.curSec);
				 setTimeout(() => {				
					 this.naviCell(event.key);
					 this.editCell();
					 $('#overlay2').css('display','none');
				 }, 300);	
				 event.preventDefault();
				 break;
			 
			 case "ArrowUp":
				 $('#overlay2').css('display','block');
				 this.saveCell(this.curSec);
				 setTimeout(() => {				
					 this.naviCell(event.key);
					 this.editCell();
					 $('#overlay2').css('display','none');
				 }, 300);	
				 event.preventDefault();
				 break;
		 }
	 }
	 
 }
 private saveCell(doc){
	this.itemIndex++;
	this.curCell['reqIndex']=this.itemIndex;
	this.toCell(doc.id);	
}
	public textData(e, id){
	let secIndex=this.getIdIndex(id); 
	let data=this.sanitizer.bypassSecurityTrustHtml(e);
	this.toContentData('text', e, '', secIndex);
	this.toContentData('htmltext', data, '',secIndex);
	let ids=this.getAllSlotId(e); 
	if(ids&&ids.length>0){
		let all=[];
		for(let slotid of ids){
			let index=this.slots.findIndex(item=>item.SLOT_ID==slotid);
			if(index>-1){
				all.push(this.slots[index]);
				if(this.slots[index].CATEGORY){
					this.addToTemp(this.slots[index],this.slots[index].CATEGORY);
				}
			}
		}
		
	this.toContentData('slots', all, '',secIndex);
			
	}
		if(this.autoFlag){
			this.saveTemplate();
		}
	
  }
  
	getAllCover(){
		let inputJson={"PROCEDURE":"getallcoverpages", "USER_ID":parseInt(this.userId)};
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.covers=data.RW_COVERPAGES;
			  }
		})
	}
	getAllHeader(){
		let inputJson={"PROCEDURE":"getallheaders", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.headers=data.RW_HEADERS;
			  }
		})
	}
	getAllFooter(){
		let inputJson={"PROCEDURE":"getallfooters", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.footers=data.RW_FOOTERS;
			  }
		})
	}
	getAllBk(id){
		let inputJson={"PROCEDURE":"getcompanyfiles","USER_ID":id,"FILE_TYPE":"BKIMAGE"}
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.bks=data.RW_UPLOAD_FILES;
			  }
		})
		let inputJson1={"PROCEDURE":"getcompanyfiles","USER_ID":id,"FILE_TYPE":"IMAGE"}
		
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.others=data.RW_UPLOAD_FILES;
			  }
		})
	} 
	private getLogo(){
		let inputJson={"PROCEDURE":"getcompanyfiles","USER_ID":this.userInfo.USER_ID,"FILE_TYPE":"LOGO"};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.logoInfo=data;		
			this.logos=data.RW_UPLOAD_FILES;
			  }
		})
	} 
	getTemplateHistory(){
		
		this.getAllTempByTypeID(this.tempInfo.TEMPLATE_ID);
		let inputJson={"PROCEDURE":"gettemplatehistory","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
			  }else{
			this.tempInfo.RW_TEMPLATE_HISTORY=response.RW_TEMPLATE_HISTORY;
			  }
		})
	}
	typeList=[];
	getAllTempByTypeID( typeID) {
		let inputJson={"PROCEDURE":"getreportlistbytemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":typeID};
		let typeIdTemplates=[];
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			for (let obj of data.RW_REPORTS) {
				typeIdTemplates.push(obj);
			}
			this.typeList2=typeIdTemplates;
			this.typeList=this.typeList2;
		}
		});
		
		
	}
	getCostLib(libs?){
		this.filterText="";
		if(this.pcaLibraries.length==0){
			let inputJson3={"PROCEDURE":"getpcacostlibrary","USER_ID":parseInt(this.userId)};
				this.reportService.univeralService(JSON.stringify(inputJson3)).subscribe(response => {
					if (response.RESPONSE_STATUS=='N') {
						this.throwError(response)
					  }else{
					this.pcaLibraries=response.RW_PCA_COST_LIBRARY; console.log(this.pcaLibraries);
						setTimeout(() => {
							this.dt5.reset();
						},10);
					}
				})
				let inputJson4={"PROCEDURE":"GetCostLibraryIdentifier", "USER_ID":parseInt(this.userId)};
				this.reportService.univeralService(JSON.stringify(inputJson4)).subscribe(response => {
					if (response.RESPONSE_STATUS=='N') {
						this.throwError(response)
					  }else{
					let items=response.RW_COST_LIBRARY_IDENTIFIERS;
					for(let item of items){
						this.pcaIdentifiers.push(item.IDENTIFIER);
					}
					}
				})
		}else{
			setTimeout(() => {
				this.dt5.reset();
						},10);
		}
				if(libs){
					this.addedCost=libs;
					this.curCost=[];
					this.curCostId=[];	
				}else{
					this.addedCost=[];
				}
	}
	getTemplate(id){
		$('#overlay').css('display','block');
		let inputJson={"PROCEDURE":"gettemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":id};
		
		this.current=id;
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
			}else{
			if(response.TEMPLATE_DATA&&response.TEMPLATE_DATA.length>0){
				this.contents=JSON.parse(response.TEMPLATE_DATA);console.log(this.contents)				
			}
			/*if(response.PCA_INDICATOR&&response.PCA_INDICATOR=='frm1104'){
				this.contents=JSON.parse(JSON.stringify(this.frmService.frm1104content));console.log(this.contents)
				this.toFlat();
			}
			if(response.PHASE1_TYPE&&response.PHASE1_TYPE=='1103'){
				this.contents=JSON.parse(JSON.stringify(this.frmService.frm1103content));console.log(this.contents)
				//this.toFlat();
			}*/
			//this.contents=JSON.parse(this.mockData);console.log(this.contents)
			if(response.BEFORE_TOC&&response.BEFORE_TOC.length>0){
				this.frontpages=JSON.parse(response.BEFORE_TOC); 
			}
			this.curIndex=[this.addon,this.addon,this.addon];
			this.generateSeq();
			this.getAllowPhase1PS(id);
			this.summaryStatus=this.haveSummary();
			this.getTemplateSlots(response.TEMPLATE_ID);
			this.pageMargin.top=response.REPORT_MARGIN_TOP;
			this.pageMargin.bottom=response.REPORT_MARGIN_BOTTOM;
			this.pageMargin.left=response.REPORT_MARGIN_LEFT;
			this.pageMargin.right=response.REPORT_MARGIN_RIGHT;	
			this.tocMargin.top=response.TOC_MARGIN_TOP;
			this.tocMargin.bottom=response.TOC_MARGIN_BOTTOM;
			this.tocMargin.left=response.TOC_MARGIN_LEFT;
			this.tocMargin.right=response.TOC_MARGIN_RIGHT;
			if(response.PCA_DATA.length>0){
				this.pcaOp=JSON.parse(response.PCA_DATA); console.log(this.pcaOp);
				this.reserveTerm=this.pcaOp.reserve;
			}
			if(response.PCA_PAGE_SETUP){
				this.lpagesize=response.PCA_PAGE_SETUP;
			}
			if(response.PCA_TABLE_STYLE&&response.PCA_TABLE_STYLE.length>0){
				this.pcaType=response.PCA_TABLE_STYLE;
			}
			this.tempInfo=response;
			if(this.tempInfo.SIGNATURE_STYLE&&this.tempInfo.SIGNATURE_STYLE.SIGNATURE_STYLE_ID>-1){
				this.defaultSign=this.tempInfo.SIGNATURE_STYLE;
				this.getSignContent(this.defaultSign['SIGNATURE_STYLE_ID']);
			}
			this.getTemplateHistory()
			if(response.PCA_INDICATOR&&response.PCA_INDICATOR=='Y'){
				this.getCostLib();
			}else if(response.PCA_INDICATOR&&response.PCA_INDICATOR=='4099e'){
				//this.getCostLib();
				//this.contents=[]
				//this.iniFme();
				this.capitalCategory=this.fmeService.capitalCategory;
				this.ratingOps=this.fmeService.ratingOps;
				this.actionItemOps=this.fmeService.actionItemOps;
				this.ulGroup=this.getGroup();
				
			}else if(response.PCA_INDICATOR&&response.PCA_INDICATOR=="frm1105"){
				//this.contents=[]
				//this.iniFrm1105();
				this.getAllCostTable();
				this.capitalCategory=this.frmService.capitalCategory;
				this.conditionOps=this.frmService.conditionOps;
				this.actionItemOps=this.frmService.actionItemOps;
			}else if(response.PCA_INDICATOR&&response.PCA_INDICATOR=='frm1104'){
				this.toFlat();
			}else if(response.PHASE1_TYPE&&response.PHASE1_TYPE=='1103'){
				//this.contents=JSON.parse(JSON.stringify(this.frmService.frm1103content));console.log(this.contents)
				this.toFlat();
			}
			if(response.COVERPAGE&&response.COVERPAGE.length>0){
				this.selectedCover=response.COVERPAGE[0].COVERPAGE_ID;
			}
			if(response.HEADER&&response.HEADER.length>0){
				this.selectedHeader=response.HEADER[0].HEADERFOOTER_ID;
			}
			if(response.FOOTER&&response.FOOTER.length>0){
				this.selectedFooter=response.FOOTER[0].HEADERFOOTER_ID;
			}
			if(response.PHOTOLOG_HEADER&&response.PHOTOLOG_HEADER.length>0){
				this.selectedPHeader=response.PHOTOLOG_HEADER[0].PHOTOLOG_HEADER_ID;
			}
			if(response.PHOTOLOG_FOOTER&&response.PHOTOLOG_FOOTER.length>0){
				this.selectedPFooter=response.PHOTOLOG_FOOTER[0].PHOTOLOG_FOOTER_ID;
			}
			if(response.TOC_HEADER&&response.TOC_HEADER.length>0){
				this.selectedTHeader=response.TOC_HEADER[0].TOC_HEADER_ID;
			}
			if(response.TOC_FOOTER&&response.TOC_FOOTER.length>0){
				this.selectedTFooter=response.TOC_FOOTER[0].TOC_FOOTER_ID;
			}
			if(response.FRM_HEADER&&response.FRM_HEADER.length>0){
				this.selectedFrmHeader=response.FRM_HEADER[0].FRM_HEADER_ID;				
			}
			if(response.FRM_FOOTER&&response.FRM_FOOTER.length>0){
				this.selectedFrmFooter=response.FRM_FOOTER[0].FRM_FOOTER_ID;				
			}
			if(response.COMP_PROFILE_ID&&response.COMP_PROFILE_ID>-1){
				this.selectedProfile=response.COMP_PROFILE_ID;
			}
			if(response.PDF_FILE_NAME&&response.PDF_FILE_NAME.length>0){
				this.pdfFname=JSON.parse(response.PDF_FILE_NAME);
			}			
			this.titleService.setTitle("Template"+' - '+response.TEMPLATE_TITLE);
			if(response.APPENDIX_DATA&&response.APPENDIX_DATA.length>0){
				this.appendices=JSON.parse(response.APPENDIX_DATA);
			}
			if(response.PRINT_BLACKWHITE&&response.PRINT_BLACKWHITE=='Y'){
				this.blackText=true;
			}else{
				this.blackText=false;
			}
			if(response.BODYINDENT_SAME_STITLE&&response.BODYINDENT_SAME_STITLE=='Y'){
				this.contentIndent=true;
			}else{
				this.contentIndent=false;
			}
			if(response.SUMMARY_CATEGORY&&response.SUMMARY_CATEGORY.length>0){
				this.summaryCategory=response.SUMMARY_CATEGORY.split(',');
			}	
			if(response.APPENDIX_NODATA_MESSAGE){
				this.printnodataforAppendix=response.APPENDIX_NODATA_MESSAGE;
			}
			if(response.TEMPLATE_TYPE&&response.TEMPLATE_TYPE[0].TEMPLATE_TYPE_ID>-1){
				let inputJson1={"PROCEDURE":"gettemplatetypeappendix","USER_ID":parseInt(this.userId),"TEMPLATE_TYPE_ID":response.TEMPLATE_TYPE[0].TEMPLATE_TYPE_ID};
				this.reportService.univeralService1(JSON.stringify(inputJson1)).subscribe(response => {
					let info=JSON.parse(response).TEMPLATE_APPENDIX;
					if(info&&info.length>0){
						this.tempAppendices=JSON.parse(info).TEMPLATE_APPENDIX[0];			
					}
				})
			}
			this.location.go('/template/'+id.toString());
			$('#overlay').css('display','none');
		}
		})
				
	}
	getTemplateSlots(id){
		let tempJson={"PROCEDURE":"getslotsbytemplatecategory", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":id};
		
		this.reportService.univeralService(JSON.stringify(tempJson)).subscribe(response => {
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
			  }else{
			this.groupSlots=response.RW_SLOT_CATEGORIES;
			this.curTemp=response;
			  }		
		})
	}
	
	updateTmp(type, e?){console.log(type, e)
		let inputJson:any
		if(type=="cover"){
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"COVERPAGE_ID":parseInt(this.selectedCover)};
		}else if(type=="header"){
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"HEADER_ID":parseInt(this.selectedHeader)};
		}else if(type=="footer"){
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"FOOTER_ID":parseInt(this.selectedFooter)};
		}else if(type=="pheader"){
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"PHOTOLOG_HEADER_ID":parseInt(this.selectedPHeader)};
		}else if(type=="pfooter"){
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"PHOTOLOG_FOOTER_ID":parseInt(this.selectedPFooter)};
		}else if(type=="Theader"){
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"TOC_HEADER_ID":parseInt(this.selectedTHeader)};
		}else if(type=="Tfooter"){
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"TOC_FOOTER_ID":parseInt(this.selectedTFooter)};
		}else if(type=="Fheader"){
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"FRM_HEADER_ID":parseInt(this.selectedFrmHeader)};
		}else if(type=="Ffooter"){
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"FRM_FOOTER_ID":parseInt(this.selectedFrmFooter)};
		}else if(type=="Profile"){
			let id=$(e.target).val();
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"COMP_PROFILE_ID":parseInt(id)};
		}else if(type=="Signature"){
			let id=$(e.target).val(); console.log(id)
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"SIGNATURE_STYLE_ID":id};
		}
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			console.log(response);
			if(response.RESPONSE_STATUS!='Y'){
				this.throwError(response)
			}else{
				if(type=="Signature"){
					let id=$(e.target).val();
					this.getSignContent(id);	
				}
			}
			
		})
	}
	
  private locations(substring,string){
  var a=[],i=-1;
  while((i=string.indexOf(substring,i+1)) >= 0) a.push(i);
  return a;
}
	/*public preview(){
			setTimeout(() => {
			this.generatePdf();
		},500);
	}
	private generatePdf(){
		
		let html='';
		if(this.selectpage.type=='portrait'){
			html = this.reportService.a4Portrait;
		}else if(this.selectpage.type=='landscape'){
			html = this.reportService.a4Landscape;
		}
		html += `<div class="page-after">`;
		this.rowData=this.viewer.nativeElement.innerHTML;
		let hi=(1054-parseInt(this.pageMargin.top)-parseInt(this.pageMargin.bottom)).toString()+'px';
		html +=`<div style="height:`+hi+`; margin:0; padding:`+this.pageMargin.top+'px '+this.pageMargin.right+'px '+this.pageMargin.bottom+'px '+this.pageMargin.left+'px'+`; background: url('`+this.bimageurl+`');background-repeat: no-repeat;background-size: cover; margin:0">`
		let p1=this.locations('<app-paragraph',this.rowData); 
		let p2=this.locations('app-paragraph>',this.rowData);
				
		for(let i=0; i<p1.length; i++){
			if(i==0){
				html+=this.rowData.substring(0,p1[i]);
				html+=this.convertDocs[i]
			}else{
				html+=this.rowData.substring((p2[i-1]+14),p1[i]);
				html+=this.convertDocs[i]
			}
		}
		html+=this.rowData.substring(p2[p1.length-1]+14); 
	    html += `</div></div>`;
		html += this.reportService.tagEnd;
			  
	}*/
	public upload(type?) {
		if(type){
			this.uploadType=type;
			//this.file4.nativeElement.click();
		}
		if(this.uploadType=='PHOTO'||this.uploadType=='IMAGE'||this.uploadType=='LOGO'||this.uploadType=='BKIMAGE'){
			this.file.nativeElement.click();
		}else if(this.uploadType=='FILE'){
			this.appOp='U';
			this.file1.nativeElement.click();
		}else if(this.uploadType=='slot'){
			this.file3.nativeElement.click();
		}else if(this.uploadType=='pdf'){
			this.file4.nativeElement.click();
		}
	}

	public uploadImage() {
	let that=this;
	this.uploadFiles=0;
		this.uploadNo=0;
   	const files = this.file.nativeElement.files; 
    if(files.length==0){
		this.loading=false;
      return
    }
	const total=files.length;
		this.uploadNo=total;
		for (let file of files)  //for multiple files
		{
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
	}
    for (let file of files)  //for multiple files
    {
		let reader = new FileReader();  
        reader.onloadend = function(e) {
			let image = e.target.result.toString().split(',')[1]; //upload service
			let inputJson:any;
			if(that.uploadType=='BKIMAGE'){
				//inputJson={"UploadFileName":file.name,"customerid":that.userId,"logoData":image};
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"BKIMAGE","filetitle":"","fdata":image};
				
				that.reportService.uploadFile2(inputJson).subscribe(result=>{
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.bks.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; 
					
			})
			}else if(that.uploadType=='PHOTO'){
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"PHOTO","filetitle":"","fdata":image};
				
				that.reportService.uploadFile2(inputJson).subscribe(result=>{
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.photos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; 
					
			})
			}else if(that.uploadType=='IMAGE'){
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"IMAGE","filetitle":"","fdata":image};
				
				that.reportService.uploadFile2(inputJson).subscribe(result=>{
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.others.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100;
					
			})
			}else if(that.uploadType=='LOGO'){
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"LOGO","filetitle":"","fdata":image};
				that.reportService.uploadFile2(inputJson).subscribe(result=>{
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.logos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; 
					
			})
			}
						
		}
		reader.readAsDataURL(file);
		}
  }
  
	public selectPage(type){
		let page:any;
		if(type=='portrait'){
			page=this.portraitSize;
		}else if(type=='landscape'){
			page=this.landscapeSize;
		}
		this.selectpage={'type':type, 'size':page};
	}
	
	private convertFigure(node){
		let value='';
		if($(node)[0].tagName=="FIGURE"){
			let item=$(node);
			if(item.hasClass('image-style-align-left')){
				item[0].style.float='left';								
			}else if(item.hasClass('image-style-align-right')){
				item[0].style.float='right';				
			}else if(item.hasClass('image-style-align-center')){
				item[0].style.display='block';
				item[0].style.margin='auto';
			}else{
				item[0].style.display='block';
				item[0].style.margin='auto';
				if(!item[0].style.width){
					item[0].style.width='30%';
				}				
			}
			item.children('img')[0].style.width='100%';
			
			if(item.children('figcaption')[0]){
				item.children('figcaption')[0].style.textAlign = "center"
			}
			
			value=item[0].outerHTML;
		 }
		 return value; 
	}
	onSavedLogo(e){
		this.showLogo = e;
    
	}
	onEditReport(e){
		
	} 
	logOut(){
		this.logOutFlag++;
	}
	@HostListener('window:offline', [])
	onOffline() {
	  this.isOnline = false;
	  console.warn('Lost internet connection');
	
	  Swal.fire({
		icon: 'warning',
		title: 'Internet Connection Lost!',
		html: `

			<p>Please <b>do not</b> close this browser window.</p><br>
            <p>Check your Wi-Fi or network settings to restore your connection.</p><br>
            <p>
              Click "<b>Confirm</b>" once your internet connection is restored and
              <b>save your work immediately to avoid data loss</b>.
            </p>

		`,
		confirmButtonText: 'Confirm',
		confirmButtonColor: '#C2D63F',
		customClass: {
		  confirmButton: 'swal2-confirm-black-text'
		},
		allowOutsideClick: false,
		footer: `
		  <div style="border-top:none; margin-top:20px; font-size:12px; color:#6c757d;">
			-Scriva Support (866) 517-5204 Ext. 4-<br>
			-9AM - 8PM EST-
		  </div>
		`,
		didRender: () => {
		  const footer = document.querySelector('.swal2-footer') as HTMLElement;
		  if (footer) {
			footer.style.borderTop = 'none';
		  }
		}
	  });
	}
	
	
	@HostListener('window:online', [])
		onOnline() {
			this.isOnline = true;
			console.log('✅ Internet connection restored');
			/*Swal.fire({
				icon:'info',
				html: ' <span>your interent is back</span>'
			})*/
	}
	@HostListener('window:beforeunload', ['$event'])
	unloadHandler(event: Event) {
		this.exitTemplate(this.userId);
	}
	exitTemplate(userId) {
		let	inputJson = {"PROCEDURE":"expireuserintemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.curTemp.TEMPLATE_ID,"EXPIRE_USER_ID":parseInt(this.userId)}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=="Y"){
				if (this.userId == userId){
					window.top.close();
				}
			}else{
				this.throwError(data)
			}
		});
	}
	addFPage(){
		let item={'TYPE':'FRONT','SECTION_TITLE': "Front Page", 'TEXT':'', 'pageSrc':'letter_style', 'header':null, 'footer':null,'SUB_SECTIONS':[], 'OSNAME':true};
		item['id']=Utils.uniqueIdGenerator();
		this.frontpages.push(item);
		this.listid=item['id'];
		this.selectedEditor=='F';
		this.pageIndex=this.getFrontIdIndex(item['id']);console.log(this.pageIndex)
		this.curId=item['id'];
		this.curIndex=[];
		setTimeout(() => {
			this.scroll(item['id']+'content');
		},500);
			
	}
	addFSections(){
		let item={'TYPE':'FIXED_SECTION','DISPLAY_SEQUENCE': "Y",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Section Title",'SUB_SECTIONS':[]};
		this.curIndex=[this.addon,this.addon,this.addon];
		this.selectedEditor='O';
		this.addToContent(item, 'root');			
	}
	addPara(){
		let item={'TYPE':'PARA','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Text Section",'SUB_SECTIONS':[], 'OSNAME':true, 'TOC':true};
		this.addToContent(item);
	}
	addTable(){
		let item={'TYPE':'TABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Customized Table",'SUB_SECTIONS':[],'OTNAME':true, 'TOC':true};
		this.addToContent(item);
	}
	addMap(){
		let item={'TYPE':'MAP','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Map",'SUB_SECTIONS':[]};
		this.addToContent(item);
	}
	summaryStatus=false;
	summaryCols=[];
	presummaryCols=[]
	summaryColsShow=false;
	summaryColsType=[];
	preSetSummary(type){
		this.summaryStatus=this.haveSummary();
		if(this.summaryStatus){
			Swal.fire({
				html:'Project Summary exist already.'
			})
			return
		}else if(this.allowPhase1PS=="Y"){
			if(type){
				this.selectedEditor='F';
				this.curIndex=[];
				this.pageIndex=[this.frontpages.length, this.addon];					
			}
			this.presummaryCols=this.reportService.summaryCols;
			this.summaryCols=JSON.parse(JSON.stringify(this.presummaryCols));
			this.summaryColsShow=true;
			this.summaryColsType=JSON.parse(JSON.stringify(this.reportService.summaryColsType));
		}else if(this.tempInfo.PCA_INDICATOR=='Y'){
			this.pcaSummaryCols=this.reportService.pcaSummaryCols;
			this.addSummary();
		}
	}
	addSummary(){
		if(this.tempInfo.PCA_INDICATOR=='Y'){
			let item={'id':'PCA_project_summary', 'TYPE':'PCASUMMARY','DISPLAY_SEQUENCE': "Y",'SECTION_SEQUENCE': "",'SECTION_TITLE': "PROJECT SUMMARY",'SUB_SECTIONS':[],'OTNAME':true, 'TOC':false, 'summaryData':0, "NEW":true};
			let src=this.reportService.summaryTable;   
			for(let table of src){
				let item1={'id':table.id,'OHEADER':!table.header, 'DISPLAY_SEQUENCE':table.displayseq,'SECTION_TITLE':table.title, 'SUB_SECTIONS':[], 'data':null };
				let data={'cols':[],'rows':[]};
				data.cols=JSON.parse(JSON.stringify(table.cols));
				if(table.id=='pca_summary_1'){
					if(this.pcaOp.term=='Exclude'){
						data.cols[6]['hide']=true;						
					}else{
						data.cols[6]['hide']=false;						
					} 
				}
				if(table.rows){
					/*if(table.id=='pca_summary_1'){
						if(this.pcaOp.term=='Exclude'){
							
							table.rows[0][6]['hide']=true;
						}else{
							
							table.rows[0][6]['hide']=false;
						} 
					}*/
					if(table.id=='pca_summary_2'){
						if(this.pcaOp.term=='Exclude'){
							table.rows[1][0]['rowhide']=true;
						}else{
							table.rows[1][0]['rowhide']=false;
						} 
					}
					if(table.rows[0][0]['pcaPara']){
						table.rows[0][0].data='Replacement Reserves';
						table.rows[1][0].data='Replacement Reserves, w/'+this.pcaOp.reserve+' year, '+parseFloat(this.pcaOp.inflation).toString()+'% escalation';
					}
					data.rows=table.rows;        
				}
				if(table.totalrow){
					if(this.pcaOp.term=='Exclude'){
						table.totalrow[2]['hide']=true;
					}else{
						table.totalrow[2]['hide']=false;
					} 
					data.rows.push(table.totalrow);
				}
				item1.data=data;
				item1['tableClass']='PCA';
				item.SUB_SECTIONS.push(item1);
				}
				console.log(item)
				this.addToContent(item);
		}else if(this.allowPhase1PS=="Y"){
			let cols=[];
			let row=[];
			let basecol=this.reportService.phaseIsummaryTable[0].basecol;
			let basecell=this.reportService.phaseIsummaryTable[0].basecell;
			for(let i=0; i<this.summaryCols.length; i++){
				if(i>0){
					let col=JSON.parse(JSON.stringify(basecol));
					col.INTERNALNAME='col'+i;
					col.NAME=this.summaryCols[i];
					if(this.summaryColsType[i]=='text'){
						col['width']=20;
					}
					col['inputType']=this.summaryColsType[i]
					cols.push(col)
				}else{
					cols.push(this.reportService.phaseIsummaryTable[0].cols[i]);
				}
				let cell=JSON.parse(JSON.stringify(basecell));
				cell['COLUMNINTERNALNAME']='col'+i
				row.push(cell);
			}
			//console.log(cols)
			//console.log(row)
			let item={'id':'phaseI_project_summary', 'TYPE':'PISUMMARY','DISPLAY_SEQUENCE': "Y",'SECTION_SEQUENCE': "",'SECTION_TITLE': "PROJECT SUMMARY",'SUB_SECTIONS':[],'OTNAME':true, 'TOC':false, "NEW":true};
			//if(this.tempInfo.PCA_INDICATOR=='Y'){
			//	item['tableClass']=='PCA'
			//}else if(this.tempInfo.TEMPLATE_TYPE.length>0&&this.tempInfo.TEMPLATE_TYPE[0].SUBCATEGORY_NAME=="Phase I"){
				item['tableClass']=='PHASE1';
				let table1={'id':'phaseI_project_summary_table', 'TYPE':'PITABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "",'SUB_SECTIONS':[],'OTNAME':true, 'TOC':true, 'summaryCols':[]};
				let dataset={'cols':cols,'rows':[row]};//console.log(dataset)
				//table1.summaryCols=
				//this.summaryCols=this.reportService.summaryCols;
				table1['data']=dataset;//console.log(table1)
				item.SUB_SECTIONS.push(table1);
			//}
			
			this.addToContent(item);			
		}
		
	}
	addPhotos(){
		let item={'TYPE':'PHOTOS','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Photo",'SUB_SECTIONS':[], 'photos':[]};
		this.addToContent(item);
	}
	addSeals(){
		let item={'TYPE':'SEALS','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Seals",'SUB_SECTIONS':[], "seals":[],"OSNAME":true,'READ_ONLY':'Y'};
		this.addToContent(item);
	}
	addSigns(){
		let item={'TYPE':'SIGNS','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Signatures",'SUB_SECTIONS':[], "signs":[],"OSNAME":true,'READ_ONLY':'Y'};
		this.addToContent(item);
	}
	addImage(){
		let item={'TYPE':'IMAGE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Image",'SUB_SECTIONS':[]};
		this.addToContent(item);
	}
	addPdfSec(){
		let item={'TYPE':'PDFSEC','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "PDF Section",'SUB_SECTIONS':[], "pageSrc":'pdf',"OSNAME":true };
		this.addToContent(item);		
	}
	/*addLContent(){
		let item={'TYPE':'LOCKED_CONTENT','DISPLAY_SEQUENCE': "N", 'SECTION_SEQUENCE': "",'SECTION_TITLE': "Locked Content",'SUB_SECTIONS':[]};
		this.addToContent(item);
	}*/
	addToContent(item, type?){console.log(item)
		if(this.selectedEditor=='F'){
				if(item.TYPE=='PISUMMARY'){
				item['pageSrc']='letter_style';
				item['header']=null;
				item['footer']=null;
				item['OSNAME']=false;
				item['TEXT']='';
				if(this.pageIndex[0]>-1){
					this.frontpages.splice(this.pageIndex[0]+1, 0, item)
				}else{
					this.frontpages.push(item)
				}
				this.generateSeq();
				this.summaryStatus=true;
				this.pageIndex=this.getFrontIdIndex(item['id']);
				this.curIndex=[];
				this.listid=item['id'];
				this.curId=item['id'];
				this.summaryType='PHASE I';
				//this.toTatalPISummary();
				return
			}			
			item['id']=Utils.uniqueIdGenerator();
			item['TOC']=true;
			//item['OSNAME']=false;
			this.allEditor.push(item['id'])
			if(this.pageIndex[1]>-1){
				this.frontpages[this.pageIndex[0]].SUB_SECTIONS.splice(this.pageIndex[1]+1,0, item);
			}else{
				if(!this.frontpages[this.pageIndex[0]].SUB_SECTIONS){
					this.frontpages[this.pageIndex[0]]['SUB_SECTIONS']=[];
				}
				this.frontpages[this.pageIndex[0]].SUB_SECTIONS.push(item);
			}
			this.pageIndex=this.getFrontIdIndex(item['id']);
			this.curIndex=[];
			this.listid=item['id'];
			this.curId=item['id'];
			setTimeout(() => {
			this.scroll(item['id']+'content');
		},500);
			
		}else if(this.selectedEditor=='O'){
		if(item.TYPE=='PCASUMMARY'){
			if(this.curIndex[0]>-1){
				this.contents.splice(this.curIndex[0]+1, 0, item)
			}else{
				this.contents.push(item)
			}
			console.log(this.contents)			
			this.generateSeq();
			this.summaryStatus=true;
			this.curIndex=this.getIdIndex(item['id']);
			this.pageIndex=[];
			this.listid=item['id'];
			this.curId=item['id'];
			this.summaryType='PCA';
			setTimeout(() => {
				this.scroll(item['id']+'content');
			},500);
			if(this.summaryStatus){console.log('add summary')
				//this.getTotalSummary();	
			this.changeOpItem();
			}
			
			return
		}else if(item.TYPE=='PISUMMARY'){
			if(this.curIndex[0]>-1){
				this.contents.splice(this.curIndex[0]+1, 0, item)
			}else{
				this.contents.push(item)
			}
			this.generateSeq();
			this.summaryStatus=true;
			this.curIndex=this.getIdIndex(item['id']);
			this.pageIndex=[];
			this.listid=item['id'];
			this.curId=item['id'];
			this.summaryType='PHASE I';
			return
		}
		if(this.curIndex[0]>-1||type=='root'){
		item['id']=Utils.uniqueIdGenerator();
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(index3>-1){
			this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS.splice(index3+1,0, item);
		}else if(index2>-1&&!index3){
			if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS&&this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS.length>0){
				this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS.splice(0,0,item);
				
			}else{
				this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS=[item];
				
			}
			
		}else if(index1>-1&&!index2&&!index3){
		
			
			if(this.contents[index1].SUB_SECTIONS&&this.contents[index1].SUB_SECTIONS.length>0){
				this.contents[index1].SUB_SECTIONS.splice(0,0,item);
				
			}else{
				this.contents[index1].SUB_SECTIONS=[item];
				
			}
		}else{
			this.curIndex=[this.contents.length,this.addon,this.addon];			
			this.contents.push(item);
			
		}
		this.generateSeq();
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}
		}	
		this.curIndex=this.getIdIndex(item['id']);
		this.pageIndex=[];
		this.listid=item['id'];
		this.curId=item['id'];
		setTimeout(() => {
			this.scroll(item['id']+'content');
		},500);
		}else{
			Swal.fire({
					icon:'info',
					text: 'Please select a position for your section.',
			})					
			return
		}
		}else{
			if(item.TYPE=='PISUMMARY'||item.TYPE=='PCASUMMARY'){
				Swal.fire({
					icon:'info',
					text: 'Please select a position for your section.',
			})					
			return
			}
		}
	}
	async startNew(){
		if(this.groupShow){
			this.groupShow=false;
		}
		let inputJson={"PROCEDURE":"checkuserpermission","USER_ID":parseInt(this.userId),"FUNCTION_ID":37}; 
		let data=await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			if(data.RESPONSE_STATUS=='Y'){
				if(data.USER_PERMISSION=='Y'){;
					this.resetTempForm();	
					if(this.companyGroupIndicator){
						await this.getUserGroups();	
						this.groupList=[];
						this.groupAll=true;
						this.groupNone=false;
						if(this.groups.length>0){
							for(let group of this.groups){
								this.groupList.push(group.GROUP_ID);
							}
						}
						
					}				
					let inputJson1={"PROCEDURE":"gettemplatetypecategory", "USER_ID":parseInt(this.userId)};
					this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(result => {
						this.categories=result.RW_CATEGORY_LIST;	
						$("#tempModal").modal('show');						
					})
				}else{
					this.throwError(data)
				}				
			}else{				
				this.throwError(data)
			}
				
	}
	getTemplateTypeCategory(){
		let inputJson={"PROCEDURE":"gettemplatetypecategory", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.templateFilterOptions2=data.RW_CATEGORY_LIST;
			  }			
		})

	}
	newTemplate(){
		let name=this.tempName.trim();
		let tid=this.selectedIden;
		if(tid.length>0&&name.length>0&&(!this.companyGroupIndicator||this.groupList.length>0)){
			let inputJson={"PROCEDURE":"inserttemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_TITLE":name, "TEMPLATE_DATA":"", "TEMPLATE_TYPE_ID":parseInt(tid)};
			if(this.companyGroupIndicator&&this.groupList.length>0){
				if(this.groupAll){
					inputJson['GROUP_ID_LIST']='All';
				}else if(this.groupList.length>0){
					inputJson['GROUP_ID_LIST']=this.groupList.join(",");
				}				
			}				
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {console.log(data)
				if(data.RESPONSE_STATUS=='Y'){
					this.tempInfo=data;
					this.current=data.TEMPLATE_ID;
					this.getAllowPhase1PS(data.TEMPLATE_ID);
					this.pcaOp={'term':'Include','multiplier':"", 'reserve':12, 'decimal':0,'currency':'USD','inflation':'2.5','round':'Round'};
					if(data.PRINT_BLACKWHITE&&data.PRINT_BLACKWHITE=='Y'){
						this.blackText=true;
					}else{
						this.blackText=false;
					}
					if(data.BODYINDENT_SAME_STITLE&&data.BODYINDENT_SAME_STITLE=='Y'){
						this.contentIndent=true;
					}else{
						this.contentIndent=false;
					}
					if(this.tempInfo.SIGNATURE_STYLE&&this.tempInfo.SIGNATURE_STYLE.SIGNATURE_STYLE_ID>-1){
						this.defaultSign=this.tempInfo.SIGNATURE_STYLE;
						this.getSignContent(this.defaultSign['SIGNATURE_STYLE_ID']);
					}
					this.titleService.setTitle("Template"+' - '+data.TEMPLATE_TITLE);
					this.location.go('/template/'+data.TEMPLATE_ID.toString());
					let tempJson={"PROCEDURE":"getslotsbytemplatecategory", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":data.TEMPLATE_ID};						
					this.reportService.univeralService(JSON.stringify(tempJson)).subscribe(response => {						
						this.groupSlots=response.RW_SLOT_CATEGORIES;
						this.curTemp=response;
					});
					this.allEditor=[];
					this.contents=[];
					this.frontpages=[];
					this.resetTempForm();
					this.getAllCover();
					//this.getProfile(this.current);
					this.getCompanyProfiles(this.current);
					this.getSignStyles(this.current);
					this.getSignInfo(this.current);
					$("#tempModal").modal('hide');
					this.pageMargin.top=data.REPORT_MARGIN_TOP;
					this.pageMargin.bottom=data.REPORT_MARGIN_BOTTOM;
					this.pageMargin.left=data.REPORT_MARGIN_LEFT;
					this.pageMargin.right=data.REPORT_MARGIN_RIGHT;	
					this.tocMargin.top=data.TOC_MARGIN_TOP;
					this.tocMargin.bottom=data.TOC_MARGIN_BOTTOM;
					this.tocMargin.left=data.TOC_MARGIN_LEFT;
					this.tocMargin.right=data.TOC_MARGIN_RIGHT;
					this.summaryStatus=false;
					if(data.PCA_PAGE_SETUP){
						this.lpagesize=data.PCA_PAGE_SETUP;
					}
					if(data.PCA_TABLE_STYLE&&data.PCA_TABLE_STYLE.length>0){
						this.pcaType=data.PCA_TABLE_STYLE;
					}
					if(data.TOC_HEADER&&data.TOC_HEADER.length>0){
						this.selectedTHeader=data.TOC_HEADER[0].TOC_HEADER_ID;
					}
					if(data.TOC_FOOTER&&data.TOC_FOOTER.length>0){
						this.selectedTFooter=data.TOC_FOOTER[0].TOC_FOOTER_ID;
					}
					if(data.FRM_HEADER&&data.FRM_HEADER.length>0){
						this.selectedFrmHeader=data.FRM_HEADER[0].FRM_HEADER_ID;				
					}
					if(data.FRM_FOOTER&&data.FRM_FOOTER.length>0){
						this.selectedFrmFooter=data.FRM_FOOTER[0].FRM_FOOTER_ID;				
					}
					if(data.COMP_PROFILE_ID&&data.COMP_PROFILE_ID>-1){
						this.selectedProfile=data.COMP_PROFILE_ID;
					}
					if(data.SUMMARY_CATEGORY&&data.SUMMARY_CATEGORY.length>0){
						this.summaryCategory=data.SUMMARY_CATEGORY.split(',');
					}
					if(data.PCA_INDICATOR&&data.PCA_INDICATOR=='4099e'){
						this.iniFme();
						this.pcaOp.inflation='3';
						this.pcaOp.decimal=2;
						this.capitalCategory=this.fmeService.capitalCategory;
						this.ratingOps=this.fmeService.ratingOps;
						this.actionItemOps=this.fmeService.actionItemOps;
						this.ulGroup=this.getGroup();
					}
					if(data.PCA_INDICATOR&&data.PCA_INDICATOR=='frm1105'){
						this.pcaOp.inflation='3';
						this.capitalCategory=this.frmService.capitalCategory;
						this.conditionOps=this.frmService.conditionOps;
						this.actionItemOps=this.frmService.actionItemOps;
						this.iniFrm1105();
					}
					if(data.PCA_INDICATOR&&data.PCA_INDICATOR=='frm1104'){
						this.contents=JSON.parse(JSON.stringify(this.frmService.frm1104content));console.log(this.contents)
						this.toFlat();
					}
					if(data.PHASE1_TYPE&&data.PHASE1_TYPE=='1103'){
						this.contents=JSON.parse(JSON.stringify(this.frmService.frm1103content));console.log(this.contents)
						this.toFlat();
					}
					if(data.APPENDIX_NODATA_MESSAGE){
						this.printnodataforAppendix==data.APPENDIX_NODATA_MESSAGE;
					}
				}else{
					this.throwError(data)
				}
						
			})
		
		}else{
			
		}		
	}
	resetTempForm(){
		this.tempName=""
		this.selectedCover=""
		this.selectedHeader="";
		this.selectedFooter="";
		this.selectedIden="";
		this.selectedPHeader="";
		this.selectedPFooter="";
		this.selectedTHeader="";
		this.selectedTFooter="";
		this.selectedFrmFooter='';
		this.selectedFrmHeader='';
		this.tempContents=[];
		this.chosenSec=[];
		this.addedSec=[];		
	}
	onClose(){
		
	}
	selectSec(i){
		let index=this.chosenSec.indexOf(i);
		if(index>-1){
			this.chosenSec.splice(index, 1);
		}else{
			this.chosenSec.push(i);
		}		
		
	}
	selectTemp(index){
		this.tempIndex=index;
	}
	toggleChild(e){
		e.stopPropagation();
		let child=$(e.target).parents('a').next('div');
		child.toggle();
		if(child.css('display')=='flex'){
			$(e.target).removeClass('fas fa-angle-down');
			$(e.target).addClass('fas fa-angle-right');
		}else{
			$(e.target).removeClass('fas fa-angle-right');
			$(e.target).addClass('fas fa-angle-down');
		}
	}
	
	removeCount(item){
		let index=this.addedSec.indexOf(item);
		if(index>-1){
		 this.addedSec.splice(index,1);
		}
	}
	removeSec(type, data, index1?, index2?, index3?){
		let that=this;
		if(this.tempInfo.PCA_INDICATOR=='frm1105'){
			let ifLinked=false;
			if(data.TYPE=='COSTTABLE'){
				ifLinked=this.checkFrmItem(data.id);				
			}
			if(!ifLinked&&data.SUB_SECTIONS&&data.SUB_SECTIONS.length>0){
				for(let sec of data.SUB_SECTIONS){
					if(!ifLinked&&sec.TYPE=='COSTTABLE'){
						ifLinked=this.checkFrmItem(sec.id);						
					}
					if(!ifLinked&&sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
						for(let sec1 of sec.SUB_SECTIONS){
							if(!ifLinked&&sec1.TYPE=='COSTTABLE'){
								ifLinked=this.checkFrmItem(sec1.id);								
							}
						}						
					}
				}				
			}			
			if(ifLinked){
				Swal.fire({
					icon:'info',
					title: 'This section or child section is referenced by Freddie Mac Section, Please remove the reference first.',
				})
				return
			}
			
		}
		let msg='Are you sure you want to delete this item?'
		if(data.TYPE=='PISUMMARY'||data.TYPE=='PCASUMMARY'){
			msg='Delete Project Summary Section will remove all related data, Are you sure you want to delete this section?'
		}
		Swal.fire({
			icon:'warning',
			title: msg,
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {			
		let datas:any
		if(type=='app'){
			that.appendices.SUB_SECTIONS.splice(index1,1);
			if(data['resume']){
				that.appendices['addedResume'] = false;
			}
			return
		}else if(type=='front'){
			if(index2>-1){
				this.frontpages[index1].SUB_SECTIONS.splice(index2,1);
			}else{
				this.frontpages.splice(index1,1);
			}
			this.checkifSign();	
			
			return
		}else if(type=='temp'){
			datas=that.tempContents
		}else if(type=='content'){
			datas=that.contents;
		}
		if(index3>-1){
			datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS.splice(index3,1);
		}else if(index2>-1){
			datas[index1].SUB_SECTIONS.splice(index2,1);
		}else{
			datas.splice(index1,1);			
		}
		if(data.TYPE=='PISUMMARY'){
			for(let doc of this.contents){
				if(doc.pisummarydata){
					delete doc.pisummarydata;
				}
				if(doc.SUB_SECTIONS&&doc.SUB_SECTIONS.length>0){
					for(let doc1 of doc.SUB_SECTIONS){
						if(doc1.pisummarydata){
							delete doc1.pisummarydata;
						}

						if(doc1.SUB_SECTIONS&&doc1.SUB_SECTIONS.length>0){
							for(let doc2 of doc1.SUB_SECTIONS){
								if(doc2.pisummarydata){
									delete doc2.pisummarydata;
								}
							}
						}
					}
				}
			}
			this.summaryStatus=false;
		}
		if(data.TYPE=='PCASUMMARY'){
			for(let doc of this.contents){
				if(doc.pcasummarydata){
					delete doc.pcasummarydata;
				}
				if(doc.SUB_SECTIONS&&doc.SUB_SECTIONS.length>0){
					for(let doc1 of doc.SUB_SECTIONS){
						if(doc1.pcasummarydata){
							delete doc1.pcasummarydata;
						}
						if(doc1.TYPE=='COSTTABLE'){
							if(doc1['summaryCat']){
								delete doc1['summaryCat'];
							}
							
						}
						if(doc1.SUB_SECTIONS&&doc1.SUB_SECTIONS.length>0){
							for(let doc2 of doc1.SUB_SECTIONS){
								if(doc2.pcasummarydata){
									delete doc2.pcasummarydata;
								}
								if(doc2.TYPE=='COSTTABLE'){
									if(doc2['summaryCat']){
										delete doc2['summaryCat'];
									}
									
								}
							}
						}
					}
				}
			}
			this.summaryStatus=false;
		}		
		that.generateSeq();
		this.summaryStatus=this.haveSummary();
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}	
		}
		if(this.tempInfo.PCA_INDICATOR&&this.tempInfo.PCA_INDICATOR=='frm1105'){
			this.getAllCostTable()
		}
		this.checkifSign();			
		}	
		})	
	}
	addChild(e,type, data, index1?, index2?){
		e.stopPropagation();
		let datas:any
		if(type=='app'){
			if(data.SECTION_TITLE){
				this.appendices.SUB_SECTIONS.push(data);
			}else{
				let item={'SECTION_TITLE': 'Appendix'};
				this.appendices.SUB_SECTIONS.push(item);
			}			
			return
		}else if(type=='temp'){
			datas=this.tempContents
		}else{
			datas=this.contents
		}
		if(index2>-1){
			this.curIndex=[index1,index2,datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS.length];
			let item={'SECTION_SEQUENCE': null,'SECTION_TITLE': 'TITLE','DISPLAY_SEQUENCE':'Y'};
			if(type=='content'){
				item['id']=Utils.uniqueIdGenerator();
			}
			this.listid=item['id'];
			this.curId=item['id'];
			datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS.push(item);
			setTimeout(() => {
			this.scroll(item['id']+'content');
		},500);
			
		}else{
			this.curIndex=[index1,datas[index1].SUB_SECTIONS.length,this.addon];
			let item={'SECTION_SEQUENCE': null,'SECTION_TITLE': 'TITLE','SUB_SECTIONS':[],'DISPLAY_SEQUENCE':'Y'};
			if(type=='content'){
				item['id']=Utils.uniqueIdGenerator();
			}
				this.listid=item['id'];
				this.curId=item['id'];
			datas[index1].SUB_SECTIONS.push(item);
			setTimeout(() => {
				this.scroll(item['id']+'content');
			},500);
			}
		let child=$(e.target).parent('a').next('div');	
		if(child.css('display')=='none'){			
			$(e.target).prev().prev().removeClass('fas fa-angle-down');
			child.css('display','block');
		}
		this.generateSeq();	
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}	
		}
		if(this.tempInfo.PCA_INDICATOR&&this.tempInfo.PCA_INDICATOR=='frm1105'){
			this.getAllCostTable()
		}	
	}
	clearAdded(){
		for(let sec of this.sections){
				sec.added=false;
				this.tempContents=[];
		}
	}
	changeTitle(type, e, index1?, index2?, index3?){
		this.selectedRow=-1;
		let datas:any;
		if(type=='front'){
			if(index2>-1){
				this.frontpages[index1].SUB_SECTIONS[index2].SECTION_TITLE=e;
			}else if(index1>-1){
				this.frontpages[index1].SECTION_TITLE=e;
			}
			return
		}else if(type=='app'){
			if(index1>-1){
				this.appendices.SUB_SECTIONS[index1].SECTION_TITLE=e;
			}else{
				this.appendices.SECTION_TITLE=e;
			}
			return
		}else if(type=='temp'){
			datas=this.tempContents
		}else{
			datas=this.contents
		}
		let doc:any;
		if(index3>-1){
			doc=datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3];
			doc.SECTION_TITLE=e;
			if(doc['ul']){
				doc['ul']['Item']=doc.SECTION_TITLE;
			}
			this.checkSummary(doc);
		}else if(index2>-1){
			doc=datas[index1].SUB_SECTIONS[index2];
			doc.SECTION_TITLE=e;
			if(doc['ul']){
				doc['ul']['Item']=doc.SECTION_TITLE;
			}
			this.checkSummary(doc);
		}else if(index1>-1){
			doc=datas[index1];
			doc.SECTION_TITLE=e;
			if(doc['ul']){
				doc['ul']['Item']=doc.SECTION_TITLE;
			}
			this.checkSummary(doc);
		}
		this.curIndex=[index1, index2, index3];	
		if(this.tempInfo.PCA_INDICATOR=='4099e'){
			this.getTotalUl();	
		}
	}
	checkSummary(doc){
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'&&doc['pisummarydata']){
				if((doc.OSNAME||doc.SECTION_TITLE.length==0)&&doc.SECTION_SEQUENCE.length==0){
					delete doc.pisummarydata;
				}
				this.toTatalPISummary();																				
			}else if(this.summaryType=='PCA'&&doc['pcasummarydata']){
				if((doc.OSNAME||doc.SECTION_TITLE.length==0)&&doc.SECTION_SEQUENCE.length==0){
					delete doc.pcasummarydata;							
				}
				this.getTotalSummary();												
			}
		}
		if(this.tempInfo.PCA_INDICATOR&&this.tempInfo.PCA_INDICATOR=='frm1105'){
			this.getAllCostTable();

		}
	}
	
  drop(event: CdkDragDrop<string[]>) {
	moveItemInArray(this.contents, event.previousIndex, event.currentIndex);
  }
	dropCol(event: CdkDragDrop<string[]>) {//console.log(this.curTableData.cols);console.log(event.previousIndex);console.log(event.currentIndex)
		moveItemInArray(this.curTableData.cols, event.previousIndex+1, event.currentIndex+1);	
		for(let row of this.curTableData.rows){
			this.array_move(row,event.previousIndex+1, event.currentIndex+1 )
		}	
		
	}
	dragStart(e){
		$('#tableModal').draggable("disable");
	}
	dragEnd(e){
		$('#tableModal').draggable("enable");
	}
	noSeq=false;
	checkParentSeq(doc1, doc2?){
		this.noSeq=false;
		if(doc1=='N'){
			this.noSeq=true;
		}
		if(doc2&&doc2=='N'){
			this.noSeq=true;			
		}
		//console.log(doc1, doc2, this.noSeq)
	}
	dragStop(){
		$('#costLibModal').draggable("disable");
	}
	dragRevise(){
		$('#costLibModal').draggable("enable");
	}
	array_move(arr, old_index, new_index) {
	new_index =((new_index % arr.length) + arr.length) % arr.length;
	arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
	return arr; // for testing
	}

  dropItem(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
	this.generateSeq();
	if(this.summaryStatus){
		if(this.summaryType=='PHASE I'){
			this.toTatalPISummary();
		}else if(this.summaryType=='PCA'){
			this.getTotalSummary();
		}
	}
	if(this.tempInfo.PCA_INDICATOR&&this.tempInfo.PCA_INDICATOR=='frm1105'){
		this.getAllCostTable()
	}
	this.curIndex=[this.addon,this.addon,this.addon];
  }
  dropFItem(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
	this.pageIndex=[];
  }
	dropLib(event: CdkDragDrop<string[]>, data) {
		moveItemInArray(data, event.previousIndex, event.currentIndex);
	}
	dropApp(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.appendices.SUB_SECTIONS, event.previousIndex, event.currentIndex);
	}
	getConnectedList(): any[] {
		return this.contents.map(x => `${x.id}`);
	}
	getFConnectedList(): any[] {
		return this.frontpages.map(x => `${x.id}`);
	}
	dropFront(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.frontpages, event.previousIndex, event.currentIndex);
		this.pageIndex=[];
	}
	dropGroups(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.contents, event.previousIndex, event.currentIndex);
		this.generateSeq();
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}
		}
		if(this.tempInfo.PCA_INDICATOR&&this.tempInfo.PCA_INDICATOR=='frm1105'){
			this.getAllCostTable()
		}
		this.curIndex=[this.addon,this.addon,this.addon];
	}
	dropGroup(event: CdkDragDrop<string[]>, index) {
		moveItemInArray(this.contents[index].SUB_SECTIONS, event.previousIndex, event.currentIndex);
		this.generateSeq();
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}
		}
		if(this.tempInfo.PCA_INDICATOR&&this.tempInfo.PCA_INDICATOR=='frm1105'){
			this.getAllCostTable()
		}
		this.curIndex=[this.addon,this.addon,this.addon];
	}
	listid:string;
	getFListPosition(id, e,i?,j?){
		this.moveShow=false;
		$(e.target).focus();
		if(e && e.stopPropagation){
			e.stopPropagation();
		}
		if(this.tableShow&&id!=this.listid){
			Swal.fire({
				icon:'info',
				html:'You are switching section, Please save your editing and close table editing window to prevent data lost.'}
			);
			return
		}
		this.listid=id;
		this.selectedEditor='F';
		this.curIndex=[];
		let status=$(e.target).hasClass('active');
		if(status){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else{
			this.pageIndex=[i,j];			
			this.scroll(id+'content');			
		}	
		this.addLib=false;
		this.selectedCell=null;
	}
	getListPosition(doc, e,i?,j?,k?){
		if(this.tableShow&&doc.id!=this.listid){
			Swal.fire({
				icon:'info',
				html:'You are switching section, Please save your editing and close table editing window to prevent data lost.'}
			);
			return
		}
		/*if(doc.id=='frm_sec'){
			this.scroll(doc.id+'content');
		}else{
			this.scroll(doc.id);
		}*/
		if(doc.TYPE=='1105'&&doc.id!='frm_sec'){
			this.scroll(doc.id);				
		}else if(doc.TYPE=='frm1104'||doc.TYPE=='frm1103'){
			this.scroll(doc.id);
			this.listid=doc.id;
		}
		let id=doc.id;
		this.moveShow=false;
		$(e.target).focus();
		if(e && e.stopPropagation){
			e.stopPropagation();
		}
		this.listid=id;
		this.selectedEditor='O';
		let status=$(e.target).hasClass('active');
		if(status){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else if(doc.TYPE!="frm1104"&&doc.TYPE!="frm1103"){
			this.curIndex=[i,j,k];
			this.pageIndex=[];
			let posi=id;
			this.scroll(posi+'content');			
		}	
		this.addLib=false;
		this.selectedCell=null;
	}
	getFPosition(id, e,i?,j?){
		if(this.tableShow&&id!=this.listid){
			Swal.fire({
				icon:'info',
				html:'You are switching section, Please save your editing and close table editing window to prevent data lost.'}
			);
			return
		}
		this.moveShow=false;
		this.listid=id;
		this.selectedEditor='F';
		let posi=id;
		let that=this;
			if(j>-1){
				$('.exDiv1').each(function(){
					let id=that.frontpages[i].id+'panel';
					let list=$(this).attr("data-id")
					if(list==id){
						$(this).css('display','block');
					}else{
						$(this).css('display','none');
					}
				})
			}else if(i>-1){
				j=this.addon;				
			}
			this.selectedCell=null;
			this.scrollPanel(posi+'list');
			this.pageIndex=[i,j];
			this.curIndex=[];
	}
	getPosition(id, e,i?,j?,k?){
		if(this.tableShow&&id!=this.listid){
			Swal.fire({
				icon:'info',
				html:'You are switching section, Please save your editing and close table editing window to prevent data lost.'}
			);
			return
		}
		this.moveShow=false;
		if(this.cellShow){
			return
		}
		this.listid=id;
		this.selectedEditor='O';
		let status=$(e.target).hasClass('active');
		if(status){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else{
			this.curIndex=[i,j,k];
			this.pageIndex=[];
			let posi=id;
			let that=this;
			if(k>-1){
				$('#expandIcon').removeClass('fa-angle-double-down');
				$('#expandIcon').addClass('fa-angle-double-up');
				
				$('.exDiv1').each(function(){
					let id=that.contents[i].id+'panel';
					let list=$(this).attr("data-id")
					if(list==id){
						$(this).css('display','block');
					}else{
						$(this).css('display','none');
					}
				})
				$('.exDiv2').each(function(){
					let id=that.contents[i].SUB_SECTIONS[j].id+'panel';
					let list=$(this).attr("data-id")
					if(list==id){
						$(this).css('display','block');
					}else{
						$(this).css('display','none');
					}
				})
			}else if(j>-1){
				$('#expandIcon').removeClass('fa-angle-double-down');
				$('#expandIcon').addClass('fa-angle-double-up');
				$('.exDiv1').each(function(){
					let id=that.contents[i].id+'panel';
					let list=$(this).attr("data-id")
					if(list==id){
						$(this).css('display','block');
					}else{
						$(this).css('display','none');
					}
				})
			}else if(i>-1){
				//posi=id;//(i+1).toString();
			}
			this.scrollPanel(posi+'list')
			this.addLib=false;
			this.selectedCell=null;
			if(this.curId!=id){
				this.selectedRow=-1;
				this.curId=id; 
				let type=this.getContentData('TYPE'); 
				if(type=='TABLE'){
					let data=this.getContentData('data');
					if(data&&(!data.erisName)){
						for(let row of data.rows){
							if(row.items&&row.items.length>0){
								row.selected=false;
							}
						}
						this.selectedRow=-1;
					}
				}
		}
		}
	
	}
	scroll(id) {console.log(id)
		
		let el = document.getElementById(id);
		el.scrollIntoView({block: "center", inline: "nearest"});
	}
	scrollPanel(id) {
		
		let el = document.getElementById(id);
		el.scrollIntoView({block: "center", inline: "nearest"});
	}
	scrollTo(id, index){console.log(index); 
		this.curIndex=this.getIdIndex(id);
		
		/*if(index[2]&&index[2]>-1){				
		}else if(index[1]&&index[1]>-1){
			this.curIndex[2]=this.addon;
			
		}else if(index[0]>-1){
			this.curIndex[1]=this.addon;
			this.curIndex[2]=this.addon;
			
		}
		
	this.curIndex=index;console.log(this.curIndex);*/
	let posi=id;
	//console.log(posi);
	this.scroll(posi+'content');
}
	selCate(e){
		let category=$(e.target).val();
		let inputJson={"PROCEDURE":"gettemplatetypesubcategory", "USER_ID":parseInt(this.userId), "CATEGORY":category};
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.temps=data.RW_SUBCATEGORY_LIST;	
			  }		
		})
	}
	selTemp(e){
		let id=parseInt($(e.target).val()); 
		let inputJson={"PROCEDURE":"gettemplatetypecontents", "USER_ID":parseInt(this.userId), "TEMPLATE_TYPE_ID":id};
		
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			let info=JSON.parse(data).TEMPLATE_CONTENTS;
			
			if(info.length>0){
				this.sections=JSON.parse(info).TEMPLATE_SECTIONS;
			}else{
				this.sections=[];
			}
		}
		})
		let inputJson1={"PROCEDURE":"gettemplatetypeappendix","USER_ID":parseInt(this.userId),"TEMPLATE_TYPE_ID":id};
		this.reportService.univeralService1(JSON.stringify(inputJson1)).subscribe(response => {
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
			  }else{
			let info=JSON.parse(response).TEMPLATE_APPENDIX;
			this.appendices={'SECTION_SEQUENCE': "",'SECTION_TITLE': 'APPENDICES','SUB_SECTIONS':[]};
			if(info.length>0){
				this.tempAppendices=JSON.parse(info).TEMPLATE_APPENDIX[0];
			}else{
				this.tempAppendices={'SECTION_SEQUENCE': "",'SECTION_TITLE': 'APPENDICES','SUB_SECTIONS':[]};;
			}
		}
		})
	}
	addEditor(doc){
		if(this.allEditor.indexOf(doc.id)==-1){
			this.selectedCell=null;
			if(!doc.text||doc.text.length==0){
				this.toContentData('text','','');
			}
			this.allEditor.push(doc.id);	
			
		}
	}
	expandToggle(e){
		let level=$(e.target).prevAll('select').val();
		if(!$(e.target).hasClass('active')){
			if(level=='1'){
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
			}else if(level==2){
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
				$('.exDiv2').each(function(){
					$(this).css('display','block');
				})
			}
			$(e.target).addClass('active');
			$(e.target).text('Collapse');
		}else{
			if(level=='1'){
				$('.exDiv1').each(function(){
					$(this).css('display','none');
				})
			}else if(level==2){
				$('.exDiv1').each(function(){
					$(this).css('display','none');
				})
				$('.exDiv2').each(function(){
					$(this).css('display','none');
				})
			}
			$(e.target).removeClass('active');
			$(e.target).text('Expand');
		}
		
	}
	missingSlot;
	missingSlotMessage=''
	createSlot(e, ele?){
		if(!(this.newSlotType.length==0||this.newSlotLabel.trim()=== ''||this.newSlotCat.length==0||(this.newSlotType=='Selection'&&this.newSlotOps.length==0)||(this.newSlotType=='File'&&this.newSlotFile.url.length==0))){	let id=null;
			let slotContent='';
			let opContent='';
			let ext="";
			let name='';
			if(this.curTemp){
				id=this.curTemp.TEMPLATE_ID;
			}
			if(this.newSlotType=='Selection'){
				opContent=this.newSlotOps.join(';;');
			}else if(this.newSlotType=='File'){
				if(this.newSlotFile.url.length>0){
					slotContent=this.newSlotFile.url;
					ext=this.newSlotFile.ext;
					name=this.newSlotFile.name;
				}				
			}else{
				slotContent=this.newSlotContent;
			}
			let inputJson:any;
			if(this.newSlotType=='File'){
				inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"TEMPLATE_ID":id.toString(),"SELECTION_CHOICES":opContent, "FILE_EXTENSION":ext, 'FILE_NAME':name};
			}else{
				inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"TEMPLATE_ID":id.toString(),"SELECTION_CHOICES":opContent};
			}
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(data => {
				let info=JSON.parse(data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
				  }else{
			let index=this.groupSlots.findIndex(slot=>slot.CATEGORY==info.CATEGORY);
			if(index>-1){
				this.groupSlots[index].RW_SLOTS.push(info);
				this.groupSlots[index].TOTAL_SLOTS+=1;
				this.groupSlots[index].TOTAL_TEMPLATE_SLOTS+=1;
			}else{
				this.groupSlots.push({'CATEGORY':info.CATEGORY,'RW_SLOTS':[info],'TOTAL_SLOTS': 1,'TOTAL_TEMPLATE_SLOTS': 1});				
			}
			this.slots.push(info);
			if(this.curTemp){
				this.curTemp.TOTAL_SLOTS+=1;
			}
			let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
			Toast.fire({
					icon: 'success',
					title: 'saved'
				})
				if(ele){
					ele.hide()
				}
			this.resetNewSlot();
				  }
		})
		}else{
			this.missingSlot=true
			this.missingSlotMessage = "* "
			if(this.newSlotLabel==null||this.newSlotLabel.trim()=== ''){
				this.missingSlotMessage = this.missingSlotMessage + "Identifier"
			}
			if(this.newSlotCat.length==0){
				if(this.newSlotLabel==null||this.newSlotLabel.trim()=== ''){
					this.missingSlotMessage = this.missingSlotMessage + ", Category"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Category"
				}
			}
			if(this.newSlotType==''){
				if(this.newSlotLabel==null||this.newSlotCat.length==0||this.newSlotLabel.trim()=== ''){
					this.missingSlotMessage = this.missingSlotMessage + ", Type"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Type"

				}
			}
			if(this.newSlotType=='Selection'&&this.newSlotOps.length==0){
				if(this.newSlotLabel==null||this.newSlotCat.length==0||this.newSlotLabel.trim()=== ''){
					this.missingSlotMessage = this.missingSlotMessage + ", Selection"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Selection"

				}
			}
			if(this.newSlotType=='File'&&this.newSlotFile.url.length==0){
				if(this.newSlotLabel==null||this.newSlotCat.length==0||this.newSlotLabel.trim()=== ''){
					this.missingSlotMessage = this.missingSlotMessage + ", File"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "File"

				}
			}
			this.missingSlotMessage = this.missingSlotMessage + " not valid"
		}
	}
	selectSlot(slot){
		console.log(slot);
		this.selectedSlot=slot;
	}
	addSlotPosi(i?,j?,k?){
		this.selectedSlot=[];
		if(k>-1){
			this.curIndex=[i,j,k];			
		}else if(j>-1){
			this.curIndex=[i,j,this.addon];			
		}else if(i>-1){
			this.curIndex=[i,this.addon,this.addon];			
		}
		
	}
	addSlot(){console.log(this.selectedSlot)
		this.toContentData('slots', this.selectedSlot, 'addSlotModal');
		//$('#addSlotModal').modal('hide');
		this.selectedSlot=[];		
	}
	addSlotPrep(type?){
		this.slotToLib=true;
		this.filteredData=null;
		this.selectedSlot=[];
		this.curLib=[];
		this.curLibId=[];
		if(type&&type=='new'){
			this.newLib=true;
			this.addLib=false;
		}else{
			this.newLib=false;
		}
	}
	addSlotToLib(){console.log(this.selectedSlot)
		let content='';
		for(let item of this.selectedSlot){
			//let itemHtml='<span class="reportTag" data-id="'+item.SLOT_ID+'" data-name="'+item.KEY+'" data-original-title="This Report Tag has no value" data-value="undefined" style="background-color:#C2D63F;">'+'{{'+item.KEY+'}}'+'</span>'+'<span style="background-color:none;">'+' '+'</span> ';
			let obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text'};
			content=JSON.stringify(obj);
			
		
		this.itemIndex+=this.itemIndex;
		this.addedItem={'index':this.itemIndex,'content':content};
		}
		//this.addedItem=content; //this.selectedSlot;
		$('#addSlotModal').modal('hide');
	}
	showSlot(libs){
		let newLibs=[];
		this.selectedRow=-1;
		if(libs[0].LIBRARY_ID>-1){
			let libarray=[];
			for(let lib of libs){
				libarray.push(lib.LIBRARY_ID);
			}
			let libstring=libarray.join(',');
			let inputJson={"PROCEDURE":"getlibraryentrybyidlist","USER_ID":parseInt(this.userId),"LIBRARY_LIST":libstring};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log('liblist',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			let updatedLibs=data.RW_LIBRARY;
			this.toContentData('choice', updatedLibs, '')
			//return updatedLibs;
			  }
		})
			//this.toContentData('choice', newLibs, '')
		}
	}
	deleteSlot(id, item){console.log(item)
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
			let inputJson={"PROCEDURE":"deleteslot","USER_ID":parseInt(this.userId),"SLOT_ID":parseInt(id)};
			console.log(inputJson);
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);

				let info=JSON.parse(data);
				let msg=info.MESSAGE;
				let Toast=Swal.mixin({
						toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				if(info.RESPONSE_STATUS=='Y'){
					let index=this.groupSlots.findIndex(slot=>slot.CATEGORY==item.CATEGORY);
					if(index>-1){
						let index1=this.groupSlots[index].RW_SLOTS.findIndex(slot=>slot.SLOT_ID==id);
						if(index1>-1){
							this.groupSlots[index].RW_SLOTS.splice(index1,1);
						}
						let index2=this.groupSlots[index].RW_TEMPLATE_SLOTS.findIndex(slot=>slot.SLOT_ID==id);
						if(index2>-1){
							this.groupSlots[index].RW_TEMPLATE_SLOTS.splice(index2,1);
						}
					}				
					Toast.fire({
						icon: 'success',
						title: msg
					})
				}else{
					this.throwError(info)
				}
			})	
		}	
		})	
	}
	expandAll() {
    if(!this.isExpanded){
      this.groupSlots.forEach(data =>{
        this.expandedRows[data.CATEGORY] = true;
      })
	  this.isExpanded=true
	  console.log(this.expandedRows);
    } else {
      this.expandedRows={};
	  this.isExpanded = false;
    }
    //this.isExpanded = !this.isExpanded;
  }
  slotChkToggle(data){console.log(data);
		if(data.RW_SLOTS.length>0){
			let allSlot=data.RW_SLOTS;
			for(let item of allSlot){
				this.addToTemp(item,data.CATEGORY);
			}
		}else{
			let allSlot=data.RW_TEMPLATE_SLOTS;
			for(let item of allSlot){
				this.removeFromTemp(item,data.CATEGORY);
			}
		}
		this.slotCheckAll=!this.slotCheckAll; 
  }
  nameValidate(event){
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
        event.preventDefault();
        return false;
    }
  }
	addSlotToTemp(e,r,cat){console.log(r)
		if(e.target.checked){
			this.addToTemp(r,cat);
		}else{
			this.removeFromTemp(r,cat);
			
		}
	}
	addToTemp(r,cat){
		let inputJson={"PROCEDURE":"addslottotemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.curTemp.TEMPLATE_ID,'SLOT_ID':r.SLOT_ID};
			//console.log(inputJson);
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {//console.log(response)
				let data=JSON.parse(response);
				let msg=data.MESSAGE;
				let Toast=Swal.mixin({
						toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				if(data.RESPONSE_STATUS=='Y'){
					let index=this.groupSlots.findIndex(slot=>slot.CATEGORY==data.CATEGORY);
					if(index>-1){
						this.curTemp.TOTAL_TEMPLATE_SLOTS+=1;
						let index1=this.groupSlots[index].RW_SLOTS.findIndex(slot=>slot.SLOT_ID==data.SLOT_ID);
						this.groupSlots[index].TOTAL_TEMPLATE_SLOTS+=1;
						if(index1>-1){
							this.groupSlots[index].RW_SLOTS.splice(index1,1);
						}
						let index2=this.groupSlots[index].RW_TEMPLATE_SLOTS.findIndex(slot=>slot.SLOT_ID==data.SLOT_ID);
						if(index2==-1){
							r.TEMPLATE_IND='Y';
							/*let item={'CATEGORY': data.CATEGORY,
								'CONTENT': data.CONTENT,
								'KEY': data.KEY,
								'SLOT_ID': data.SLOT_ID,
								'SYSTEM_IND': data.SYSTEM_IND,
								'TEMPLATE_IND': data.TEMPLATE_IND,
								'TYPE': data.TYPE,
							}*/
							this.groupSlots[index].RW_TEMPLATE_SLOTS.push(r);
						}
					}				
					/*Toast.fire({
						icon: 'success',
						title: msg
					})*/
				}else{
					this.throwError(data)
				}
				
			/*{"PROCEDURE":"addslottotemplate","USER_ID":213223,"TEMPLATE_ID":3,"SLOT_ID":8,"STATUS":"Y","MESSAGE":"Slot added to Template was successful"}*/
			})
	}
	removeFromTemp(r,cat){
		let inputJson={"PROCEDURE":"removeslotfromtemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.curTemp.TEMPLATE_ID,'SLOT_ID':r.SLOT_ID};
			console.log(inputJson);
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {console.log(response)
				let data=JSON.parse(response);
				let msg=data.MESSAGE;
				let Toast=Swal.mixin({
						toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				if(data.RESPONSE_STATUS=='Y'){
					let index=this.groupSlots.findIndex(slot=>slot.CATEGORY==cat);
					this.curTemp.TOTAL_TEMPLATE_SLOTS-=1;
					this.groupSlots[index].TOTAL_TEMPLATE_SLOTS-=1;
					if(index>-1){
						let index1=this.groupSlots[index].RW_SLOTS.findIndex(slot=>slot.SLOT_ID==r.SLOT_ID);
						if(index1==-1){
							r.TEMPLATE_IND='N';
							this.groupSlots[index].RW_SLOTS.push(r);
						}
						let index2=this.groupSlots[index].RW_TEMPLATE_SLOTS.findIndex(slot=>slot.SLOT_ID==r.SLOT_ID);
						if(index2>-1){
							this.groupSlots[index].RW_TEMPLATE_SLOTS.splice(index2,1);
						}
					}				
					/*Toast.fire({
						icon: 'success',
						title: msg
					})*/
				}else{
					this.throwError(data)
				}
			})
	}
	async selLib(item){console.log(item)
		if(!item.CONTENT_HTML){
			await this.getLibContent(item);
		}
		
		let index=this.curLib.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
		if(index>-1){
			this.curLib.splice(index,1);
			this.curLibId.splice(index,1);
		}else{
			this.curLib.push(item);
			this.curLibId.push(item.LIBRARY_ID);
		}
				
	}
	
	addSelLib(){console.log(this.addedLib);
		if(this.curLib.length>0){
			for(let item of this.curLib){
				let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
				if(index==-1){
					this.addedLib.push(item);
				}
			}
			this.curLib=[];
			this.curLibId=[];	
		}
		
	}
	async addAllSelLib(){console.log(this.addedLib);
	console.log(this.filteredData)
		if(this.libraries.length<11&&!this.filteredData){
			for(let flib of this.libraries){
				let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==flib.LIBRARY_ID);
				if(index==-1){
					await this.getLibContent(flib);
					this.addedLib.push(flib);
				}
			}
		}else if(this.filteredData&&this.filteredData.length<11){
			//this.addedLib = [...this.addedLib, ...this.filteredData]; console.log(this.addedLib);
			for(let flib of this.filteredData){
				let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==flib.LIBRARY_ID);
				if(index==-1){
					await this.getLibContent(flib);
					this.addedLib.push(flib);
				}
			}
		}
		this.curLib=[];
		this.curLibId=[];	
	}
	rmvAddedLib(){
		for(let item of this.curLib){
			let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
			if(index>-1){
				this.addedLib.splice(index,1);
			}
		}
		this.curLib=[];
		this.curLibId=[];
	}
	clearAddedLib(){
		this.addedLib=[];
		this.curLib=[];
		this.curLibId=[];
	}
	cancleLib(){
		this.addedLib=[];
		this.curLib=[];
		this.curLibId=[];
		$('#libraryModal').modal('hide');
	}
	deleteLib(data){console.log(data)
		let inputJson={"PROCEDURE":"deletelibraryentry", "USER_ID":parseInt(this.userId), "LIBRARY_ID":data.LIBRARY_ID}
		/*let inputJson={"PROCEDURE":"updatelibraryentry", "USER_ID":parseInt(this.userId), "LIBRARY_ID":data.LIBRARY_ID,'ITEM_TITLE':data.ITEM_TITLE};
		console.log(inputJson);*/
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response);//{"STATUS":"Y","MESSAGE":"Deletion of Library Entry was successful"}
			let info=JSON.parse(response);
			let msg=info.MESSAGE;
			if(info.RESPONSE_STATUS=="Y"){
				let index=this.libraries.findIndex(lib=>lib.LIBRARY_ID==data.LIBRARY_ID);
				if(index>-1){
					this.libraries.splice(index,1);
				}
				if(this.filteredData){
					let index1=this.filteredData.findIndex(lib=>lib.LIBRARY_ID==data.LIBRARY_ID);
					if(index1>-1){
						this.filteredData.splice(index1,1);
					}	
				}				
				let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				Toast.fire({
					icon: 'success',
					title: msg
				})
				
          }else{
            this.throwError(info)
          }
		})
			
	}
	selSlot(item){console.log(item)
		let index=this.curSlot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
		if(index>-1){
			this.curSlot.splice(index,1);
			this.curSlotId.splice(index,1);
		}else{
			this.curSlot.push(item);
			this.curSlotId.push(item.SLOT_ID);
		}	
		console.log(this.curSlotId)
	}
	addSelSlot(){
		if(this.curSlot.length>0){
			for(let item of this.curSlot){
				let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
				if(index==-1){
					this.selectedSlot.push(item);
				}
			}
		}
		this.curSlot=[];
		this.curSlotId=[];
		
	}
	addAllSelSlot(){
		if(this.slots.length<11&&!this.filteredData){
			for(let fslot of this.slots){
				let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==fslot.SLOT_ID);
				if(index==-1){
					this.selectedSlot.push(fslot);
				}
			}
			
		}else if(this.filteredData&&this.filteredData.length<11){
			for(let fslot of this.filteredData){
				let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==fslot.SLOT_ID);
				if(index==-1){
					this.selectedSlot.push(fslot);
				}
			}
		}
		this.curSlot=[];
		this.curSlotId=[];
	}
	rmvAddedSlot(){
		for(let item of this.curSlot){
			let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
			if(index>-1){
				this.selectedSlot.splice(index,1);
			}
		}
		this.curSlot=[];
		this.curSlotId=[];
	}
	clearAddedSlot(){
		this.selectedSlot=[];
		this.curSlot=[];
		this.curSlotId=[];
	}
	cancleSlot(){
		this.selectedSlot=[];
		this.curSlot=[];
		this.curSlotId=[];
		$('#addSlotModal').modal('hide');
	}

	changeCat(cat){
		console.log(cat)
	}
	resetNewSlot(){
		this.missingSlot=false;
		this.missingSlotMessage='';
		this.newSlotLabel="";
		this.newSlotCat="";
		this.newSlotType="";
		this.newSlotContent="";
		this.newSlotMultiple='N';
		this.newSlotFile.name='';
		this.newSlotFile.url='';
		this.newSlotFile.ext='';
		this.tableContent=[];
		this.newSlotOps=[];
		this.resetLib();
	}
	addLibToSlot(){
		if(this.newSlotType=='Selection'){
			this.newSlotOps=[];
			for(let lib of this.addedLib){
				this.newSlotOps.push(lib.CONTENT);
			}
			$('.slotBtn')[0].classList.add("disabled"); 
		}else{
			this.newSlotContent="";
			for(let lib of this.addedLib){
				this.newSlotContent+=lib.CONTENT;
			}
		}
		$('#libraryModal').modal('hide');
		this.resetLib();
	}
	resetLib(){
		this.addedLib=[];
		this.filteredData=null;
	}
	secSetting(e){
		//e.stopPropagation();
	}
	addLibToDoc(){
		/*let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(index3>-1){
			this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3]['libs']=this.addedLib;
		}else if(index2>-1){
			this.contents[index1].SUB_SECTIONS[index2]['libs']=this.addedLib;;
		}else if(index1>-1){
			this.contents[index1]['libs']=this.addedLib;
		}*/
		this.toContentData('libs', this.addedLib, 'libraryModal');
		//$('#libraryModal').modal('hide');
		this.resetLib();	
	}
	showLib(libs){
		//this.addedLib=libs;
		//$('#showLibModal').modal('show');
	}
	
	generateSeq(){
		if(this.contents.length>0){
			let i=0;
			for (let item1 of this.contents){
				if(item1.DISPLAY_SEQUENCE=='Y'){
					i++;
					item1.SECTION_SEQUENCE=i+'.';
					if(item1['ul']){
						item1.ul.SecRef=item1.SECTION_SEQUENCE;
					}			
					if(item1.SUB_SECTIONS&&item1.SUB_SECTIONS.length>0){
						let j=0;
						for (let item2 of item1.SUB_SECTIONS){
							if(item2.DISPLAY_SEQUENCE=='Y'){
								j++;
								item2.SECTION_SEQUENCE=i+'.'+j;	
								if(item2['ul']){
									item2.ul.SecRef=item2.SECTION_SEQUENCE;
								}						
								if(item2.SUB_SECTIONS&&item2.SUB_SECTIONS.length>0){
									let k=0;
									for (let item3 of item2.SUB_SECTIONS){
										if(item3.DISPLAY_SEQUENCE=='Y'){
											k++;
											item3.SECTION_SEQUENCE=i+'.'+j+'.'+k;
											if(item3['ul']){
												item3.ul.SecRef=item3.SECTION_SEQUENCE;
											}									
											if(item3.SUB_SECTIONS&&item3.SUB_SECTIONS.length>0){
												let l=0;
												for (let item4 of item3.SUB_SECTIONS){
													if(item4.DISPLAY_SEQUENCE=='Y'){
														l++;
														item4.SECTION_SEQUENCE=i+'.'+j+'.'+k+'.'+l;														
														if(item4['ul']){
															item4.ul.SecRef=item4.SECTION_SEQUENCE;
														}
														if(item4.SUB_SECTIONS&&item4.SUB_SECTIONS.length>0){
															let m=0;
															for (let item5 of item4.SUB_SECTIONS){
																if(item5.DISPLAY_SEQUENCE=='Y'){
																	m++;
																	item5.SECTION_SEQUENCE=i+'.'+j+'.'+k+'.'+l+'.'+m;
																	
																}else{
																	item5.SECTION_SEQUENCE='';
																}
															}
														}
													
													}else{
														item4.SECTION_SEQUENCE='';
													}
												}
											}
										
										}else{
											item3.SECTION_SEQUENCE='';
										}
									}
								}
							
							}else{
								item2.SECTION_SEQUENCE='';
							}
						}
					}
				
				}else{
					item1.SECTION_SEQUENCE='';
				}	
			}
		}
	}
	onFilter(event, dt) { 
		this.filteredData = event.filteredValue; console.log(this.filteredData);
	}
	resetNewLibrary(){
		this.addLibWarn=false;
		$('#libTitle').val('');
		$('#libLabel').val('');		
		this.inputLabels='';
		this.newLibPara[0]='';
		this.newLibPara[2]='';
		this.newLibPara[3]='';
		this.newLibPara[1]='';
		this.newLibPara[4]='';
		this.newLibPara[5]='';
	}
	createLibrary(e, type?){
		this.addLibWarn=false;
		let ele=$(e.target).siblings('input');
		const title=ele[0].value;
		if(title.length==0){
			this.addLibWarn=true;
			return
			
		}
		const label=$('#libLabel').val();//this.inputLabels;
		const instr=this.newLibPara[0];
		const content=this.newLibPara[2];
		const eleContent=this.newLibPara[3];
		const eleInstruction=this.newLibPara[1];
		let inputJson={"PROCEDURE":"insertlibraryentry", "USER_ID":parseInt(this.userId), "ITEM_TITLE":title, "CONTENT":content, "INSTRUCTIONS":instr, "LABELS":label, 'CONTENT_HTML':eleContent, 'INSTRUCTIONS_HTML':eleInstruction };
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			if (data.LIBRARY_ID){
				this.libraries.splice(0,0, data);
			}
			if(type=='new'){
				this.addLibShow=false
			}else{
				this.resetNewLibrary()
			}
		}
		})
	}
	toCreateTable(i?, j?, k?, l?, m?){console.log(i,j,k)
		this.curTableData=null;	
		this.colNo=0;
		this.rowNo=0;
		if(this.selectedEditor=='F'){
			this.curTableData=this.getFContentData('data');
		}else if(this.selectedEditor=='O'){
			//this.curTableData=this.getContentData('data');
		
		if(k>-1){
			this.curIndex=[i,j,k];
			if(this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k].data){
				this.curTableData=this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k].data;	console.log(this.curTableData)
				
			}			
		}else if(j>-1){
			this.curIndex=[i,j,this.addon];
			if(this.contents[i].SUB_SECTIONS[j].data){
				this.curTableData=this.contents[i].SUB_SECTIONS[j].data;console.log(this.curTableData)
			};			
		}else if(i>-1){
			this.curIndex=[i,this.addon,this.addon];
			if(this.contents[i].data){
				this.curTableData=this.contents[i].data;
			};			
		}
		}
		if(!this.curTableData){
			this.curTableData={'cols':[],'rows':[]};
			if(this.selectedEditor=='F'){
				this.slotTableType=0;
			}else if(this.selectedEditor=='O'){
				this.slotTableType=1;
			}		
		}else{
			this.slotTableType=this.curTableData.src;
			this.colNo=this.curTableData.cols.length;
			this.rowNo=this.curTableData.rows.length;			
		}	
	}
	createTable(e){console.log(this.rowNo);
		console.log(this.curTableData.cols);
		if((!this.curTableData.erisName&&this.rowNo<1)||this.curTableData.cols.length==0){
			Swal.fire({
				icon: 'info',
				title: "Columns and Rows must be more than 0."
			})
			return
		}
		if(this.curTableData.rows.length==0){
			if(this.slotTableType==1){
				this.curTableData.src=this.slotTableType;
				this.rowNo=1;
				let firstCol={'INTERNALNAME': "ES_RID",'NAME': "ID",'TYPE': "text",'unit': "%",'width': 0, 'hide':true};
				this.curTableData.cols.unshift(firstCol);
				console.log(this.curTableData);
			}else if(this.slotTableType==2){
				this.curTableData.src=this.slotTableType;
				console.log(this.curTableData);
			}else{
				this.curTableData.SLOT_ID=null;
				this.curTableData.src=this.slotTableType;
				//this.rowNo=10;
				 
			}
			console.log(this.rowNo)
			if(this.slotTableType==0){			
		for(let i=0; i<this.rowNo; i++){
			let row=[];
			let rowData={'items':[]};
			for(let j=0; j<this.curTableData.cols.length; j++){
				let item={'COLUMNINTERNALNAME':'','data':''};
				
				item.COLUMNINTERNALNAME=this.curTableData.cols[j].INTERNALNAME;
				rowData[this.curTableData.cols[j].INTERNALNAME]='';
				if(this.curTableData.cols[j]['hide']){
					item['hide']=true;
				}
				//console.log(item)
				row.push(item);
			}
			rowData.items=row;
			this.curTableData.rows.push(rowData);
			
		}
		}else{
		for(let i=0; i<this.rowNo; i++){
			let row=[]
			for(let j=0; j<this.curTableData.cols.length; j++){console.log(this.curTableData.cols[j]);
				let item={'COLUMNINTERNALNAME':'','data':''};
				if(this.curTableData.cols[j]['hide']){
					item['hide']=true;
				}
				item.COLUMNINTERNALNAME=this.curTableData.cols[j].INTERNALNAME;
				//if(this.curTableData.cols[j].TYPE=="dropdown"){
				//	item['choice']=[];
				//}
				//console.log(item)
				row.push(item);
			}
			this.curTableData.rows.push(row);
			
		}
		}
		}else{
			for(let header of this.headertype){
				if(this.curTableData[header]&&this.curTableData[header].length>0){
					for(let hrow of this.curTableData[header]){
						if(hrow.length==1){
							if(!hrow[0]['colspan']){
								hrow[0]['colAlign']=this.curTableData.cols[0].colAlign;
							}							
						}else{
							for(let i=0; i<this.curTableData.cols.length; i++){
								hrow[i]['colAlign']=this.curTableData.cols[i].colAlign;
								hrow[i]['unit']=this.curTableData.cols[i].unit;
								hrow[i]['width']=this.curTableData.cols[i].width;
							}
						}							
					}
				}				
			}
		}
		if(this.curTableData.slotName&&this.curTableData.slotName.length>-1){
			if(this.selectedEditor=='F'){
				let oldtitle=this.getFContentData('SECTION_TITLE');
				if(oldtitle=='Customized Table'){
					this.changeTitle('front',this.curTableData.slotName,this.pageIndex[0],this.pageIndex[1]);
				}
			}else if(this.selectedEditor=='O'){
				let oldtitle=this.getContentData('SECTION_TITLE');
				if(oldtitle=='Customized Table'){
					if(this.curIndex[2]>-1){
						this.changeTitle('content',this.curTableData.slotName,this.curIndex[0],this.curIndex[1],this.curIndex[2]);
					}else{
						this.changeTitle('content',this.curTableData.slotName,this.curIndex[0],this.curIndex[1]);
					}
				}
			}
	
		}
		if(this.curTableData.erisName&&this.curTableData.erisName.length>-1){
			if(this.selectedEditor=='F'){
				let oldtitle=this.getFContentData('SECTION_TITLE');
				if(oldtitle=='Customized Table'){
					this.changeTitle('front',this.curTableData.erisName,this.pageIndex[0],this.pageIndex[1]);
				}
			}else if(this.selectedEditor=='O'){
				let oldtitle=this.getContentData('SECTION_TITLE');
				if(oldtitle=='Customized Table'){
					if(this.curIndex[2]>-1){
						this.changeTitle('content',this.curTableData.erisName,this.curIndex[0],this.curIndex[1],this.curIndex[2]);
					}else{
						this.changeTitle('content',this.curTableData.erisName,this.curIndex[0],this.curIndex[1]);
					}
				}
			}
			
		}
		//this.curTableData.cols=item;
		//this.curTableData.rows=[item1,item2, item3, item4];
		$("#tableModal").modal('hide');
		if(this.selectedEditor=='F'){
			this.toFContentData('data', this.curTableData, 'tableModal')
		}else if(this.selectedEditor=='O'){
			this.toContentData('data', this.curTableData, 'tableModal')
		}	
	}
	updateErisHeader(){
		console.log(this.curTableData)
		if(this.curTableData.SLOT_ID&&this.curTableData.SLOT_ID>-1){
		let data=this.curTableData;
		let headers=[];
		for(let col of data.cols){
			let item={"INTERNALNAME":col.INTERNALNAME,"NAME":col.NAME,"TYPE":col.TYPE};
			if(col.FO&&col.FO.length>0){
				item['FO']=col.FO;
			}
			if(col.DefaultFO&&col.DefaultFO.data.length>0){
				item['DefaultFO']=col.DefaultFO;
			}
			headers.push(item)
		}
		let inputJson={"PROCEDURE":"setSlotReportHeader","USER_ID":parseInt(this.userId),"SLOT_ID":data.SLOT_ID,"TABLE_HEADERS":headers,"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"REPORT_SECTION_ID":this.curId};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			}else{
				let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				Toast.fire({
					icon: 'success',
					title: 'Update successful.',
				})
			}
		})
	}
	}
	/*addOption(e, index){
		let val=$(e.target).val();
		this.curTableData.cols[index].push(val);
	}*/
	addCol(){
		if(this.curTableData['locked']&&this.curTableData['locked']['header']){
			Swal.fire('Table header is locked, can not add column');
			return
		}
		let id='col'+this.curTableData.cols.length.toString();
		 //let item={'INTERNALNAME':id, 'name':'','type':'text'};
		let item={'INTERNALNAME':id,'NAME':'Header'+this.curTableData.cols.length.toString(),'TYPE':'text', 'width':null, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left',};
		item['htmltext']=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
		item['text']=item.NAME;
		this.curTableData.cols.push(item);//console.log(this.curTableData.cols)		
		if(this.curTableData.rows.length>0){
			for(let row of this.curTableData.rows){//console.log(row)
				if(row.items){
					row[id]='';
					if(row.items.length==1&&row.items[0].colspan){
						row.items[0].colspan++;
					}else{
						row.items.push({'COLUMNINTERNALNAME':id, 'DATA':''});
					}
				}else{
					row.push({'COLUMNINTERNALNAME':id, 'DATA':''});	
				}								
			}			
		}
		this.colNo++;
		
		if(this.isEven||(this.curTableData.row[0].items&&this.curTableData.row[0].items.length>1)){
			let width=Math.floor((96/this.curTableData.cols.length)*100)/100;//console.log(width);
			for(let i=0; i<this.curTableData.cols.length; i++){
				this.curTableData.cols[i].width=width;
				this.curTableData.cols[i].unit='%';
			}
		}
		//multiple header parts
		for(let header of this.headertype){
			if(this.curTableData[header]&&this.curTableData[header].length>0){
				for(let row of this.curTableData[header]){//console.log(row)
					if(row.length==1&&row[0].colspan){
							row[0].colspan++;
					}else{
						let no=this.curTableData.cols.length-1;
						let item={'INTERNALNAME':id,'NAME':'<p>Header'+no+'</p>', 'text':'Header'+no, 'htmltext':{changingThisBreaksApplicationSecurity: '<p>Header'+no+'</p>'}};
						item.INTERNALNAME=this.curTableData.cols[no].INTERNALNAME;
						row.push(item);
						for(let i=0; i<row.length; i++){
							row[i]['colAlign']=this.curTableData.cols[i].colAlign;
							row[i]['unit']=this.curTableData.cols[i].unit;
							row[i]['width']=this.curTableData.cols[i].width;
						}
					}
												
				}	
				//console.log(this.curTableData[header])		
			}
		}
	}
	deleteCol(index){
		let that=this;
			Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
		let id=that.curTableData.cols[index].INTERNALNAME; //console.log(id)
		if(that.curTableData.cols.length>1){
		that.curTableData.cols.splice(index, 1);
		for(let header of that.headertype){
			if(that.curTableData[header]&&that.curTableData[header].length>0){
				for(let row of that.curTableData[header]){//console.log(row)
					if(row.length==1&&row[0].colspan){
							row[0].colspan--;
					}else{
						row.splice(index, 1);
					}
				}	
			}
		}
		if(that.curTableData.rows.length>0){
			let index1=-1;
			if(that.curTableData.rows[0].items){
				
			}else{
				index1=that.curTableData.rows[0].findIndex(item=>item.COLUMNINTERNALNAME==id);//console.log(index1)
			}
			for(let row of that.curTableData.rows){
				if(row.items&&row.items.length>0){
							row[id]=null;
							let index2=row.items.findIndex(item=>item.COLUMNINTERNALNAME==id);//console.log(index2)
							if(index2>-1){//console.log(row)
								if(row.items.length==1&&row.items[0].colspan){//console.log(row)
									row.items[0].COLUMNINTERNALNAME=that.curTableData.cols[0].INTERNALNAME;
									row.items[0].colspan--;
								}else{//console.log(row)
									row.items.splice(index2, 1);
								}
							}else{
								if(row.items.length==1&&row.items[0].colspan){
									row.items[0].colspan--;
								}
							}
					
						}else{
							if(index1>-1){
								row.splice(index1, 1);
							}
						}
			}
		}
		if(!that.curTableData.erisName&&(!that.curTableData.slotName)){
			this.reorderTableData(that.curTableData)
		}
		if(that.isEven){
			let total=that.curTableData.cols.length;
			let i=0;
			if(that.curTableData.SLOT_ID>-1){
				total-=1;
				i=1
			}
			if(this.isEven||(this.curTableData.row[0].items&&this.curTableData.row[0].items.length>1)){
			let width=Math.floor((96/this.curTableData.cols.length)*100)/100;//console.log(width);
			for(let i=0; i<this.curTableData.cols.length; i++){
				this.curTableData.cols[i].width=width;
				this.curTableData.cols[i].unit='%';
			}
			}
		}
		}else{
				//console.log(that.curTableData.cols);
				alert('Column can no be deleted since only 1 column left!');
				
			}
		}
			})
	}
	changeLabel(e, index1?){
		this.selectedRow=-1;
		//this.selectedCell={'row':index1,'col':index2};
		if(index1>-1){
			this.curTableData.cols[index1].NAME=e;
			this.curTableData.cols[index1].htmltext=this.sanitizer.bypassSecurityTrustHtml(e);

		}else{
			this.toContentData('data', e, "")
		}
		/*if(index2){
			this.curTableData.rows[index2][index1].name=e;//console.log(this.curTableData.rows[index2][index1].name);
		}else{
			this.curTableData.cols[index1].name=e;//console.log(this.curTableData.cols[index1].name);
		}*/
	}
	changeLabel1(e, doc, index){
		let cell= doc.data.cols[index];
		cell.NAME=e;
		cell.html=e;		
	}
	selCell(i,j?){//console.log(i, j);
		if(j!=null){
			this.selectedCell={'row':i,'col':j};
		}else{
			this.selectedCell={'row':-1,'col':i};
		}
	}
	getRow(h){
		if(this.selectedRow==h){
			this.selectedRow=-1;
		}else{
			this.selectedRow=h;
		}
	}
	toContentData(field, data, pop, preIndex?){
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(preIndex){
			index1=preIndex[0];
			index2=preIndex[1];
			index3=preIndex[2];
		}
		if(!this.selectedCell){			
			if(index3>-1){
				if(field=='slot'){
					if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots){
						let index=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); console.log(index);
						if(index==-1){
							this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots.push(data);
						}						
					}else{
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots=[];
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs){
						let index=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); console.log(index);
						if(index==-1){
							this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs.push(data);
						}
						//this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs.push(data);	
					}else{
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs=[];
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs.push(data);	
					}					
				}else{
					this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3][field]=data;
				}
			}else if(index2>-1){
				if(field=='slot'){
					if(this.contents[index1].SUB_SECTIONS[index2].slots){
						let index=this.contents[index1].SUB_SECTIONS[index2].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); console.log(index);
						if(index==-1){
							this.contents[index1].SUB_SECTIONS[index2].slots.push(data);
						}						
					}else{
						this.contents[index1].SUB_SECTIONS[index2].slots=[];
						this.contents[index1].SUB_SECTIONS[index2].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.contents[index1].SUB_SECTIONS[index2].libs){
						let index=this.contents[index1].SUB_SECTIONS[index2].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); console.log(index);
						if(index==-1){
							this.contents[index1].SUB_SECTIONS[index2].libs.push(data);	
						}
					}else{
						this.contents[index1].SUB_SECTIONS[index2].libs=[];
						this.contents[index1].SUB_SECTIONS[index2].libs.push(data);	
					}					
				}else{

					this.contents[index1].SUB_SECTIONS[index2][field]=data;//console.log(data);
				}
			}else if(index1>-1){
				if(field=='slot'){
					if(this.contents[index1].slots){
						let index=this.contents[index1].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); console.log(index);
						if(index==-1){						
							this.contents[index1].slots.push(data);	
						}
					}else{
						this.contents[index1].slots=[];
						this.contents[index1].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.contents[index1].libs){
						let index=this.contents[index1].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); console.log(index);
						if(index==-1){
							this.contents[index1].libs.push(data);	
						}
					}else{
						this.contents[index1].libs=[];
						this.contents[index1].libs.push(data);	
					}					
				}else{
					this.contents[index1][field]=data;
				}
				//console.log(this.contents[index1].libs)
			}
		}else{console.log(this.selectedCell)
			if(index3>-1){
				if(data instanceof Array){
					if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row].items){
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
					}else{
						if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].TYPE=='4099e'){
							this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
						}else{
							this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data;
						}
					}
				}else{
					if(this.selectedCell.row>-1){
							//this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
						if(field=='htmltext'){
							if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].TYPE=='4099e'){
								this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
								let row=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row];
								let celldata=row[this.selectedCell.col];
								if(celldata['cal0']||celldata['cal1']){
									let that=this;
									if(celldata['cal0']){
										setTimeout(() => {
											let a=parseInt(celldata.data);//console.log(a)
											let b=parseInt(row[that.selectedCell.col+1].data);//console.log(b)
											if(a>0&&b>0){
												row[that.selectedCell.col+2].data=(a-b).toString();;
												row[that.selectedCell.col+3].data=that.getRound(100*(a-b)/a)+'%';
											}
										}, 500);
										
									}else if(celldata['cal1']){
										
										setTimeout(() => {
										let b=parseInt(celldata.data);//console.log(b)
										let a=parseInt(row[that.selectedCell.col-1].data);//console.log(a)
										if(a>0&&b>0){
											row[that.selectedCell.col+1].data=(a-b).toString();
											row[that.selectedCell.col+2].data=that.getRound(100*(a-b)/a)+'%';
										}
										}, 500);
									}
																		
								}
							}else{
								this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
							}
						}else if(field.length>0){console.log(field)
							if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].TYPE=='4099e'){
								this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
							}else{
								this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][field]=data;
							}
							console.log(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3]);
						}else{
							if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].TYPE=='4099e'){
								this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data;
							}else{
								this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row].items[this.selectedCell.col].DATA=data;
							}
							
						}
					}else{
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.cols[this.selectedCell.col].NAME=data
					}
					//this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col].name=data
				}
			}else if(index2>-1){//console.log(this.contents[index1].SUB_SECTIONS[index2]);
				if(data instanceof Array){
					if(this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items){
						this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data; //console.log(data)
					}else if(this.contents[index1].SUB_SECTIONS[index2].tableClass&&this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row]){
						this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data; //console.log(data);
					}else{
						this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data; //console.log(data)
					}
				}else{console.log(this.selectedCell.row);
					if(this.selectedCell.row>-1){
						//this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
						if(field=='htmltext'){
							if(this.contents[index1].SUB_SECTIONS[index2]['tableClass']){
								this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
							}else{
								this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
							}
							
						}else if(field.length>0){console.log(field)
							if(this.contents[index1].SUB_SECTIONS[index2]['tableClass']){
								this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
							}else{
								this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][field]=data;
							}
						}else{
							this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col].DATA=data
						}
						console.log(this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row]);
					}else{
						this.contents[index1].SUB_SECTIONS[index2].data.cols[this.selectedCell.col].NAME=data
					}
				}
			}else if(index1>-1){
				if(data instanceof Array){
					this.contents[index1].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data;
				}else{
					this.contents[index1].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
				}
			}
		}
		if(pop.length>0){
			let dom='#'+pop;
			$(dom).modal('hide');
		}
		console.log(this.contents);
	}
	toFContentData(field, data, pop, preIndex?){console.log(field, data);
		let index1=this.pageIndex[0];
		let index2=this.pageIndex[1];
		if(!this.selectedCell){			
			if(index2>-1){
				if(field=='slot'){
					if(this.frontpages[index1].SUB_SECTIONS[index2].slots){
						let index=this.frontpages[index1].SUB_SECTIONS[index2].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); console.log(index);
						if(index==-1){
							this.frontpages[index1].SUB_SECTIONS[index2].slots.push(data);
						}						
					}else{
						this.frontpages[index1].SUB_SECTIONS[index2].slots=[];
						this.frontpages[index1].SUB_SECTIONS[index2].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.frontpages[index1].SUB_SECTIONS[index2].libs){
						let index=this.frontpages[index1].SUB_SECTIONS[index2].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); console.log(index);
						if(index==-1){
							this.frontpages[index1].SUB_SECTIONS[index2].libs.push(data);	
						}
					}else{
						this.frontpages[index1].SUB_SECTIONS[index2].libs=[];
						this.frontpages[index1].SUB_SECTIONS[index2].libs.push(data);	
					}					
				}else{
				this.frontpages[index1].SUB_SECTIONS[index2][field]=data;console.log(data);
				}
			}else if(index1>-1){
				if(field=='slot'){
					if(this.frontpages[index1].slots){
						let index=this.frontpages[index1].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); console.log(index);
						if(index==-1){						
							this.frontpages[index1].slots.push(data);	
						}
					}else{
						this.frontpages[index1].slots=[];
						this.frontpages[index1].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.frontpages[index1].libs){
						let index=this.frontpages[index1].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); console.log(index);
						if(index==-1){
							this.frontpages[index1].libs.push(data);	
						}
					}else{
						this.frontpages[index1].libs=[];
						this.frontpages[index1].libs.push(data);	
					}					
				}else{
				this.frontpages[index1][field]=data;
				}
			}
		}else{console.log(this.selectedCell)
			if(index2>-1){console.log(this.frontpages[index1].SUB_SECTIONS[index2]);
				if(data instanceof Array){
					this.frontpages[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data; console.log(data)
				}else{console.log(this.selectedCell.row);
					if(this.selectedCell.row!=null){console.log(this.frontpages[index1].SUB_SECTIONS[index2].data.rows)
						if(field=='htmltext'){
							this.frontpages[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
						}else if(field.length>0){console.log(field)
							this.frontpages[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
						}else{
							this.frontpages[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col].DATA=data
						}
					}else{
						this.frontpages[index1].SUB_SECTIONS[index2].data.cols[this.selectedCell.col].NAME=data
					}
				}
			}else if(index1>-1){
				if(data instanceof Array){
					this.frontpages[index1].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data;
				}else{
					this.frontpages[index1].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
				}
			}
		}
		if(pop.length>0){
			let dom='#'+pop;
			$(dom).modal('hide');
		}
		console.log(this.frontpages);
	}
	getFContentData(source){console.log(this.pageIndex);
		let index1=this.pageIndex[0];//console.log(index1);
		let index2=this.pageIndex[1];//console.log(index2);
		let dest:any;
		if(index2>-1){
			if(this.frontpages[index1].SUB_SECTIONS[index2][source]){
				dest=this.frontpages[index1].SUB_SECTIONS[index2][source];
			};			
		}else if(index1>-1){//console.log(index1);
			if(this.frontpages[index1][source]){
				dest=this.frontpages[index1][source];
			};			
		}
		return dest;
	}
	getContentData(source){console.log(this.curIndex);
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		let dest:any;
		
		if(index3>-1){
			if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3][source]){
				dest=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3][source];
			}			
		}else if(index2>-1){
			if(this.contents[index1].SUB_SECTIONS[index2][source]){
				dest=this.contents[index1].SUB_SECTIONS[index2][source];
			};			
		}else if(index1>-1){console.log(index1);
			if(this.contents[index1][source]){
				dest=this.contents[index1][source];
			};			
		}
		return dest;
	}
	startNewLib(){
		this.inputLabels="";
	}
	addLabel(e){
		let text=$(e.target).prev().prev('input').val(); console.log(text);
		let arr=text.split(';');
		for (let ar of arr) {
			if(ar.trim().length>0){
				this.inputLabels+=ar.trim()+';';
			}
		}
		$(e.target).prev().prev('input').val('');
	}
	removeLabel(index){console.log(index);
		let labels=this.inputLabels.split(';');
		labels.splice(index, 1);
		this.inputLabels=labels.join(';');
		console.log(this.inputLabels);
	}
	moveUp(index){
		let data=this.getContentData('data'); console.log(data)
		if(index>0){
			this.array_move(data.rows,index, index-1 );
			this.selectedRow-=1;
		}
	}
	moveDown(index){
		let data=this.getContentData('data');
		if(index<(data.rows.length-1)){
			this.array_move(data.rows,index, index+1 );	
			this.selectedRow+=1;
		}	
	}
	deleteRow(index){
			Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
		let data=this.getContentData('data');
		data.rows.splice(index,1);
		}
			})
	}
	addSub(e){
		let posi=$(e.target).prev('select').val();console.log(posi)
		let data=this.getContentData('data'); console.log(data);
		let row=[{'COLUMNINTERNALNAME':'','data':'', 'celAllign':posi}];
		if(this.selectedRow>-1){
			if(this.addBefore){
						data.rows.splice(this.selectedRow,0,row);
						this.selectedRow+=1;
					}else{
						data.rows.splice(this.selectedRow+1,0,row);
					}
		}	
	}
	addRows(e){
		let no=$(e.target).prev('input').val();
		if(no>0){
			let data=this.getContentData('data');
			for(let i=0; i<no; i++){
				let row=[]
				for(let j=0; j<data.cols.length; j++){
					let item={'COLUMNINTERNALNAME':'','data':''};
					item.COLUMNINTERNALNAME=data.cols[j].INTERNALNAME;
					if(data.cols[j].type=="dropdown"){
						item['choice']=[];
					}
					console.log(item)
					row.push(item);
				}
				if(this.selectedRow>-1){
					if(this.addBefore){
						data.rows.splice(this.selectedRow,0,row);
						this.selectedRow+=1;
					}else{
						data.rows.splice(this.selectedRow+1,0,row);
					}
				}else{
					data.rows.push(row);
				}
				
			}
		}
	}
	toNewLib(){
		this.newLibPara=[];
		this.inputLabels='';
		this.addLibShow=true;
		
	}
	libPara(e, index){
		//console.log(e)
		this.newLibPara[index]=e;//console.log(this.newLibPara);
		if(index==1){
			this.newLibPara[4]=e;
		}else if(index==3){
			this.newLibPara[5]=e;
		}
	}

	getTable(data){console.log(data.TYPE)
		if(data.TYPE=='Table'){
			this.tableContent=JSON.parse(data).HEADERS;
		}else if(data.TYPE=='Selection'){
			let ops=data.SELECTION_CHOICES;
			this.tableContent=ops.split(';;'); 
		}
		console.log(this.tableContent);
	}	
	addOpItem(e){
		if(this.newSlotOp.length>0){
			this.newSlotOps.push(this.newSlotOp)
			this.newSlotOp='';
			//$('.slotBtn')[1].classList.add("disabled"); 
		}
	}
	
	clearOpItem(){
		this.newSlotOps=[];
		$('.slotBtn').each(function(){
			if($(this).hasClass('disabled')){
				$(this).removeClass('disabled');
			}
		})
	}
	setTableSrc(type){
		this.slotTableType=type;
		this.curTableData={'cols':[],'rows':[]};
		if(type==0){			
			for(let i=0; i<this.colNo; i++){
				let item={'INTERNALNAME':'col'+i,'NAME':'Header'+i,'TYPE':'text', 'width':5, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left',};
				item['htmltext']=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
				item['text']=item.NAME;
				this.curTableData.cols.push(item)
			}
			this.curTableData.slotName=null;
			this.curTableData.erisName=null;			
		}else if(type==2){			
			this.curTableData.SLOT_ID=null;	
			this.curTableData.slotName='';			
		}else{
			this.curTableData.SLOT_ID=null;
			this.curTableData.erisName='';
		}
		
	}
	getTables(type){
		let inputJson:any;
		this.erisSlots=[];
		this.tableSlots=[];
		if(type=='eris'){
			inputJson={"PROCEDURE":"getslotsbytype", "USER_ID":parseInt(this.userId), "SLOT_TYPE":"Table", "ERIS_TABLE":"Y"};
		}else{
			inputJson={"PROCEDURE":"getslotsbytype", "USER_ID":parseInt(this.userId), "SLOT_TYPE":"Table", "ERIS_TABLE":"N"};
		}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			if(type=='eris'){
				this.erisSlots=data.RW_SLOTS;
			}else{
				this.tableSlots=data.RW_SLOTS;
			}
		}
		})
	}
	getSlotTable(e){
		let index=$(e.target).val();console.log(index);
			if(index>-1){
				this.curTableData.cols=JSON.parse(this.tableSlots[parseInt(index)].CONTENT).HEADERS; console.log(this.curTableData.cols);
				this.curTableData.SLOT_ID=this.tableSlots[parseInt(index)].SLOT_ID;
				this.curTableData.slotName=this.tableSlots[parseInt(index)].KEY;
				this.curTableData.rows=[];
				this.colNo=this.curTableData.cols.length;
				if(this.isEven){
					let width=Math.floor(100/this.colNo);
					for(let i=0; i<this.colNo; i++){
						this.curTableData.cols[i].width=width;
						this.curTableData.cols[i].unit='%';
					}
				}
			}else{
				this.curTableData={'cols':[],'rows':[]}; console.log(this.curTableData.cols);
				this.curTableData.SLOT_ID=null;
				this.curTableData.slotName='';
				this.colNo=0;
				this.curTableData.rows=[];
			}
		
	
	}
	getErisTable(e){console.log(this.erisSlots);
		let index=$(e.target).val();console.log(index);
		if(index>-1){
			this.curTableData.cols=JSON.parse(this.erisSlots[parseInt(index)].CONTENT).HEADERS; console.log(this.curTableData.cols);
			this.curTableData.SLOT_ID=this.erisSlots[parseInt(index)].SLOT_ID;
			this.curTableData.erisName=this.erisSlots[parseInt(index)].KEY;
			this.colNo=this.curTableData.cols.length;
			if(this.isEven){
				//let width=Math.floor(100/this.colNo);
				let width=Math.floor((96/this.curTableData.cols.length)*100)/100;console.log(width);
				for(let i=0; i<this.colNo; i++){
					this.curTableData.cols[i].width=width;
					this.curTableData.cols[i].unit='%';
					this.curTableData.cols[i]['colAlign']='Center';
					this.curTableData.cols[i]['celAllign']='Left';
				}
			}
		}else{
			this.curTableData={'cols':[],'rows':[]}; console.log(this.curTableData.cols);
			this.curTableData.SLOT_ID=null;
			this.curTableData.erisName='';
			this.colNo=0;
		}
	}
	frmShow=false;
	curFrm:any;
	//summaryShow=false;
	curSummary:any;
	async addRepeat(type, item, cat?){
		let content='';
		if(type=='choice'){
			console.log(type, item);
			let content=item.CONTENT.split(';');
			this.toContentData('choice', content, '');	
			return
		}
		if(type=='slot'){
			let obj:any;
			/*if(item=='signature'){
				obj={'name':'signature', 'dataId':'signature'+this.itemIndex, 'dataType':'text', 'status':'N'};
			}else if(item=='seal'){
				obj={'name':'seal', 'dataId':'seal'+this.itemIndex, 'dataType':'text', 'status':'N'};
			}else{*/
				obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text', 'status':'N'};
			
			//}
			//let obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text', 'status':'N'};
			content=JSON.stringify(obj);
			this.itemIndex++;	console.log(this.itemIndex);
			let data={'index':this.itemIndex,'content':content, 'type':type};			
			if(cat&&cat!=='topara'){
				this.addToTemp(item,cat);
			}
			if(this.selectedEditor=='P'){
					this.pdfFname['addedItem']=data;	
					this.pdfFname['reqIndex']=this.itemIndex;
			}else if(this.cellShow||this.tableShow){
					this.curSec['addedItem']=data;
					this.curSec['reqIndex']=this.itemIndex;
					//this.toContentData(type, info, '');	
			}else if(this.frmShow){
				let obj:any;
				obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text', 'status':'N'};
				content=JSON.stringify(obj);
				this.itemIndex++;	console.log(this.itemIndex);
				let data={'index':this.itemIndex,'content':content, 'type':type};	
				this.curFrm['addedItem']=data;
				this.curFrm['reqIndex']=this.itemIndex;
				
			}/*else if(this.summaryShow){
				let obj:any;
				obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text', 'status':'N'};
				content=JSON.stringify(obj);
				this.itemIndex++;	console.log(this.itemIndex);
				let data={'index':this.itemIndex,'content':content, 'type':type};	
				this.curSummary['addedItem']=data;
				this.curSummary['reqIndex']=this.itemIndex;
				console.log(this.curSummary)
			}*/
			else if(this.pisummaryShow){
				let obj:any;
				obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text', 'status':'N'};
				content=JSON.stringify(obj);
				this.itemIndex++;	console.log(this.itemIndex);
				let data={'index':this.itemIndex,'content':content, 'type':type};	
				this.picurSummaryItem['addedItem']=data;
				this.picurSummaryItem['reqIndex']=this.itemIndex;
				console.log(this.picurSummaryItem)
			}else if(this.selectedEditor=='F'){
					this.toFContentData('addedItem', data, '');
					this.toFContentData(type, item, '');	
					this.toFContentData('reqIndex', this.itemIndex, '');					
				}else{
					this.toContentData('addedItem', data, '');
					this.toContentData('reqIndex', this.itemIndex, '');
				}
			
		}else if(type=='lib'){
			let data:any;
			if(cat&&cat=='topara'){
				await this.getSftContent(item);
				this.itemIndex++;
				data={'index':this.itemIndex,'content':item.CONTENT, 'type':type};
				if(item.CONTENT_HTML&&item.CONTENT_HTML.length>0){
					let text: string = item.CONTENT_HTML;
					data.content=text;
				}
			}
			if(this.cellShow||this.tableShow){
				if(this.curCell){
					if(this.curCell['libs']){
						this.curCell['libs'].push(item);
					}else{
						this.curCell['libs']=[];
						this.curCell['libs'].push(item);
					}
					if(cat&&cat=='topara'){
						this.curSec['addedItem']=data;
						this.curSec['reqIndex']=this.itemIndex;
					}
				}
				//this.toContentData(type, data, '');	
			}else if(this.selectedEditor=='F'){
				this.toFContentData(type, item, '');
				if(cat&&cat=='topara'){
					this.toFContentData('addedItem', data, '');
					this.toFContentData('reqIndex', this.itemIndex, '');
				}					
			}else{
				this.toContentData(type, item, '');
				if(cat&&cat=='topara'){
					this.toContentData('addedItem', data, '');
					this.toContentData('reqIndex', this.itemIndex, '');
				}	
			} 
				let index=this.addedLibs.indexOf(item.LIBRARY_ID);
				if(index==-1){
					this.addedLibs.push(item.LIBRARY_ID);
				}
							
		}else if(type=='newLib'){
			let obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text', 'status':'N'};
			content=JSON.stringify(obj);
			this.addedItem={'index':this.itemIndex,'content':content, 'type':'slot'};console.log(this.addedItem);
			//this.toContentData('addedItem', data, '');
			if(cat&&cat!=='topara'){
				this.addToTemp(item,cat);
			}
			this.itemIndex++;
			this.toContentData(type, item, '');	
		}else if(type=='FO'){
			if(this.defaultShow){
				let data={'index':this.itemIndex,'content':item, 'type':type};
				this.itemIndex++;
				this.eriscurcol.DefaultFO['addedItem']=data;
				this.eriscurcol.DefaultFO['reqIndex']=this.itemIndex;				
			}
		}			
	}
	showSlots(){
		$('.nav-tabs a[href="#slot"]').tab('show');
		this.slotGroup='A';
		this.clearAddedSlot();
		//this.curSlots=[];
		//this.expandAll();
		this.addLib=true;
		this.newLib=false;
		this.groupSlots.forEach(data =>{
			this.expandedRows[data.CATEGORY] = true;
		})
		this.isExpanded=true
	}
	showLibs(doc?){console.log(doc)
		this.checkLib();
		$('.nav-tabs a[href="#lib"]').tab('show');
		this.addLib=true;
		this.addedLibs=[];
		/*if(doc.libs.LIBRARY_ID){
			doc.libs=[];console.log(doc)
		}*/
		if(doc.libs&&doc.libs.length>0){
		for(let lib of doc.libs){
			this.addedLibs.push(lib.LIBRARY_ID);			
		}
		let libstring=this.addedLibs.join(',');
		//let updatedLibs=this.getLib(libstring);
		//let inputJson={"PROCEDURE":"getlibraryentrybyidlist","USER_ID":parseInt(this.userId),"LIBRARY_LIST":libstring};
		let inputJson={"PROCEDURE":"getlibraryentrybyidlistsimple","USER_ID":parseInt(this.userId),"LIBRARY_LIST":libstring};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log('liblist',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			let updatedLibs=data.RW_LIBRARY;
			if(this.selectedEditor=="F"){
				this.toFContentData('libs', updatedLibs, '')
			}else{
				this.toContentData('libs', updatedLibs, '')
			}
			//return updatedLibs;
		}
		})
		//this.toContentData('libs', updatedLibs, '')
		
		}
	}
	showSelSlots(){
		$('.nav-tabs a[href="#slot"]').tab('show');
		this.slotGroup='S';
	}
	showSelLibs(){
		console.log(this.contents)
		console.log(this.getContentData('data'))
		this.addedLib=[];
		let libs=this.getContentData('data').rows[this.selectedCell.row][this.selectedCell.col].choice;console.log(libs)
		if(libs&&libs.length>0){
			for(let lib of libs){
				if(lib.LIBRARY_ID&&lib.LIBRARY_ID.length>0){
					this.addedLib.push(lib)
				}
			}
		}
		console.log(this.addedLib)
	}
	setCol(){
		if(this.colNo>0){
			let width=Math.round((96/this.colNo)*100)/100;
			this.curTableData.cols=[];
			for(let i=0; i<this.colNo; i++){
				let item:any
				if(this.isEven){
					item={'INTERNALNAME':'col'+i,'NAME':'Header'+i,'TYPE':'text', 'width':width, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left',};
					item['text']=item.NAME;
					item.htmltext=this.sanitizer.bypassSecurityTrustHtml('Header'+i);
				}else{
					item={'INTERNALNAME':'col'+i,'NAME':'Header'+i,'TYPE':'text', 'width':'', 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left',};
					item['text']=item.NAME;
					item.htmltext=this.sanitizer.bypassSecurityTrustHtml('Header'+i);
				}
				this.curTableData.cols.push(item)
			}			
		}
	}	
	clearChoice(){
		this.toContentData('', [], '');
		this.resetLib();
		this.selectedSlot=[];			
	}
	addPdfs(e,i){
		let info={'CATEGORY': "ERIS Data",'CONTENT': "",'KEY': "",'LABEL': "",'SHORT_CONTENT': "",'TYPE': "PDF", 'selectedfile':true}; console.log(info)
		if(this.appendices.SUB_SECTIONS[i].RF){
			this.appendices.SUB_SECTIONS[i].RF.push(info);
		}else{
			this.appendices.SUB_SECTIONS[i].RF=[];
			this.appendices.SUB_SECTIONS[i].RF.push(info);
		}
	}
	addPdf(e,i, j){
		let info=this.pdfSlots[e]; console.log(info)
		this.appendices.SUB_SECTIONS[i].RF[j]=info;		
	}
	removePdf(i, j){
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				this.appendices.SUB_SECTIONS[i].RF.splice(j, 1);
			}
		})
	}
	selUp(index){console.log(index);
		//this.newSlotOps
		moveItemInArray(this.newSlotOps, index-1, index);
			//this.array_move(this.newSlotOps,index-1, index )
		
	}
	selDown(index){console.log(index);
		moveItemInArray(this.newSlotOps, index+1, index);
			//this.array_move(this.newSlotOps,index+1, index )
		
	}
	selRemove(index){console.log(index);
			Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
		this.newSlotOps.splice(index, 1);
		}
	})
	}
	setTextType(e){
		let data=$(e.target).prop('checked');console.log(data);
		this.toContentData('intro', data, '');		
	}
	deleteFile(item, type){
		console.log(item)
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				let inputJson={"PROCEDURE":"deleteuploadfilev2","USER_ID":parseInt(that.userId),"FILE_ID":item.FILE_ID};
				this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
					console.log(JSON.parse(response))
					if(JSON.parse(response).RESPONSE_STATUS=="Y"){
						let data=[];
						if(type=="FILE"){
							data=that.uploadedFiles
						}else if(type=="PHOTO"){
							data=that.photos
						}else if(type=="IMAGE"){
							data=that.others
						}else if(type=="BKIMAGE"){
							data=that.bks
						}else if(type=="LOGO"){
							data=that.logos
						}
						let index=data.findIndex(file=>file.FILE_ID==item.FILE_ID); console.log(index);
						if(index>-1){
							data.splice(index,1);
							Swal.fire({
								icon:'success',
								title: JSON.parse(response).MESSAGE,
							})
						}
					}else{
					this.throwError(response)
				}
				})
			}
		})
	}
	updateFile(item, type, e? ){console.log(item);
		let data=$(e.target).prev('textarea').val();console.log(data);
		let inputJson={"PROCEDURE":"updateuploadfilev2","USER_ID":parseInt(this.userId),"FILE_ID":item.FILE_ID,"FILE_NAME":item.FILE_NAME,"FILE_DESCRIPTION":data};
		console.log(inputJson);
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response)
			let file=JSON.parse(response);
			if (file.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			if(type=='PHOTO'){
				let index=this.photos.findIndex(photo=>photo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.photos[index]=file;
				}
			}else if(type=='IMAGE'){
				let index=this.others.findIndex(other=>other.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.others[index]=file;
				}
			}else if(type=='BKIMAGE'){
				let index=this.bks.findIndex(bk=>bk.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.bks[index]=file;
				}
			}else if(type=='LOGO'){
				let index=this.logos.findIndex(logo=>logo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.logos[index]=file;
				}
			}
		}
		})
	}
	copyTemp(id){
		
	}
	addSec(sec){console.log(sec);
		let newsec=JSON.parse(JSON.stringify(sec));
		if(newsec.SECTION_TITLE=='COST TABLES'){
			this.selectedCell=null;
			this.addPCATable();
		}else{
			newsec['id']=Utils.uniqueIdGenerator();
			for(let subSec1 of newsec.SUB_SECTIONS){
				subSec1['id']=Utils.uniqueIdGenerator();
				for(let subSec2 of subSec1.SUB_SECTIONS){
					subSec2['id']=Utils.uniqueIdGenerator();			
				}
			}
			this.contents.push(newsec); console.log(this.contents)
			this.generateSeq();
			if(this.summaryStatus){console.log(this.summaryStatus)
				if(this.summaryType=='PHASE I'){
					this.toTatalPISummary();
				}else if(this.summaryType=='PCA'){
					this.getTotalSummary();
				}	
			}
		}
	}
	getPCAData(){
		if(this.currencies.length==0){
			let inputJson={"PROCEDURE":"getcurrency"};
			console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				//console.log(data.RW_CURRENCYS)
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
				  }else{
				this.currencies=data.RW_CURRENCYS; console.log(this.currencies)
				  }
			})
		
		let inputJson1={"PROCEDURE":"getPCACostTableMultipler","USER_ID":parseInt(this.userId)};
		console.log(inputJson1);
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
			console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
			  }else{
			this.multipliers=response.PCA_COST_MULTIPLIER;
			  }
		})
		let inputJson2={"PROCEDURE":"gettemplatepca","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID}
		console.log(inputJson2);
		this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(response => {
			console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
			  }else{
			if(response.PCA_DATA.length>0){
				this.pcaOp=JSON.parse(response.PCA_DATA); console.log(this.pcaOp);
				this.reserveTerm=this.pcaOp.reserve;
			}
		}
		})
		}
	}
	addCost(type){
		if(this.selectedEditor=='O'){
			this.checkPca();
			if(this.hasPca){
				if(type=='A'){
					this.addCostTable()
				}else if(type=='B'){
					this.addCostTable2()
				}
			}
	}else{
			Swal.fire({
				icon:'info',
				title: "A Cost Recommendation table must be added to a section. Select a report section from the Sections tab on the left sidebar of your report.",
			})
		}
	}
	addCostTable(){
		
			let item={'TYPE':'COSTTABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Cost Recommendation Table",'SUB_SECTIONS':[]};
			this.addToContent(item);
			console.log(this.curIndex);
			//this.setCurIndex();
			this.createCostTable();
		
	}
	addCostTable2(){
			let item={'TYPE':'COSTTABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Cost Recommendation Table",'SUB_SECTIONS':[]};
			this.addToContent(item);
			console.log(this.curIndex);
			//this.setCurIndex();
			this.createCostTable('cost2');
		
	}
	addPCATable(){
		if(this.selectedEditor=='O'){
		let index=this.contents.findIndex(sec=>sec.TYPE=='COST');
		if (index>-1){
				Swal.fire({
					icon:'info',
					text: 'Only one Short term, Immediate, and Replacement Reserve tables allowed.',
				})	
			return
		}
		let uid=Utils.uniqueIdGenerator();
		let item={'TYPE':'COST','DISPLAY_SEQUENCE': "Y",'SECTION_SEQUENCE': "",'SECTION_TITLE': "COST TABLES",'SUB_SECTIONS':[], 'id':uid};
		if(this.curIndex[0]>-1){
			this.contents.splice(this.curIndex[0]+1,0, item);
			this.curIndex=[this.curIndex[0]+1, this.addon, this.addon];
		}else{
			this.contents.push(item);
			this.curIndex=[this.contents.length-1, this.addon, this.addon];
		}
		this.generateSeq();
		/*if(this.summaryStatus){
			this.getTotalSummary();	
		}*/	
		this.curIndex=[this.curIndex[0], this.addon, this.addon];
		this.addPCATable2();
		this.curIndex=[this.curIndex[0], this.addon, this.addon]
		let title="Immediate and Short Term Repair Cost Table";
		if(this.pcaOp.term=='Exclude'){
			title="Immediate Repair Cost Table";
		}
		let item1={'TYPE':'PCATABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': title,'SUB_SECTIONS':[],"NEW":false};
		this.addToContent(item1);
		//this.setCurIndex();
		this.createCostTable('pca');
		}else{
			Swal.fire({
				icon:'info',
				title: "Please select a position for your Cost Table in the Table of Contents.",
			})
		}
	}
	addPCATable2(){
		let item={'TYPE':'PCATABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Replacement Repair Cost Table",'SUB_SECTIONS':[],"NEW":false,"ZOOM":true};
		this.addToContent(item);
		console.log(this.curIndex);
		//this.setCurIndex();
		this.createCostTable('repair');		
	}
	createCostTable(type?){
		this.curCostTable={'cols':[],'rows':[]};
		let cols:any;
		let keys=[];
		if(type&&type=='repair'){
			cols=this.repairCols; //['Item','EUL','EFF AGE','RUL','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Year x', 'Total'];
			keys=this.repairKeys;//['Item','EUL','EFF','RUL','Quantity','Unit','Cost','Cycle','Percent','Year', 'Total'];
		}else if(type&&type=='cost2'){
			cols=this.costCols2; //['Item','EUL','EFF AGE','RUL','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Year x', 'Total'];
			keys=this.costKeys2;//['Item','EUL','EFF','RUL','Quantity','Unit','Cost','Cycle','Percent','Year', 'Total'];
			this.curCostTable['version']='2';
		}else{
			cols=this.costCols1;//['Item','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Reserve Total','Short Term Total'];
			//cols.splice(7,0,'Immediate Total');
			keys=this.costKeys1;//['Item','Quantity','Unit','Cost','Cycle','Percent','Reserve','Immediate','Short']
			
		}
			for(let i=0; i<cols.length; i++){
				let item={'INTERNALNAME':'col'+i,'NAME':cols[i],'TYPE':'text', 'width':null, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left','KEY':keys[i]};
				if(!type){
					if(item.KEY=='Cycle'||item.KEY=='Percent'){
						item['hide']=true;
					}
					if(item.KEY=='Short'){
						if(this.pcaOp.term=='Exclude'){
							item['hide']=true;
						}else{
							item['hide']=false;
						}
					}						
				}else if(type&&type=='pca'){
					if(item.KEY=='Reserve'){
						item['hide']=true;
					}
					if(item.KEY=='Short'){
						if(this.pcaOp.term=='Exclude'){
							item['hide']=true;
						}else{
							item['hide']=false;
						}
					}
				}else if(type&&type=='repair'){
					item.width=this.repairWidth[i];
					if(i==0){
						item.celAllign='Left';
					}else{
						item.celAllign='Right';
					}
					item.colAlign='Center';
					
				}
				console.log(item);
				this.curCostTable.cols.push(item)
			}
			let row=[]
			for(let j=0; j<this.curCostTable.cols.length; j++){
				let item={'COLUMNINTERNALNAME':'','data':'', 'KEY':''};
				item.COLUMNINTERNALNAME=this.curCostTable.cols[j].INTERNALNAME;
				if(!type){
					if(this.curCostTable.cols[j].KEY=='Cycle'||this.curCostTable.cols[j].KEY=='Percent'){
						item['hide']=true;
					}
					if(this.curCostTable.cols[j].KEY=='Short'){
						if(this.pcaOp.term=='Exclude'){
							item['hide']=true;
						}else{
							item['hide']=false;
						}
					}
				}else if(type&&type=='pca'){
					if(this.curCostTable.cols[j].KEY=='Reserve'){
						item['hide']=true;
					}
					if(this.curCostTable.cols[j].KEY=='Short'){
						if(this.pcaOp.term=='Exclude'){
							item['hide']=true;
						}else{
							item['hide']=false;
						}
					}
				}
				console.log(item);
				row.push(item);
			}
			this.curCostTable.rows.push(row);
			console.log(this.curCostTable)
			this.toContentData('data', this.curCostTable, '')
			let table={'data':this.curCostTable, 'index':this.curIndex};
			//this.costTables.push(table);console.log(this.costTables);
			//this.setCostTableTitle();
			this.getAllCostTable();			
	}
	getAllCostTable(){
		this.costTables=[];
		for(let sec of this.contents){
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='COSTTABLE'){
						sec1['pre']=this.getPre(sec1.id)
						this.costTables.push(sec1)
					}
					if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
						for(let sec2 of sec1.SUB_SECTIONS){
							if(sec2.TYPE=='COSTTABLE'){
								sec2['pre']=this.getPre(sec2.id)
								this.costTables.push(sec2)
							}
						}
					}
				}
			}
		}		
	}
	setCurIndex(){
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(index3>-1){
			this.curIndex=[index1,index2,index3+1];
		}else if(index2>-1&&!index3){
			this.curIndex=[index1,index2,0];			
		}else if(index1>-1&&!index2&&!index3){
			this.curIndex=[index1,0,this.addon];			
		}
	}
	selCost(item){console.log(item)
		if(item.STATUS!='Active'){
			Swal.fire({
				icon:'info',
				html: '<span>Only Active items can be selected.</span>'
			})
			return
		}
		let index=this.curCostId.indexOf(item.COST_LIBRARY_ID);console.log(index)
		if(index>-1){
			this.curCost.splice(index,1);
			this.curCostId.splice(index,1);
		}else{
			this.curCost.push(item);
			this.curCostId.push(item.COST_LIBRARY_ID);
		}
		console.log(this.curCost)
		console.log(this.curCostId)
				
	}
	addSelCost(){
		if(this.curCost.length>0){
			for(let item of this.curCost){
				let index=this.addedCost.findIndex(lib=>lib.COST_LIBRARY_ID==item.COST_LIBRARY_ID);
				if(index==-1){
					this.addedCost.push(item);
				}
			}
			this.curCost=[];
			this.curCostId=[];	
		}
		
	}
	addLibToCost(){console.log(this.addedCost)
		this.toContentData('libs', this.addedCost, 'costLibModal');
		this.addedCost=[];	
		this.selectedRow=-1;
		this.selectedCell=null;
	}
	rmvAddedCost(){
		for(let item of this.curCost){
			let index=this.addedCost.findIndex(lib=>lib.COST_LIBRARY_ID==item.COST_LIBRARY_ID);
			if(index>-1){
				this.addedCost.splice(index,1);
			}
		}
		this.curCost=[];
		this.curCostId=[];
	}
	clearAddedCost(){
		this.addedCost=[];
		this.curCost=[];
		this.curCostId=[];
	}
	setCostTableTitle(){
		console.log(this.pcaOp.term);
		for(let sec of this.contents){
			if(sec.TYPE=='COST'){
				console.log(sec);
				let index=sec.SUB_SECTIONS[0].data.cols.findIndex(col=>col.KEY=='Short');
				if(index>-1){								
				if(this.pcaOp.term=='Exclude'){
					sec.SUB_SECTIONS[0].SECTION_TITLE="Immediate Repair Cost Table";
					sec.SUB_SECTIONS[0].data.cols[index].hide='Y';
					for(let row of sec.SUB_SECTIONS[0].data.rows){
						row[index].hide='Y';							
					}
				}else{
					sec.SUB_SECTIONS[0].SECTION_TITLE="Immediate and Short Term Repair Cost Table";
					sec.SUB_SECTIONS[0].data.cols[index].hide='N';
					for(let row of sec.SUB_SECTIONS[0].data.rows){
						row[index].hide='N';							
					}
				}
			}
			}
			if(sec.SUB_SECTIONS){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='COSTTABLE'){
						console.log(sec1);
						let index=sec1.data.cols.findIndex(col=>col.KEY=='Short');
						if(index>-1){
							if(this.pcaOp.term=='Exclude'){
								sec1.data.cols[index].hide='Y';
								for(let row of sec1.data.rows){
									row[index].hide='Y';							
								}
							}else{
								sec1.data.cols[index].hide='N';
								for(let row of sec1.data.rows){
									row[index].hide='N';							
								}
							}
						}
						
					}else if(sec1.id=='pca_summary_1'){
						//let index=sec1.data.cols.findIndex(col=>col.NAME=='Short Term Repairs');console.log(index)
						let index=sec1.data.cols.findIndex(col=>col.KEY=='Short');console.log(index)
						if(this.pcaOp.term=='Exclude'){
							if(index>-1){
								sec1.data.cols[index]['hide']=true;
								for(let row of sec1.data.rows){
									if(row[index]){
										row[index]['hide']=true;
									}else{
										if(row[0]['colspan']==8){
											row[0]['colspan']=7;
										}else if(row[0]['colspan']==5){
											row[2]['hide']=true;
										}
										
									}
									
								}
							}
						}else{
							if(index>-1){
								sec1.data.cols[index]['hide']=false;
								for(let row of sec1.data.rows){
									if(row[index]&&row[index]['hide']){
										row[index]['hide']=false;
									}else{
										if(row[0]['colspan']==7){
											row[0]['colspan']=8;
											
										}else if(row[0]['colspan']==5){
											row[2]['hide']=false;
										}
										
									}
								}
							}
						}

					}else if(sec1.id=='pca_summary_2'){
						if(this.pcaOp.term=='Exclude'){
							sec1.data.rows[1][0]['rowhide']=true;
						}else{
							sec1.data.rows[1][0]['rowhide']=false;
						}

					}else{
						if(sec1.SUB_SECTIONS){
							for(let sec2 of sec1.SUB_SECTIONS){
								if(sec2.TYPE=='COSTTABLE'){
									let index1=sec2.data.cols.findIndex(col=>col.KEY=='Short');
									if(index1>-1){
									if(this.pcaOp.term=='Exclude'){
										if(sec2.data.cols[index1]){
											sec2.data.cols[index1]['hide']='Y';
										}
										
										for(let row of sec2.data.rows){
											if(row[index1]){
												row[index1]['hide']='Y';	
											}
																		
										}
									}else{
										if(sec2.data.cols[index1]){
											sec2.data.cols[index1]['hide']='N';
										}
										
										for(let row of sec2.data.rows){
											if(row[index1]){
											row[index1]['hide']='N';
											}								
										}
									}
								}
								}
				
							}
						}
					}
				}
			}
		}
				
	}
	expanded=false;
	allTemplates=[];
	getCompanyTemplates(){
		let inputJson= {"PROCEDURE":"getcompanytemplates","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log('companyTemplates',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.allTemplates=data.RW_TEMPLATES;
			for(let i=0; i<this.allTemplates.length;i++){
				console.log(this.allTemplates[i].TEMPLATE_TYPE[0], i);
					this.allTemplates[i].CATEGORY_NAME=this.allTemplates[i].TEMPLATE_TYPE[0]?.CATEGORY_NAME
					this.allTemplates[i].SUBCATEGORY_NAME=this.allTemplates[i].TEMPLATE_TYPE[0]?.SUBCATEGORY_NAME
				

			}
		}
		})

	}
	expandcollapse() {
		if(this.allTemplates.length==0){
			this.getCompanyTemplates();
			this.getTemplateCounts();
			this.getTemplateTypeCategory();
		}
		this.expanded =! this.expanded;
		if(!this.expanded){
			console.log($('#task-box'))
			$('#task-box').css('right', '360px');
			$('#task-box').css('transform', '');
		
		}else{
			$('#task-box').css('right', '5vw');
		}
	  }
	 
	  @ViewChild('iframe') iframe: ElementRef;
	   clickTemplate(){

		this.iframe.nativeElement.contentWindow.document.getElementById('templatebutton').click()

}
templateCounts;
templateCountDict ={};
templateFilterOptions=[];
templateFilterOptions2=[];
typeList2=[];
getTemplateCounts(){
let inputJson={"PROCEDURE":"gettemplatecounts","USER_ID":parseInt(this.userId)}
this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
	console.log("templateCounts",data);
	if (data.RESPONSE_STATUS=='N') {
		this.throwError(data)
	  }else{
	this.templateCounts=data.TEMPLATE_COUNTS;
	this.templateFilterOptions.push(...data.TEMPLATE_COUNTS);
	console.log("this.templateFilterOptions",this.templateFilterOptions)
	for(let template of this.templateCounts){
		this.templateCountDict[template.SUBCATEGORY_NAME]=template.TOTAL;
	}
}
});
}
selectedFilter2
filterTemplates(x){
this.tt.filter(x.SUBCATEGORY_NAME, 'SUBCATEGORY_NAME', 'contains')
}
selectedFilter3
filterTemplates3(x){
this.tt.filter(x, 'STATUS', 'equals')
}
filterTemplates2(x){
this.tt.filter(x.CATEGORY, 'CATEGORY_NAME', 'contains')
}
selectedFilter;
templateRow;
resetTypeList(){
this.typeList=[];
}
getTemplateHistory2(user){

let inputJson={"PROCEDURE":"gettemplatehistory","USER_ID":parseInt(this.userId),"TEMPLATE_ID":user.TEMPLATE_ID}
this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
	console.log(data);
	if (data.RESPONSE_STATUS=='N') {
		this.throwError(data)
	  }else{
	user.RW_TEMPLATE_HISTORY=data.RW_TEMPLATE_HISTORY;
	  }
});
}
@ViewChild('ttt') private tt: Table;

updateTemplateTitlePermission = false;
checkUpdateTemplateTitlePermission() {
	this.updateTemplateTitlePermission = false;
	let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 38};
	console.log(checkUserInputJson);
	this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
		console.log(checkResponse)
		if (checkResponse.RESPONSE_STATUS=='N') {
			this.throwError(checkResponse)
		  }else{
		if (checkResponse.USER_PERMISSION == 'N') {
			this.throwError(checkResponse)
			this.updateTemplateTitlePermission = false;

		} else {
			this.updateTemplateTitlePermission = true;
		}
	}

	});
}
updateTemplateTitle(rowData){
	let inputJson={"PROCEDURE":"updatetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":rowData.TEMPLATE_ID, "TEMPLATE_TITLE":rowData.TEMPLATE_TITLE};
	this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		if (data.RESPONSE_STATUS=='N') {
			this.throwError(data)
		  }
		console.log(data);

	})
}
changeStatus(user) {
	// first check if user has permission:
	let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 37};
	console.log(checkUserInputJson);
	this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
		console.log(checkResponse)
		if (checkResponse.RESPONSE_STATUS=='N') {
			this.throwError(checkResponse)
		  }else{
		if (checkResponse.USER_PERMISSION == 'N') {
			this.throwError(checkResponse)
		} else {
			console.log(user)
			let inputJson;
			if(user.STATUS == "Active"){
				inputJson={"PROCEDURE":"removetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":user.TEMPLATE_ID}
			}else{
				inputJson={"PROCEDURE":"activatetemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":user.TEMPLATE_ID}

			}

			user.STATUS = user.STATUS == "Active" ? "Inactive" : "Active";
			console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data)
			});
		}
	}
	});
	

}
// not used:
deleteTemplate(){
	let inputJson= {"PROCEDURE":"deletetemplate", "USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.templateRow.TEMPLATE_ID};
	this.reportService.univeralService(JSON.stringify(inputJson))
	.subscribe(data => {
		if (data.RESPONSE_STATUS=='N') {
			this.throwError(data)
		  }else{
		for(let i=0; i<this.allTemplates.length; i++){
			if(this.allTemplates[i].TEMPLATE_ID==this.templateRow.TEMPLATE_ID ){	
				this.allTemplates.splice(i, 1);
				this.allTemplates = [].concat(this.allTemplates);
				}
		}
		console.log(data);
	}
	})
}
copyTemplate(include){
	// first check if user has permission:
	let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId),"FUNCTION_ID": 37};
	console.log(checkUserInputJson);
	this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
		console.log(checkResponse)
		if (checkResponse.RESPONSE_STATUS=='N') {
			this.throwError(checkResponse)
		  }else{
		if (checkResponse.USER_PERMISSION == 'N') {
			this.throwError(checkResponse)
		} else {
			
			let inputJson= {"PROCEDURE":"copytemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.templateRow.TEMPLATE_ID,"INCLUDE_SLOT":include}
			this.reportService.univeralService(JSON.stringify(inputJson))
			.subscribe(data => {
				console.log(data);
				if(data.RESPONSE_STATUS=="N"){
					this.throwError(data)
				
				}else if(data.RESPONSE_STATUS=="Y"){
					let Toast=Swal.mixin({
							toast: true,						
								position: 'center',
								showConfirmButton: false,
								timer: 3000
							})
						Toast.fire({
							icon: 'success',
							title: data.MESSAGE,
						})
				}
				for(let i=0; i<this.allTemplates.length; i++){
					if(this.allTemplates[i].TEMPLATE_ID==this.templateRow.TEMPLATE_ID ){
						this.allTemplates.splice(i, 0, data);
						this.allTemplates[i].CATEGORY_NAME=this.allTemplates[i].TEMPLATE_TYPE[0].CATEGORY_NAME
						this.allTemplates[i].SUBCATEGORY_NAME=this.allTemplates[i].TEMPLATE_TYPE[0].SUBCATEGORY_NAME
				//		this.allTemplates = [].concat(this.allTemplates);
						break;
					}
				}
			})

		}
	}
	});

}
	dismissConfirm2(event){
		$('#deleteModal').modal('hide');
	}
	dismissConfirm1(event){
		$('#deleteModal2').modal('hide');
	}
	dismissConfirm3(event){
		$('#deleteTempConfirm').modal('hide');
	}
	dismissConfirm4(event){
		$('#copyWith').modal('hide');
	}
	dismissConfirm(a){
		$(a).modal('hide');
	}	
	removeLib(item){console.log(item);
		if(this.curCell){
			let index=this.curCell.libs.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
			if(index>-1){
				this.curCell.libs.splice(index, 1);			
			}
		}else if(this.selectedEditor=='F'){
			let data=this.getFContentData('libs'); console.log(data);
			let index=data.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
			if(index>-1){
				data.splice(index, 1);
				this.addedLibs.splice(index, 1);
			
			}
			
		}else  if(this.selectedEditor=='O'){
			let data=this.getContentData('libs'); console.log(data);
			let index=data.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
			if(index>-1){
				data.splice(index, 1);
				this.addedLibs.splice(index, 1);
			
			}
		}
	}
	ifSeq(e, doc){
		let config=$(e.target).prop('checked'); console.log(config)
		let data='Y';
		if(config){
			data='N';
			if(this.summaryStatus){
				if(doc.OSNAME||doc.SECTION_TITLE.length==0){
					if(doc.pisummarydata){
						delete doc.pisummarydata;
					}else if(doc.pcasummarydata){
						delete doc.pcasummarydata;
					}
				}
				
			}
		}
		this.toContentData('DISPLAY_SEQUENCE', data, ''); 
		this.generateSeq();
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}	
		}
	}
	ifSecTitle(e, doc){
		let config=$(e.target).prop('checked'); //console.log(config)
		if(config){
			doc.OSNAME=true;
		}else{
			delete doc.OSNAME;
		}
		if((config||doc.SECTION_TITLE.length==0)&&doc.SECTION_SEQUENCE.length==0){			
			if(this.summaryStatus){
				if(doc.pisummarydata){
					delete doc.pisummarydata;
				}else if(doc.pcasummarydata){
					delete doc.pcasummarydata;
				}
			}
		}

		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}	
		}		
	}
	private getAllSlotId(str){//console.log(str)
		if(!str)return
		let indices1=this.getIndices(str,'data-id=');//console.log(indices1);
		let indices2=this.getIndices(str, 'data-type="text" data-status');//console.log(indices2);
		let ids=[];
		for(let i=0; i<indices1.length; i++){
			let text=str.substring(indices1[i],indices2[i]).split('"')[1]; //console.log(text)
			let id=parseInt(text);
			if(ids.indexOf(id)==-1){
			ids.push(parseInt(text));
			}
		}
		//console.log(ids);
		return ids
	}
	private getIndices(str, substr){
		let indices=[];
		let index = str.indexOf(substr);
		while(index !== -1) {
			indices.push(index);
			index = str.indexOf(substr, index + 1);
		}
		//console.log(indices);
		return indices;
	}
	saveTimer:any;
	autoSave(){
		let that=this;
		//window.clearInterval(that.saveTimer);
		this.saveTimer = window.setInterval(function () {
			that.saveTemplate('Y');		
		},  60000);
		
	}
	filterSlot(e){
		//console.log(e.target);
		let key="";
		if(e.target.tagName=='INPUT'){
			key=e.target.value.trim();;
		}else if(e.target.tagName=='I'){
			key=$(e.target).prev('input').val().trim();
		}
		console.log(key);
		let inputJson={"PROCEDURE":"searchslotsfortemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"SLOT_KEYWORD":key};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
				
			}else{
				this.groupSlots=data.RW_SLOT_CATEGORIES;
			}
			//this.slots=data.RW_SLOTS;
				if(!this.isExpanded){
				this.groupSlots.forEach(data =>{
					this.expandedRows[data.CATEGORY] = true;
				})
				this.isExpanded=true
				console.log(this.expandedRows);
			}
		})
	}
	hasPca=false;
	checkPca(){
		let index=this.contents.findIndex(sec=>sec.TYPE=='COST');
		if(index>-1){
			this.hasPca=true;
		}else{
			this.hasPca=false;
		}
	}
	async getLibContent(lib){
		let inputJson={"PROCEDURE":"getlibraryentrybyidlist","USER_ID":parseInt(this.userId),"LIBRARY_LIST":lib.LIBRARY_ID,};
		//console.log(inputJson);
		let data=await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			console.log('liblist',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
														
			}else{
				lib['CONTENT']=data.RW_LIBRARY[0].CONTENT;
				lib['CONTENT_HTML']=data.RW_LIBRARY[0].CONTENT_HTML;
				lib['INSTRUCTIONS']=data.RW_LIBRARY[0].INSTRUCTIONS;
				lib['INSTRUCTIONS_HTML']=data.RW_LIBRARY[0].INSTRUCTIONS_HTML;					
			}
	
	}
	/*getLib(libstring){
		let inputJson={"PROCEDURE":"getlibraryentrybyidlist","USER_ID":parseInt(this.userId),"LIBRARY_LIST":libstring};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log('liblist',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			let updatedLibs=data.RW_LIBRARY;
			this.toContentData('libs', updatedLibs, '')
			return updatedLibs;
			  }
		})
	}*/
	refreshSlots(){
		this.getSlots();
	}
	refreshLibs(){
		this.getLibraries();
		this.getLibLabels();
	}
	getFrontIdIndex(id){
		let secIndex=[];
		for(let i=0; i<this.frontpages.length; i++){
			if(this.frontpages[i].id==id){
				secIndex=[i,this.addon];
				break;
			}else{
				if(this.frontpages[i].SUB_SECTIONS){
				for(let j=0; j<this.frontpages[i].SUB_SECTIONS.length; j++){
					if(this.frontpages[i].SUB_SECTIONS[j].id==id){
						secIndex=[i,j];									
						break;
					}
				}
				}
			}
		}
		if(secIndex.length>0){
			this.selectedEditor='F';
		}
		console.log(secIndex);
		return secIndex;
	}
	getIdIndex(id){
		let secIndex=[];
		for(let i=0; i<this.contents.length; i++){
			if(this.contents[i].id==id){
				secIndex=[i,this.addon,this.addon];
				break;
			}else{
				for(let j=0; j<this.contents[i].SUB_SECTIONS.length; j++){
					if(this.contents[i].SUB_SECTIONS[j].id==id){
						secIndex=[i,j,this.addon];									
						break;
					}else{
						if(!this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS){
							this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS=[];
						}
						for(let k=0; k<this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS.length; k++){
							if(this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k].id==id){
								secIndex=[i,j,k];
								break;
							}
						}
					}
				}
			}
		}
		console.log(secIndex);
		return secIndex;
	}
	trackByFuntion(index, item) {
		return index;
	}
	async getSftContent(data){
		await this.getLibContent(data);
		if(data.CONTENT_HTML&&data.CONTENT_HTML.length>0){
			data.htmltext=this.sanitizer.bypassSecurityTrustHtml(data.CONTENT_HTML);
		}
		
	}
	checkLib(){
		if(this.libraries.length==0||this.filted){
			this.refreshLibs();
		}
	}
	uploadFile1(){
		this.uploading=true;
		let that=this;
		const files = this.file3.nativeElement.files; console.log(files);
		if(files.length==0){
			this.uploading=false;
		return
		}
		for (let file of files)  //for multiple files
		{
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
	}
		for (let file of files)  //for multiple files
		{
			let reader = new FileReader();  
			reader.onloadend = function(e) {
				
				let filedata = e.target.result.toString().split(',')[1];//
				let inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata}
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if(result.RESPONSE_STATUS=='N'){
						that.throwError(result);
						that.uploading=false;
						console.log(result.ERRORCODE)
					}else{
						that.uploading=false;
						that.newSlotFile.name=result.FILE_NAME;
						that.newSlotFile.url=result.FILE_URL;
						that.newSlotFile.ext=result.FILE_EXTENSION;console.log(that.newSlotFile)
					}					
				})			
		}
		reader.readAsDataURL(file);
		} 
  }
  uploadPdf(){console.log(this.selectIndex);
		this.uploading=true;
		let that=this;
		const files = this.file4.nativeElement.files; console.log(files);
		if(files.length==0){
			this.uploading=false;
		return
		}
		for (let file of files)  //for multiple files
		{
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
	}
		for (let file of files)  //for multiple files
		{
			let reader = new FileReader();  
			reader.onloadend = function(e) {
				
				let filedata = e.target.result.toString().split(',')[1];//
				let inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata}
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if(result.RESPONSE_STATUS=='N'){
						that.throwError(result);
						that.uploading=false;
						console.log(result.ERRORCODE)
					}else{console.log(that.selectIndex);
						if(that.curDoc){
							that.curDoc.pdf=result.FILE_URL;
							that.curDoc.pdfName=result.FILE_NAME;
							that.uploading=false;
						}else{
							that.frontpages[that.selectIndex].pdf=result.FILE_URL;
							that.frontpages[that.selectIndex].pdfName=result.FILE_NAME;
							that.uploading=false;console.log(that.frontpages);
						}						
					}
				})			
		}
		reader.readAsDataURL(file);
		} 
  }
  /*editCell(doc, e, x, y){
		console.log(doc, x, y);
		if(doc.TYPE!=='TABLE'||(doc.data.parent_table&&doc.data.parent_table.length>0)){
			return
		}
		this.cellShow=true;
		this.curSec=doc;
		this.selectedCell={'row':x,'col':y};
	}*/
	cellData(e, id?){//console.log(e, id)
		//console.log(this.selectedCell);
		this.pageIndex=this.getFrontIdIndex(id);//console.log('first',this.pageIndex);
		this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex);
		let tableclass=this.getContentData('tableClass');//console.log('tableclass',tableclass);
		//console.log('first',this.curIndex);
		this.selectedRow=-1;//this.selectedCell.row;
		let data=this.sanitizer.bypassSecurityTrustHtml(e);
		if(this.pageIndex[0]>-1){
			this.toFContentData('htmltext', e, '',this.pageIndex);
			this.toFContentData('', data, '', this.pageIndex);
		}else if(this.curIndex[0]>-1){
			if(tableclass){
				this.toContentData('htmltext', e, '',this.curIndex);
				this.toContentData('secHtml', data, '', this.curIndex);
			}else{
				this.toContentData('htmltext', e, '',this.curIndex);
				this.toContentData('', data, '', this.curIndex);
			}
			
		}
		let ids=this.getAllSlotId(e); console.log(ids);
		let docSlot=[];
		if(ids&&ids.length>0){
			for(let id of ids){
				let index=this.slots.findIndex(slot=>slot.SLOT_ID==id);
				if(index>-1){
					docSlot.push(this.slots[index]);
				}
			
		}
		//console.log(docSlot)
		if(docSlot.length>0){
			if(this.pageIndex[0]>-1){
				this.toFContentData('slots', docSlot, '', this.pageIndex);
			}else if(this.curIndex[0]>-1){console.log(this.selectedCell);
				this.toContentData('slots', docSlot, '', this.curIndex);
			}			
		}
	}	
  }
	toCell(id){
		/*this.pageIndex=this.getFrontIdIndex(id);console.log('first',this.pageIndex);
		this.curIndex=this.getIdIndex(id);console.log('first',this.curIndex);
		let data:any;
		if(this.pageIndex[0]>-1){
			data=this.getFContentData('data'); console.log(data);
		}else if(this.curIndex[0]>-1){
			data=this.getContentData('data'); console.log(data);
		}
		if(this.allRow){
			for(let row of data.rows[this.selectedCell.row].items){
				row.bkcolor=this.curCell.bkcolor
			}
		}
		if(this.allCol){
			for(let row of data.rows){
				if(row.items[this.selectedCell.col]){
					row.items[this.selectedCell.col].bkcolor=this.curCell.bkcolor
				}
			}
		}
		let overallRatecell=data.rows[this.selectedCell.row][this.selectedCell.col]; //console.log(overallRatecell)
		if(overallRatecell){
			if(overallRatecell.KEY=="overallRating"){
			let titletable=this.getSecbyId(this.contents, 'fme_exec_sum_title_2');
			for(let row of titletable.data.rows){console.log(row)
				for(let item of row){
					if (item.KEY=="overallRating"){
						item.data=overallRatecell.data;
						delete item.htmltext;
						delete item.DATA;
					}
				}
			}
		}else if(overallRatecell&&(overallRatecell.KEY=="Source"||overallRatecell.KEY=="Srouce")){
			let id=data.rows[this.selectedCell.row][0].id;
			let ulItem=this.getSecbyId(this.contents, id);console.log(ulItem)
			ulItem.ul['Source']=overallRatecell.data;						
		}
		}
		
		this.curCellBK=null;
		this.cellShow=false;
		this.curCell=null; */
		/*this.autoSave();*/
		this.cellsaveErr=false;
		setTimeout(() => {
			if(this.curCell['DATA']&&this.curCell['htmltext']!=this.curCell['DATA']['changingThisBreaksApplicationSecurity']){
				this.cellsaveErr=true;
				return
			}
			let data:any;
			this.pageIndex=this.getFrontIdIndex(id);//console.log('first',this.pageIndex);
			this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex);
			if(this.pageIndex[0]>-1){
				//this.pageIndex=this.getFrontIdIndex(id);//console.log('first',this.pageIndex);
				data=this.getFContentData('data'); //console.log(data);
			}else if(this.curIndex[0]>-1){
				//this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex);
				data=this.getContentData('data'); //console.log(data);
			}
				if(this.allRow){
					for(let row of data.rows[this.selectedCell.row].items){
						row.bkcolor=this.curCell.bkcolor
					}
				}
				if(this.allCol){
					for(let row of data.rows){
						if(row.items[this.selectedCell.col]){
							row.items[this.selectedCell.col].bkcolor=this.curCell.bkcolor
						}
					}
				}
				console.log(this.curCell)
				this.curCell=null;
				let overallRatecell=data.rows[this.selectedCell.row][this.selectedCell.col]; console.log(overallRatecell)		
				if(overallRatecell&&overallRatecell.KEY=="overallRating"){
					let titletable=this.getSecbyId(this.contents, 'fme_exec_sum_title_2');
					for(let row of titletable.data.rows){console.log(row)
						for(let item of row){
							if (item.KEY=="overallRating"){
								item.data=overallRatecell.data;
								delete item.htmltext;
								delete item.DATA;
							}
						}
					}
				}else if(overallRatecell&&(overallRatecell.KEY=="Source"||overallRatecell.KEY=="Srouce")){
					let id=data.rows[this.selectedCell.row][0].id;
					let ulItem=this.getSecbyId(this.contents, id);console.log(ulItem)
					ulItem.ul['Source']=overallRatecell.data;	
				}
				this.curCellBK=null;
				console.log('modify',this.curSec.id, this.curSec.SECTION_TITLE, this.selectedEditor);
				this.cellShow=false;
				
			},200)
	}
	cellsaveErr=false;
	selectCell(doc, i, col, cell,table?){console.log(doc, i, col, cell)
		if(doc.TYPE=='4099e'&&(cell.ops||(!(cell.RF||cell.Manual)))||(doc['tableClass']=='PCA'&&doc.id!='pca_summary_0')){
			return
		}
		/*this.cellShow=true;
		this.curSec=doc;
		this.curCol=col;
		this.curCell=cell;
		console.log(this.curCell)
		this.curCellBK=JSON.parse(JSON.stringify(cell));
		this.allRow=false;
		this.allCol=false;
		let x=i;
		let y=doc.data.cols.findIndex(data=>data.INTERNALNAME==col.INTERNALNAME);
		this.selectedCell={'row':x,'col':y}; console.log(this.selectedCell);
		*/
		this.cellsaveErr=false;
		this.curId=doc.id;
		this.listid=doc.id;
		if(!this.tableShow){
			this.cellShow=true;
		}else if(this.curHeader){
			this.curHeader=false;
		}
		this.curSec=doc;
		this.curCol=col;
		this.curCell=cell;
		//if(this.curCap){
		//	this.curCap=null;
		//}
		this.curCellBK=JSON.parse(JSON.stringify(cell))
		this.allRow=false;
		this.allCol=false;
		let x=i;
		let y=doc.data.cols.findIndex(data=>data.INTERNALNAME==col.INTERNALNAME);
		this.selectedCell={'row':x,'col':y}; console.log(this.curCell);
		if(this.tableShow){
			this.preCell={'row':i,'col':y};
		}
	}
	headerShow=false;
	colIndex=-1;
	headerIndex=-1;
	selectCol(doc, i, col, type?, hindex?){
		console.log(doc, i, col, type, hindex);				
		/*this.headerShow=true;
		this.curSec=doc;
		this.curCol=col;
		this.curColBK=JSON.parse(JSON.stringify(col));
		this.colIndex=i;*/
		if(doc.data['locked']){
			if(type){
				if(doc.data['locked'][type].indexOf(hindex)>-1){
					//Swal.fire('Header is locked!');
					return	
				}
				
			}else if(doc.data['locked']['header']){
				//Swal.fire('Header is locked!');
				return
			}
		}		
		if(!this.tableShow){
			this.headerShow=true;
		}else if(this.curCell){
			this.curCell=null;
		}
		//if(this.curCap){
		//	this.curCap=null;
		//}		
		this.curSec=doc;
		if(type){
			this.selectedHeaderType=type;
			this.curHeader=true;			
			this.curCol=col;
			this.curColBK=JSON.parse(JSON.stringify(col))
			this.colIndex=i;
			this.headerIndex=hindex;
		}else{
			this.selectedHeaderType='';
			this.headerIndex=-1;
			//if(col['VH']){
			//	this.ifVH=true;
			//}else{
			//	this.ifVH=false;
			//}
			if(col['Lock']){
				this.ifLock=true;
			}else{
				this.ifLock=false;
			}
			this.curHeader=true;			
			this.curCol=col;
			this.curColBK=JSON.parse(JSON.stringify(col))
			this.colIndex=i;			
		}
		/*setTimeout(() => {
			this.hotkeyIcon.nativeElement.click();
		},1000)
		console.log(this.selectedHeaderType, this.headerIndex, this.curHeader, this.colIndex)*/
	}
	colText(e, type?){
		console.log(this.curSec);
		/*if(e.length>=0&&this.colIndex>-1){
			//console.log('first',this.curIndex);
			this.selectedRow=-1;//this.selectedCell.row;
			this.curSec.data.cols[this.colIndex].text=e;
		}*/
		if(e.length>=0&&this.colIndex>-1){
			////console.log('first',this.curIndex);
			this.selectedRow=-1;//this.selectedCell.row;
			if(type){
				this.curSec.data[type][this.headerIndex][this.colIndex].text=e;
			}else{
				this.curSec.data.cols[this.colIndex].text=e;
			}
			
		}
	}
	colData(e, id?, type?){console.log(e)
		console.log(this.curSec);
		/*if(e.length>=0&&this.colIndex>-1){
			this.curIndex=this.getIdIndex(id);console.log('first',this.curIndex)
			console.log('first',this.curIndex);
			this.selectedRow=-1;//this.selectedCell.row;
			this.curSec.data.cols[this.colIndex].NAME=e;
			this.curSec.data.cols[this.colIndex].htmltext=this.sanitizer.bypassSecurityTrustHtml(e);
		}*/
		if(e.length>=0&&this.colIndex>-1){
			this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex)
			//console.log('first',this.curIndex);
			this.selectedRow=-1;//this.selectedCell.row;
			if(type){
				this.curSec.data[type][this.headerIndex][this.colIndex].NAME=e;
				this.curSec.data[type][this.headerIndex][this.colIndex].htmltext=this.sanitizer.bypassSecurityTrustHtml(e);
			}else{
				this.curSec.data.cols[this.colIndex].NAME=e;
				this.curSec.data.cols[this.colIndex].htmltext=this.sanitizer.bypassSecurityTrustHtml(e);					
			}
			console.log(this.curSec.data)				
		}
	}
	toCol(id, type?){
		this.headerShow=false;
		this.curColBK=null;
		/*if(!type){
			if(this.ifVH){
				this.curSec.data.cols[this.colIndex]['VH']=true;
			}else{
				if(this.curSec.data.cols[this.colIndex]['VH']){
					delete this.curSec.data.cols[this.colIndex]['VH'];
				}
			}		
		}*/
		/*if(this.ifLock){
			this.curSec.data.cols[this.colIndex]['Lock']=true;
		}else{
			if(this.curSec.data.cols[this.colIndex]['Lock']){
				delete this.curSec.data.cols[this.colIndex]['Lock'];
			}
		}*/	
		if(this.autoFlag){
			this.autoSave();
		};
	}
	/*ifVH=false;
	secVH(e){
		if(e.target.checked){			
			this.ifVH=true;
		}else{
			this.ifVH=false;
		}
	}*/
	ifLock=false;
	setLock(e, cell){
		if(e.target.checked){			
			cell['lock']=true;
		}else{
			cell['lock']=false;
		}		
	}
	setrowLock(e, type, index?){console.log(this.curSec)
		e.preventDefault(); 
		let data=this.curSec.data;
		this.resetProp(this.curSec);
		this.resetProp(this.curSec, this.headertype[0])
		this.resetProp(this.curSec, this.headertype[1])
		this.curHeader=false;
		
		if(!data['locked']){
			data['locked']={'beforeHeaders':[],'afterHeaders':[],'header':false};
		}
		let lockedrow=data['locked'];
		if(type=='beforeHeaders'){
			let rindex=lockedrow['beforeHeaders'].indexOf(index);
			if(rindex>-1){
				lockedrow['beforeHeaders'].splice(rindex, 1);
			}else{
				lockedrow['beforeHeaders'].push(index);
			}
		}else if(type=='afterHeaders'){
			let rindex=lockedrow['afterHeaders'].indexOf(index);
			if(rindex>-1){
				lockedrow['afterHeaders'].splice(rindex, 1);
			}else{
				lockedrow['afterHeaders'].push(index);
			}
		}else if(type=='header'){
			lockedrow['header']=!lockedrow['header']

		}else if(type=='row'){
			if(data.rows[index]&&data.rows[index]['lock']){
			//let rindex=lockedrow['row'].indexOf(index);
			//if(rindex>-1){
				//lockedrow['row'].splice(rindex, 1);
				delete data.rows[index]['lock'];
			}else{
				//lockedrow['row'].push(index);
				data.rows[index]['lock']=true;
			}
		}
	}
   colReorder(e, id){
		console.log(e.dragIndex);
		console.log(e.dropIndex);
		console.log(e.columns);// Columns array after reorder
		/*for(let i=0; i<e.columns.length; i++){
			let id='col'+i;
			e.columns[i].INTERNALNAME=id;
		}*/
		for(let row of this.curSec.data.rows){
			moveItemInArray(row.items, e.dragIndex, e.dropIndex);
			/*for(let j=0; j<row.items.length; j++){
				let id='col'+j;
				row.items[j].COLUMNINTERNALNAME=id;
			}*/
			
		}
		this.reorderTableData(this.curSec.data)
   }
   rowReorder(e){console.log(e);
	   console.log(e.dragIndex);
		console.log(e.dropIndex);
   }
   colResize(e, doc){//console.log(e);
	   //console.log(e.element);
	   this.curSec=doc;
	   let ele=e.element;
	   let wi=ele.style.width; //console.log(wi);
	    let pagewidth=816-parseInt(this.pageMargin.right)-parseInt(this.pageMargin.left);
	  
	   let items=$(ele).parent().children(); //console.log(items);
	   for(let i=1; i<items.length; i++){
		   let cellWidth=items[i].offsetWidth; //console.log(cellWidth)
		   let val=Math.round(cellWidth/pagewidth*100); console.log(val)
		   this.curSec.data.cols[i-1].width=val;
		   this.curSec.data.cols[i-1].unit='%';
	   }
		
   }
   selectedrows=[];
   selectedHeaderType='';
   selectedHRow=-1;
   headertype=['beforeHeaders','afterHeaders'];
   selectToggle(e, doc, index, type?){console.log(doc, index)
		e.stopPropagation();
		if(type){
			if(doc.data['locked']&&doc.data['locked'][type].indexOf(index)>-1){
				//Swal.fire('This header is locked!');
				return
			}
			this.resetProp(doc);
			if(this.headertype.indexOf(type)>0){
				this.resetProp(doc, this.headertype[0])
			}else{
				this.resetProp(doc, this.headertype[1])
			}
			let selectedrows=[];
			this.selectedRow=-1;
			this.selectedHeaderType=type;
			let selectedHRows=[];
			this.selectedHRow=index;
			if(e.ctrlKey){
				doc.data[type][index]['selected']=!doc.data[type][index]['selected'];
				for(let i=0; i<doc.data[type].length; i++){
					if(doc.data[type][i]['selected']){
						selectedHRows.push(i);
					}
				}
				////console.log(selectedrows)
				if(selectedHRows.length==1){
					this.selectedHRow=selectedHRows[0];
				}else{
					this.selectedHRow=-1;
				}
			}else{
				for(let i=0; i<doc.data[type].length; i++){
					if(i!=index){
						doc.data[type][i]['selected']=false
					}else{
						doc.data[type][i]['selected']=!doc.data[type][i]['selected'];
						if(doc.data[type][i]['selected']){
							this.selectedHRow=index;
						}
					}
				}
			}
			console.log(this.selectedHeaderType,this.selectedHRow, selectedHRows )
		}else{
			/*if(doc.data['locked']&&doc.data['locked']['row'].indexOf(index)>-1){
				Swal.fire('This row is locked!');
				return
			}*/
			if(doc.data&&doc.data.rows[index]&&doc.data.rows[index]['lock']){
				//Swal.fire('Row is locked!');
				return
			}
			this.resetProp(doc, this.headertype[0])
			this.resetProp(doc, this.headertype[1])
			this.selectedHeaderType=''
			let selectedrows=[];
			this.selectedRow=-1;
			if (e.ctrlKey) {
				doc.data.rows[index]['selected']=!doc.data.rows[index]['selected'];
				for(let i=0; i<doc.data.rows.length; i++){
					if(doc.data.rows[i]['selected']){
						selectedrows.push(i);
					}
				}
				////console.log(selectedrows)
				if(selectedrows.length==1){
					this.selectedRow=selectedrows[0];
				}else{
					this.selectedRow=-1;
				}				
			}else{
				for(let i=0; i<doc.data.rows.length; i++){
					if(i!=index){
						doc.data.rows[i]['selected']=false
					}else{
						doc.data.rows[i]['selected']=!doc.data.rows[i]['selected'];
						if(doc.data.rows[i]['selected']){
							this.selectedRow=index;
						}
					}
				}
			}
		}
		
		this.curSec=doc;
		this.preCell={'row':0,'col':0};
		if(this.curCell){
			this.curCell=null;			
		}else if(this.curHeader){
			this.curHeader=null
		}//else if(this.curCap){
		//	this.curCap=null;
		//}

	//=========old version
		/*e.stopPropagation();
		this.selectedRow=-1
		let selectedrows=[];
		if (e.ctrlKey) {
			doc.data.rows[index]['selected']=!doc.data.rows[index]['selected'];
			for(let i=0; i<doc.data.rows.length; i++){
				if(doc.data.rows[i]['selected']){
					selectedrows.push(i);
				}
			}
			console.log(selectedrows)
			if(selectedrows.length==1){
				this.selectedRow=selectedrows[0];
			}else{
				this.selectedRow=-1;
			}
			
		}else{
			for(let i=0; i<doc.data.rows.length; i++){
				if(i!=index){
					doc.data.rows[i]['selected']=false
				}else{
					doc.data.rows[i]['selected']=!doc.data.rows[i]['selected'];					
				}
				if(doc.data.rows[i]['selected']){console.log(i)
					this.selectedRow=index;
				}//else{
				//	this.selectedRow=-1;
				//}
			}			
		}
		this.curSec=doc;
		console.log(this.selectedRow)
		console.log(doc);*/
   }
	deleteRows(doc){console.log(doc)
	   	let totals=[];
		for(let i=0; i<doc.data.rows.length; i++){
			if(doc.data.rows[i].selected){
				totals.push(i); 
			}
		}
		let that=this;
		if(totals.length>0){
			Swal.fire({
				icon:'info',
				title: 'Are you sure you want to delete '+totals.length+' item(s)?',
				confirmButtonText: 'Delete',
				showLoaderOnConfirm: true,
				showCancelButton: true,
				backdrop:false,
				preConfirm: () => {
					doc.data.rows=doc.data.rows.filter(row => row.selected!=true);				
				}
			})
		}else{
			Swal.fire({
				icon:'info',
				title: 'Please select row(s) you want to delete.',
			})
		}
   }
	addCSub(e){
		let posi=$(e.target).prev('select').val();console.log(posi)
		let data=this.curSec.data;//this.getContentData('data'); console.log(data);
		let rowData={'items':[]};
		let row=[{'COLUMNINTERNALNAME':data.cols[0].INTERNALNAME,'data':'', 'celAllign':posi, 'colspan':data.cols.length, 'DATA': {changingThisBreaksApplicationSecurity: ''},htmltext: ""}];
		let key=data.cols[0].INTERNALNAME;
		rowData[key]='';
		rowData.items=row;
		if(this.selectedRow>-1){
			if(this.addBefore){
						data.rows.splice(this.selectedRow,0,rowData);
						this.selectedRow+=1;
					}else{
						data.rows.splice(this.selectedRow+1,0,rowData);
					}
		}else{
			if(this.addBefore){
						data.rows.splice(data.rows.length-1,0,rowData);
						//this.selectedRow=data.rows.length;console.log(this.selectedRow);
					}else{
						data.rows.push(rowData);
					}
		}		
	}
	addCRows(e){console.log(this.selectedRow)
		let no=$(e.target).prevAll('input').val(); console.log($(e.target).prev('input'));console.log(no);
		if(no>0){
			let data=this.curSec.data;//this.getContentData('data'); console.log(data);
			if(this.curSec.id=='pca_summary_0'){
				let data=this.curSec.data;
				for(let i=0; i<no; i++){
        			let baserow=JSON.parse(JSON.stringify(this.reportService.summaryTable[0].baserow));
       				if(this.selectedRow>-1){
						if(this.addBefore){
							data.rows.splice(this.selectedRow,0,baserow);
							this.selectedRow+=1;
						}else{
							data.rows.splice(this.selectedRow+1,0,baserow);
						}
					}else{
						if(this.addBefore){
							data.rows.splice(data.rows.length-1,0,baserow);							
						}else{
							data.rows.push(baserow);
						}
						
					}
				
				}
			}else{

			
			for(let i=0; i<no; i++){
				let row=[];
				let rowData={'items':[]};
				for(let j=0; j<data.cols.length; j++){
					let item={'COLUMNINTERNALNAME':'','data':''};
					item.COLUMNINTERNALNAME=data.cols[j].INTERNALNAME;
					rowData[data.cols[j].INTERNALNAME]='';
					if(data.cols[j].DefaultFO&&data.cols[j].DefaultFO.html){
						item.data=data.cols[j].DefaultFO.data
						item['htmltext']=data.cols[j].DefaultFO.html;
						item['DATA']=this.sanitizer.bypassSecurityTrustHtml(item['htmltext']);
						item['slots']=data.cols[j].DefaultFO.slots;

					}	
					console.log(item)
					row.push(item);
				}
				rowData.items=row;
				if(this.selectedRow>-1){
					if(this.addBefore){
						data.rows.splice(this.selectedRow,0,rowData);
						this.selectedRow+=1;
					}else{
						data.rows.splice(this.selectedRow+1,0,rowData);
					}
				}else{
					if(this.addBefore){
						data.rows.splice(data.rows.length-1,0,rowData);
						
					}else{
						data.rows.push(rowData);
					}
					
				}
				
			}
		}
		}
	}
	hideRows(doc){
		let totals=[];
		for(let i=0; i<doc.data.rows.length; i++){
			if(doc.data.rows[i].selected){
				totals.push(i); 
			}
		}
		let that=this;
		if(totals.length>0){
			for(let row of doc.data.rows){
				if(row.selected){
					row['hide']=!row['hide']; 
					//row.selected=false;
				}
			}
		}else{
			Swal.fire({
				icon:'info',
				title: 'Please select row(s) you want to hide.',
			})
		}
		
	}
	resetProp(doc, type?){
		if(type){console.log(type)
			if((doc.TYPE=='TABLE'&&doc.data&&(!doc.erisName))){
				this.curSec=doc;
				this.curCell=null;
				if(doc.data[type]&&doc.data[type].length>0){
					for(let header of doc.data[type]){
						header.selected=false;
					}
				}
				
			}
		}else{
			if((doc.TYPE=='TABLE'&&doc.data&&(!doc.erisName))||doc.tableClass){
				this.curSec=doc;
				this.curCell=null;
				for(let row of doc.data.rows){
					row.selected=false;
				}
			}	
			this.selectedRow=-1;
		}
	}
	withBorder:false;
	addHBefore:false;
	addHeaders(e){
		let data=this.curSec.data;
		let posi=$(e.target).prev('select').val();
		let targetset=[]
		if(this.addHBefore){
			if(!data['beforeHeaders']){
				data['beforeHeaders']=[];
			}
			targetset=data['beforeHeaders'];
		}else{
			if(!data['afterHeaders']){
				data['afterHeaders']=[];
			}
			targetset=data['afterHeaders'];
		}
		let headerRow=[]
		for(let j=0; j<data.cols.length; j++){//console.log(data.cols[j])
			let item={'INTERNALNAME':'','NAME':'<p>Header'+j+'</p>', 'text':'Header'+j, 'htmltext':{changingThisBreaksApplicationSecurity: '<p>Header'+j+'</p>'}};
			item.INTERNALNAME=data.cols[j].INTERNALNAME;
			item['colAlign']=data.cols[j].colAlign;
			item['unit']=data.cols[j].unit;
			item['width']=data.cols[j].width;
			headerRow.push(item);
		}
		targetset.push(headerRow);		console.log(targetset)		
}
	addHSub(e){
		let data=this.curSec.data;
		let posi=$(e.target).prev('select').val();console.log(posi)
		let targetset=[]
		if(this.addHBefore){
			if(!data['beforeHeaders']){
				data['beforeHeaders']=[];
			}
			targetset=data['beforeHeaders'];
		}else{
			if(!data['afterHeaders']){
				data['afterHeaders']=[];
			}
			targetset=data['afterHeaders'];console.log(targetset)
		}
		let headerRow=[]
		//for(let j=0; j<data.cols.length; j++){//console.log(data.cols[j])
			//let item={'COLUMNINTERNALNAME':'','data':'', 'text':'', 'htmltext':'', 'celAllign':posi, 'colspan':data.cols.length};
			//let item={'COLUMNINTERNALNAME':'','data':'<p>Header</p>', 'text':'Header', 'htmltext':{changingThisBreaksApplicationSecurity: '<p>Header</p>', 'celAllign':posi, 'colspan':data.cols.length}};
			let item={'INTERNALNAME':'','NAME':'<p>Header</p>', 'text':'Header', 'htmltext':{changingThisBreaksApplicationSecurity: '<p>Header</p>'}, 'colAlign':posi, 'colspan':data.cols.length};
			item.INTERNALNAME=data.cols[0].INTERNALNAME;
			//item['colAlign']=data.cols[j].colAlign;
			//item['unit']=data.cols[j].unit;
			//item['width']=data.cols[j].width;
			headerRow.push(item);
		//}
		targetset.push(headerRow);		console.log(targetset)
	}
	/*addCap(e, doc){
		let data=this.curSec.data;
		if(e.target.checked){
			data['caption']={'NAME':'<p>Table Caption</p>', 'text':'Table Caption', 'htmltext':{changingThisBreaksApplicationSecurity: '<p>Table Caption</p>'}, 'border':false, 'align':'center'};		
			this.curCell=null;
			this.selectedCell=null;
			this.curCap=data['caption'];
		}else{
			this.deleteCap(doc);
		}	
	}
	deleteCap(doc){
		let data=this.curSec.data;
		if(data['caption']){
			this.curSec.data['caption']=null;
			delete data['caption'];
			this.curCap=null;
		}
	}
	curCap=null;
	selectCap(doc){
		console.log(doc);
		if(this.headerShow){
			this.headerShow=false;
		}else if(this.curCell){
			this.curCell=null;
		}else if(this.curHeader){
			this.curHeader=false
		}
		if(this.selectedHeaderType){
			this.selectedHeaderType='';
		}
		this.curCapBK=JSON.parse(JSON.stringify(doc.data['caption']));
		this.curCap=doc.data['caption'];
		this.curSec=doc;
	}
	capData(e, id){
		if(e.length>=0){
			this.curSec.data['caption'].NAME=e;
			this.curSec.data['caption'].htmltext=this.sanitizer.bypassSecurityTrustHtml(e);
			this.curSec.data['caption'].border=this.curCap.border;			
		}
	}
	capText(e, id){
		if(e.length>=0){
			this.curSec.data['caption']['text']=e;			
		}
	}
	curCapBK=null;
	closeCap(){
		setTimeout(() => {
			let id=this.curSec.id;			
				let text="";
				if(this.curCapBK['NAME']){
					let item={'NAME':'', 'text':'', 'htmltext':{changingThisBreaksApplicationSecurity: '', 'border':false}};		
					if(this.curCapBK['NAME']){
						item['html']=this.curCapBK['NAME']
					}
					if(this.curCapBK['text']){
						item['text']=this.curCapBK['text'];
					}
					if(this.curCapBK['htmltext']){
						item['htmltext']=this.curCapBK['htmltext'];
					}
					if(this.curCapBK['border']){
						item['border']=this.curCapBK['border'];
					}
					this.capData(text, id);					
				}					
			
			this.curCapBK=null;
			this.curCap=null;
			}, 200)
	}
	toCap(id){
		setTimeout(() => {
			this.headerShow=false;
			this.curCapBK=null;			
			this.curCap=null;
		}, 200)
	}*/
	deleteHeaders(doc){
		let totals=[];
		for(let type of this.headertype){
			if(doc.data[type]&&doc.data[type].length>0){
				for(let i=0; i<doc.data[type].length; i++){
					if(doc.data[type][i].selected){
						totals.push(i);
					}
				}
			}
		}
		
		
		let that=this;
		if(totals.length>0){
			Swal.fire({
				icon:'info',
				title: 'Are you sure you want to delete '+totals.length+' item(s)?',
				confirmButtonText: 'Delete',
				showLoaderOnConfirm: true,
				showCancelButton: true,
				backdrop:false,
				preConfirm: () => {
					for(let type of this.headertype){
						if(doc.data[type]&&doc.data[type].length>0){ 
							doc.data[type]=doc.data[type].filter(header => header.selected!=true);
						}						
					}
					
					if(this.tableShow){
						this.preCell={'row':0,'col':0};
						this.curCell=null;
					}
				}
			})
		}else{
			Swal.fire({
				icon:'info',
				title: 'Please select row(s) you want to delete.',
			})
		}
	}
	resetHProp(doc){
		if((doc.TYPE=='TABLE'&&doc.data&&(!doc.erisName))||doc.tableClass){
			this.curSec=doc;
			this.curCell=null;
			for(let row of doc.data.rows){
				row.selected=false;
			}
		}
	}
	selectHToggle(e, doc, index){//console.log(doc, index)
		e.stopPropagation();
		let selectedrows=[];
		this.selectedRow=-1;
		if (e.ctrlKey) {
			doc.data.rows[index]['selected']=!doc.data.rows[index]['selected'];
			for(let i=0; i<doc.data.rows.length; i++){
				if(doc.data.rows[i]['selected']){
					selectedrows.push(i);
				}
			}
			////console.log(selectedrows)
			if(selectedrows.length==1){
				this.selectedRow=selectedrows[0];
			}else{
				this.selectedRow=-1;
			}
			
		}else{
			for(let i=0; i<doc.data.rows.length; i++){
				if(i!=index){
					doc.data.rows[i]['selected']=false
				}else{
					doc.data.rows[i]['selected']=!doc.data.rows[i]['selected'];
					if(doc.data.rows[i]['selected']){
						this.selectedRow=index;
					}
				}
			}
		}
		this.curSec=doc;

   }
	addToIden(label, id){
		let ele='#'+id;
		let text=$(ele).val();console.log(text);
		if(text.length>0){
			text=text+'; '+label;
		}else{
			text=label;
		}
		$(ele).val(text);		
	}
	pageData(e, index, index1?){
		//console.log('page', e, index); 
		this.curIndex=[this.addon,this.addon,this.addon];
		let data=this.sanitizer.bypassSecurityTrustHtml(e);
		if(index1>-1){
			this.frontpages[index].SUB_SECTIONS[index1]['text']=e;
			this.frontpages[index].SUB_SECTIONS[index1]['htmltext']=data;
		}else{
			this.frontpages[index]['text']=e;
			this.frontpages[index]['htmltext']=data;
		}
		let ids=this.getAllSlotId(e); console.log(ids);
		let docSlot=[];
		if(ids&&ids.length>0){
			for(let id of ids){
				let sindex=this.slots.findIndex(slot=>slot.SLOT_ID==id);
				if(sindex>-1){
					docSlot.push(this.slots[sindex]);
				}
			
			}		
		}
		if(index1>-1){
			this.frontpages[index].SUB_SECTIONS[index1]['slots']=docSlot;
		}else{
			this.frontpages[index]['slots']=docSlot;
		}	
		if(this.autoFlag){
			this.autoSave();
		};
	}
	/*pageData(e, index){
		console.log('page', e, index); 
		this.curIndex=[this.addon,this.addon,this.addon];
		let data=this.sanitizer.bypassSecurityTrustHtml(e);
		this.frontpages[index]['text']=e;
		this.frontpages[index]['htmltext']=data;
		let ids=this.getAllSlotId(e); console.log(ids);
	
		let docSlot=[];
		if(ids&&ids.length>0){
			for(let id of ids){
				let index=this.slots.findIndex(slot=>slot.SLOT_ID==id);
				if(index>-1){
					docSlot.push(this.slots[index]);
				}
			
			}		
		}
		this.frontpages[index]['slots']=docSlot;
		if(this.autoFlag){
			this.autoSave();
		};
	}*/
	removePage(s){
		let that=this;
		let data=this.frontpages[s];
		let msg='Are you sure you want to delete this item?'
		if(data.TYPE=='PISUMMARY'){
			msg='Delete Project Summary Section will remove all related data, Are you sure you want to delete this section?'
		}
		Swal.fire({
			icon:'warning',
			title: msg,
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				if(data.TYPE=='PISUMMARY'){
					for(let doc of this.contents){
						if(doc.pisummarydata){
							delete doc.pisummarydata;
						}
						if(doc.SUB_SECTIONS&&doc.SUB_SECTIONS.length>0){
							for(let doc1 of doc.SUB_SECTIONS){
								if(doc1.pisummarydata){
									delete doc1.pisummarydata;
								}
		
								if(doc1.SUB_SECTIONS&&doc1.SUB_SECTIONS.length>0){
									for(let doc2 of doc1.SUB_SECTIONS){
										if(doc2.pisummarydata){
											delete doc2.pisummarydata;
										}
									}
								}
							}
						}
					}
					this.summaryStatus=false;
				}
				that.frontpages.splice(s, 1);	
				this.checkifSign();		
			}	
		})			
	}
	changeSrc(e, page, src){
		if($(e.target).prop('checked')){
			page['pageSrc']=src;
		}else{
			page['pageSrc']='letter_style';
		}
	}
	showPages(){
		console.log(this.frontpages)
	}
	
	pdfFname={"text":'<p><span class="placeholder" data-id="1" data-type="text" data-status="N">{Project Number/Name}</span>-<span class="placeholder" data-id="8" data-type="text" data-status="N">{Property Address}</span></p>',
	'reqIndex':0, "name":'{Project Number/Name}-{Property Address}'};
	pdfData(e){
		console.log(e)
		this.pdfFname.text=e;
		//this.pdfFname.htmltext=this.sanitizer.bypassSecurityTrustHtml(e);
	}
	pdfPara(e){
		console.log(e);
		if(e.length>0){
			this.pdfFname.name=e;
		}
	}
	savepdf(){
		this.pdfFname.reqIndex++;
	}
	sideNavWidth = '60px'
	toggleSideBarVar = false
	toggleSideBar(){
		if(this.toggleSideBarVar == false) {
			this.sideNavWidth = '400px'
			this.toggleSideBarVar = true
		} else if(this.toggleSideBarVar == true) {
			this.sideNavWidth = '60px'
			this.toggleSideBarVar = false
		}
	}
	editAuthor(e, photo){
		if(e.length>0){
			photo['AUTHOR']=e;
		}else{
			photo['AUTHOR']='Author';
		}
	}
	selectedSign:number;
	signStyles=[];
	getSignStyles(id){
		let inputJson={"PROCEDURE":"getsignaturestylelist","USER_ID":parseInt(this.userId), "TEMPLATE_ID":parseInt(id)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				console.log(data)
				this.signStyles=data.RW_SIGNATURE_STYLES;
			}
		})	
	}
	signInfo:any;
	getSignInfo(id){
		let inputJson={"PROCEDURE":"getsignaturerelatedinfo","USER_ID":parseInt(this.userId),"TEMPLATE_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {console.log(data)
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				this.signInfo=data;				
			}
		})
	}
	defaultSign:any;
	async getSignContent(id){
		let inputJson={"PROCEDURE":"getsignaturestyle","USER_ID":parseInt(this.userId),"SIGNATURE_STYLE_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				let htmlstring=atob(data.SIGNATURE_STYLE_TEMPLATE);
				//let html=htmlstring.replace('{{NAME}}', "Add Your Name Here").replace('{{TITLE}}', "Add Your Title Here")
				this.defaultSign['SIGNATURE_STYLE_TEMPLATE_HTML']=htmlstring;
				this.defaultSign['SIGNATURE_STYLE_TEMPLATE']=this.sanitizer.bypassSecurityTrustHtml(htmlstring);		
				//console.log(this.defaultSign)	
			}
		})
	}
	allowProfileChange=true;
	checkProfile(){
		let addedSigns=this.getAllsigns(); 
		if(addedSigns){
			this.allowProfileChange=false
		}
		if(!this.signStyles){
			this.getSignStyles(this.tempInfo.TEMPLATE_ID)
		}
	}
	checkifSign(){
		let addedSigns=this.getAllsigns()
		if(addedSigns){
			this.allowProfileChange=false;
		}else{
			this.allowProfileChange=true
		}
	}
	getAllsigns(){
		let haveSigns=false
		for(let sec of this.frontpages){
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='SIGNS'&&sec1.signs.length>0){
						haveSigns=true;
						break
					}
				}
			}		
		}
		for(let sec of this.contents){
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='SIGNS'&&sec1.signs.length>0){
						haveSigns=true;
						break
					}
					if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
						for(let sec2 of sec1.SUB_SECTIONS){
							if(sec2.TYPE=='SIGNS'&&sec2.signs.length>0){
								haveSigns=true;
								break
							}				
						}
					}
				}
			}			
		}
		return haveSigns
	}
	async addSeal(type){
		this.selectedCell=null;
		if(this.pageIndex[0]>-1||this.curIndex[0]>-1){
		let item={'TITLE':'Add Your Title Here', 'FILE_URL':"", 'NAME':'Add Your Name Here', 'TYPE':type};		
		let field="";
		if(type=='seal'){
			item.FILE_URL='/assets/images/seal.jpg';
			field='seals';
		}else if(type=='signature'){
			field='signs';
			if(this.defaultSign['SIGNATURE_STYLE_ID']){
				item['signatureTemplate']=true;
				item['html']=this.defaultSign['SIGNATURE_STYLE_TEMPLATE_HTML'];
				item['htmlSec']=this.defaultSign['SIGNATURE_STYLE_TEMPLATE'];	
				item['label']="Signature Label";		
				item['role']='';
				item['roleName']='';
				item['ALIGN']=this.tempInfo.SIGNATURE_ALIGNMENT_CODE;						
			}else{
				item.FILE_URL='/assets/images/signature.jpg';				
				if(this.tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'){
					item['AUTHOR']='Author';
					item['ALIGN']='L'
				}else if(this.tempInfo&&(!isNaN(this.tempInfo['SPECIAL_SIGNATURE_FORMAT']))){
					item['underline']=true;
					item['ALIGN']='L'
				}
			}			
		}
		let added=[];
		if(this.selectedEditor=='F'){
			let type1=this.getFContentData('TYPE'); console.log(type1);
			if((type1=='SEALS'&&type=='seal')||(type1=='SIGNS'&&type=="signature")){
				added=this.getFContentData(field);console.log(added);
			}else{
				if(type=='seal'){
					this.addSeals();
				}else if(type=='signature'){
					this.addSigns();
				}
			}			
		}else if(this.selectedEditor=='O'){
			let type1=this.getContentData('TYPE'); console.log(type1);
			if((type1=='SEALS'&&type=='seal')||(type1=='SIGNS'&&type=="signature")){
				added=this.getContentData(field);console.log(added)				
			}else{
				if(type=='seal'){
					this.addSeals();
				}else if(type=='signature'){
					this.addSigns();
				}
			}			
		}
		added.push(JSON.parse(JSON.stringify(item)));
		setTimeout(() => {
			if(this.selectedEditor=='F'){
				this.toFContentData(field, added, '');console.log(added)
			}else if(this.selectedEditor=='O'){
				this.toContentData(field, added, '');
			}
			
		},1000);
		}else{
			Swal.fire({
					icon:'info',
					text: 'Please select a position for your signature/seal.',
			})					
			return
		}
	}
	signShow=false;
	curSign:any;
	editSign(photo){
		//this.getSignRoles();
		this.curSign=photo
		this.signShow=true
	}
	
	extractPositionFromHtml(htmlString: string): { offsetX: number } {
		if (!htmlString) return { offsetX: 0 };
		
		let offsetX = 0;
		
		const transformMatch = htmlString.match(/transform:\s*translateX\(([^)]+)\)/gi);
		if (transformMatch) {
			transformMatch.forEach(match => {
				const values = match.match(/translateX\(([^)]+)\)/i);
				if (values && values[1]) {
					const value = values[1].trim();
					offsetX = parseFloat(value) || 0;
				}
			});
		}
		
		return { offsetX };
	}
	
	getSignaturePosition(photo: any): { offsetX: number } {
		if (photo) {
			if (photo.html) {
				return this.extractPositionFromHtml(photo.html);
			}
		}
		return { offsetX: 0 };
	}	
	setSignRoleName(e){
		let index=this.signInfo.RW_SIGNATURE_LABELS.findIndex(item=>item.SIGNATURE_LABEL_ID==this.curSign['role']);
		if(index>-1){
			this.curSign['roleName']=this.signInfo.RW_SIGNATURE_LABELS[index].SIGNATURE_LABEL_NAME;
		}		
	}
	saveSign(){
		let htmlstring=this.curSign['html'];
		let ele=$(htmlstring).find('#sig-label')[0];
		if(ele){
			let oldLabel=ele.innerHTML;
			this.curSign['html']=htmlstring.replace(oldLabel, this.curSign['label']);
			this.curSign['htmlSec']=this.sanitizer.bypassSecurityTrustHtml(this.curSign['html']);
		}
		
		this.signShow=false;
	}
	/*signatureroles=[];
	getSignRoles(){
		let inputJson={"PROCEDURE":"getsignaturelabels","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				this.signatureroles=data.RW_SIGNATURE_LABELS;
				
			}
		})				
	}*/
	resumeSec(e, item){
		if(e.target.checked){
			let hasResumeSection = this.appendices.SUB_SECTIONS.some(sec => sec['resume']);
			if(hasResumeSection){
				Swal.fire({
					icon:'info',
					html:'<p>Only One Resume Appendix Section Allowed</p>'
				});
				e.target.checked=false;
			}else{
				item["resume"]=true;
				this.appendices['addedResume']=true;				
			}
		}else{
			delete item["resume"];
			let hasResumeSection = this.appendices.SUB_SECTIONS.some(sec => sec['resume']);
			this.appendices['addedResume']=hasResumeSection;
		}
	}	
	removeSeal(type, photo, index){
		console.log(photo);
		console.log(this.curIndex)
		let added=[];
		if(this.selectedEditor=='F'){
			added=this.getFContentData(type);console.log(added)
		}else if(this.selectedEditor=='O'){
			added=this.getContentData(type);console.log(added);
		}
		//let index=added.findIndex(item=>item.FILE_URL==photo.FILE_URL);console.log(index)
		if(index>-1){
			added.splice(index, 1);			
		}
		if(this.selectedEditor=='F'){
			this.toFContentData(type, added, '');console.log(added)
		}else if(this.selectedEditor=='O'){
			this.toContentData(type, added, '');
		}
		if(type=='signs'){
			this.checkifSign();
		}
	}
	changeDesc(type, field,index, e, index1?, index2?, index3?){console.log(type, field,index, e, index1, index2, index3);
		this.selectedRow=-1;
		let datas:any;
		if(this.selectedEditor=='F'){
			datas=this.frontpages;
			//this.toFContentData('photos', added, '');console.log(added)
			this.pageIndex=[index1, index2, index3];
		
		}else if(this.selectedEditor=='O'){
			datas=this.contents;
			//this.toContentData('photos', added, '');
			this.curIndex=[index1, index2, index3];console.log(this.curIndex)
		
		}		
		if(index3>-1){
			datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3][type][index][field]=e;
		}else if(index2>-1){
			datas[index1].SUB_SECTIONS[index2][type][index][field]=e;
		}else{
			datas[index1][type][index][field]=e;
		}
		//this.autoSave();
	}
	clipboardText='';
	copyCell(data){
		console.log(data)
		if(data.htmltext){
			this.clipboardText=data.htmltext;
		}
	}
	pasteCell(data){
		//console.log(data)
		/*if(this.curSec.data&&this.curSec.data['locked']){
			let lockedrow=this.curSec.data['locked']['row'];
			if(lockedrow.indexOf(this.preCell['row'])>-1){
				Swal.fire('Row is locked, can not edit');
			return
			}
		}*/
		if(this.curSec.data&&this.curSec.data.rows[this.preCell['row']]&&this.curSec.data.rows[this.preCell['row']]['lock']){
			//Swal.fire('Row is locked, can not edit');
			return
		}
		if(this.curSec.data&&(!data['colspan']&&this.curSec.data.cols[this.preCell['col']]['lock'])){
			//Swal.fire('Column is locked, can not edit');
			return
		}
		if(data['lock']){
			//Swal.fire('Cell content is locked, can not edit');
			return
		}
		if(!data.htmltext){
			data.htmltext='';
		}
		if(this.clipboardText.length>0){
			data['htmltext']=this.clipboardText;
			data.DATA=this.sanitizer.bypassSecurityTrustHtml(data.htmltext);		
			let ids=this.getAllSlotId(this.clipboardText); //console.log(ids);
			let docSlot=[];
			if(ids&&ids.length>0){
				for(let id of ids){
					let index=this.slots.findIndex(slot=>slot.SLOT_ID==id);
					if(index>-1){
						docSlot.push(this.slots[index]);
					}
				}
			}
			if(docSlot.length>0){
				data['slots']=docSlot;
			}
		}
		
	}
	addCheckmark(data){
		console.log(data)
		if(!data.htmltext){
			data.htmltext='';
		}
		data.data='✓';
		data.htmltext=data.htmltext+'<span>✓</span>'
		data.DATA=this.sanitizer.bypassSecurityTrustHtml(data.htmltext);		
	}
	clearCheckmark(data){
		data.data='';
		data.htmltext='';
		data.DATA=null;		
	}
	saveMargin(type?){
		let margin={
				"TOC_MARGIN_TOP":this.tocMargin.top.toString(),
				"TOC_MARGIN_BOTTOM":this.tocMargin.bottom.toString(),
				"TOC_MARGIN_LEFT":this.tocMargin.left.toString(),
				"TOC_MARGIN_RIGHT":this.tocMargin.right.toString(),
				"REPORT_MARGIN_TOP":this.pageMargin.top.toString(),
				"REPORT_MARGIN_BOTTOM":this.pageMargin.bottom.toString(),
				"REPORT_MARGIN_LEFT":this.pageMargin.left.toString(),
				"REPORT_MARGIN_RIGHT":this.pageMargin.right.toString(),
		}			
		let inputJson={"PROCEDURE":"updatetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,  ...margin};
		//let inputJson = { "PROCEDURE": "updaterwprofile", "USER_ID": parseInt(this.userId), 'TEMPLATE_ID': this.tempInfo.TEMPLATE_ID, "COMPANY_ID": this.userInfo.COMPANY_ID.toString(), ...margin };
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("profile", data);
			if(data.RESPONSE_STATUS=='Y'){
				$('#marginModal').modal('hide')
			}else{
				this.throwError(data)
			}
		});
	}
	setToc(e){
		let val=e.target.value;
		let	inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"TOC_IND":val}
		console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);
				if(data.RESPONSE_STATUS=="Y"){
					this.tempInfo=data;
				}else{
					this.throwError(data)
				}
			})
	}
	closeCell(){		
		setTimeout(() => {
			this.curCell=null;
			this.cellShow=false;
			let id=this.curSec.id;
			let text="";		
			if(this.curCellBK['htmltext']){
				text=this.curCellBK['htmltext'];
				this.cellData(text, id);
			}else{
				this.cellData('', id);
			}				
			this.curCellBK=null;
		}, 200);		
	}
	closeCol(){
		setTimeout(() => {
			let id=this.curSec.id;
			let text="";
			if(this.curColBK['NAME']){
				text=this.curColBK['NAME']
			}		
			this.colData(text, id);
			this.autoSave();
			this.curColBK=null;
			}, 200);
		
	}
	filted=false;
	filterLibs(e){
		this.loading=true
		this.zone.run(()=>{this.loading=true;})
		let key="";
		if(e.target.tagName=='INPUT'){
			key=e.target.value.trim();;
		}else if(e.target.tagName=='I'){
			key=$(e.target).prev('input').val().trim();
		}else{
			key=$(e.target).val();
		}
		//let inputJson={"PROCEDURE":"getlibrary","USER_ID":parseInt(this.userId),"KEYWORD":key}
		let inputJson={"PROCEDURE":"getlibrarysimple", "USER_ID":parseInt(this.userId), "KEYWORD":key};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
				
			}else{
				this.libraries=data.RW_LIBRARY;
				if(key.length>0){
					this.filted=true;
				}else{
					this.filted=false;
				}
				
			}
			this.zone.run(()=>{this.loading=false;})
		})
	}
	saveBlack(){
		let printblack='N'
		if(this.blackText){
			printblack='Y';
		}
		let inputJson={"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"PRINT_BLACKWHITE":printblack}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{console.log(result)	
			if(result.RESPONSE_STATUS!="Y"){
				this.throwError(result)
			}		
		})
	}
	contentIndent=false;
	saveIndent(){
		let ifIndent='N'
		if(this.contentIndent){
			ifIndent='Y';
		}
		console.log(ifIndent)
		let inputJson={"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"BODYINDENT_SAME_STITLE":ifIndent}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{console.log(result)	
			if(result.RESPONSE_STATUS!="Y"){
				this.throwError(result)
			}		
		})
	}
	private throwError(data){
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			console.log('Timeout');
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
			this.cookieService.clearAll();
			this.router.navigate(['/']);			
		}else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}
	  }
	  errMsg='';
	  pdfType:any;
	  noPrint=false;
	  public preview(){
		this.errMsg='';
		this.itemIndex++;
		this.pdfType={'index':this.itemIndex, 'type':'temp'};
	  }
	  pdfSpin(e){
		if(e=='start'){
			this.pdfspin.nativeElement.style.display='inline';
			this.noPrint=true;
		}else{
			this.pdfspin.nativeElement.style.display='none'
			this.noPrint=false;
		}
	}
	showErrMsg(e){
		this.errMsg=e;
	}
	iniFme(){
		
		let item={'id':'4099eExcutive', 'TYPE':'4099e','DISPLAY_SEQUENCE': "Y",'SECTION_SEQUENCE': "1",'SECTION_TITLE': "Executive Summary",'SUB_SECTIONS':[], 'required':true};
		this.curIndex=[this.addon,this.addon,this.addon];
		this.selectedEditor='O';		
		this.contents.splice(0, 0, item);
		item={'id':'4099eEstimate', 'TYPE':'4099e','DISPLAY_SEQUENCE': "Y",'SECTION_SEQUENCE': "2",'SECTION_TITLE': "Cost Estimate Schedules - Immediate Repairs and Replacement of Capital Items",'SUB_SECTIONS':[], 'required':true};
		this.contents.splice(1, 0, item);
		this.addFTable();
	}
	
	
	addFTable(){
		for(let t of this.fmeService.tableSet){
			let item={'TYPE':'4099e',id:t.id, 'DISPLAY_SEQUENCE': t.displayseq,'SECTION_SEQUENCE': t.squence,'SECTION_TITLE': t.title,'SUB_SECTIONS':[],'OTNAME':false, 'TOC':true, 'required':t.required};
			for(let subt of this.fmeService.dataset[t.id]){
				let item1={'TYPE':'4099e',id:subt.id, 'DISPLAY_SEQUENCE': subt.displayseq,'SECTION_SEQUENCE': '','SECTION_TITLE': subt.title,'OTNAME':true, 'TOC':true, 'header':subt.header, 'data':subt, 'required':t.required, 'append':subt.append, 'appendtitle':subt.appendtitle, 'halfwidth':subt.halfwidth, 'noborder':subt.noborder};
				item.SUB_SECTIONS.push(item1)
			}
			this.contents[0].SUB_SECTIONS.push(item); console.log(this.contents[0]);
		}
		for(let t of this.fmeService.tableSet2){
			let item={'TYPE':'4099e',id:t.id, 'DISPLAY_SEQUENCE': t.displayseq,'SECTION_SEQUENCE': t.squence,'SECTION_TITLE': t.title,'SUB_SECTIONS':[],'OTNAME':false, 'TOC':true, 'required':t.required};
			for(let subt of this.fmeService.dataset[t.id]){
				let item1={'TYPE':'4099e',id:subt.id, 'DISPLAY_SEQUENCE': subt.displayseq,'SECTION_SEQUENCE': '','SECTION_TITLE': subt.title,'OTNAME':true, 'TOC':true, 'header':subt.header, 'data':subt, 'required':t.required,'append':subt.append, 'appendtitle':subt.appendtitle, 'halfwidth':subt.halfwidth, 'noborder':subt.noborder};
				item.SUB_SECTIONS.push(item1)
			}
			this.contents[1].SUB_SECTIONS.push(item); console.log(this.contents[1]);
		}
		
	}
	toIndex=[null,null,null];
	tomoveTitle='';
	toMove(doc){
		this.toIndex=[];
		if(doc.SECTION_SEQUENCE.length>0){
			this.tomoveTitle=doc.SECTION_SEQUENCE+'  '+doc.SECTION_TITLE;
		}else{
			this.tomoveTitle=doc.SECTION_TITLE;
		}
		
		this.curSec=doc;
		//this.toIndex.push(...this.curIndex);
		if(this.curIndex[2]>-1){
			this.toIndex[2]=this.curIndex[2]+1;
		}else{
			this.toIndex[2]=null;
		}
		if(this.curIndex[1]>-1){
			this.toIndex[1]=this.curIndex[1]+1;
		}else{
			this.toIndex[1]=null;
		}
		if(this.curIndex[0]>-1){
			this.toIndex[0]=this.curIndex[0]+1;
		}else{
			this.toIndex[0]=null;
		}
		//this.toIndex = Array.from(this.curIndex);
	}
	
	moveTo(id){
		console.log(this.toIndex)
		if(this.toIndex[2]>0){
			transferArrayItem(this.contents[this.curIndex[0]].SUB_SECTIONS[this.curIndex[1]].SUB_SECTIONS, this.contents[this.toIndex[0]-1].SUB_SECTIONS[this.toIndex[1]-1].SUB_SECTIONS, this.curIndex[2],this.toIndex[2]-1);
		}else if(this.toIndex[1]>0){
			transferArrayItem(this.contents[this.curIndex[0]].SUB_SECTIONS, this.contents[this.toIndex[0]-1].SUB_SECTIONS, this.curIndex[1],this.toIndex[1]-1);
		}else{
			moveItemInArray(this.contents, this.curIndex[0], this.toIndex[0]-1);
		}
		this.generateSeq();
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}
		}	
		
	}
	resetCostTable(){
		this.rowItem=JSON.parse(JSON.stringify(this.newRow));
		//this.rowItem.EFF=this.pcaOp.age;
		//this.rowItem.data[1].data=this.pcaOp.quantity
		
		for(let i=0; i<this.pcaOp.reserve; i++){
			this.rowItem.allocate.push(0);
		}
		this.curCost=null;
		$('input.yearbox').each(function(e){////console.log($(this)[0].checked);
			$(this).prop('checked', false);
		})
	}
	//fmeItem={'long':null, 'short':null};
	fmeCat=[];
	immiCategory=[];
	capitalCategory=[];
	ratingOps=[];
	conditionOps=[];
	actionItemOps=[];
	ulGroup=[]; 
	selFmeCost(doc, e){//console.log(e.target.value)
		let index=parseInt(e.target.value);
		if(index>-1){
			doc.long=this.capitalCategory[index].id
		}else{
			doc.long='';
		}
		//console.log(doc.long);	
	}
	selFmeUl(doc, e, type, op?, id?){console.log(doc, e)
		e.stopPropagation();
		let val:any;
		if(type=='ACTION'){
			val=e.value;
		}else if(type=='EUL'||type=='EFF'){
			val=e.target.value;
			if(val>0){
				if(!Number.isInteger(val)){
					val=Math.ceil(val).toString();
				}else{
					val=val.toString();
				}
			}else{
				val='0';
			}
			console.log(val)
		}else{
			val=e.target.value;
			setTimeout(() => {
				const el = this.elementRef.nativeElement.querySelector(
				`[data-id="${id}"]`
				) as HTMLElement;
    			if (el) {
					op.show(null, el); // reopen immediately
				}
			}, 500);
		}
		if(!doc['ul']){
			doc['ul']={'id':doc.id,'No':'', 'Item':doc.SECTION_TITLE, 'EUL':'', 'EFF':'','RUL':'', 'RATING':'','RERatio':'NA', 'ACTION':[], 'SecRef':doc.SECTION_SEQUENCE, 'cat':val};
		}
		if(val.length>0){
			doc['ul'][type]=val;
		}else{
			if(type=='cat'){
				delete doc.ul;
			}else{
				doc['ul'][type]='';
			}			
		}	
		//console.log(doc['ul']);	
		this.getTotalUl();	
	}
	getTotalUl(){
		let allUls=[];
		let ulgps=JSON.parse(JSON.stringify(this.ulGroup));console.log(ulgps)
		if (this.contents){
			for(let sec of this.contents){
				if(sec.ul&&sec.ul.Item.length>0){
					let item=JSON.parse(JSON.stringify(sec.ul));
					item['catIndex']=ulgps.findIndex(gp=>gp.label==item.cat);
					item.secRef=sec.SECTION_SEQUENCE;
					allUls.push(item)
				}
				if(sec.SUB_SECTIONS){				
					for(let sec1 of sec.SUB_SECTIONS){
						if(sec1.ul&&sec1.ul.Item.length>0){
							let item=JSON.parse(JSON.stringify(sec1.ul));
							item['catIndex']=ulgps.findIndex(gp=>gp.label==item.cat);
							item.secRef=sec.SECTION_SEQUENCE;
							allUls.push(item)
						}
						if(sec1.SUB_SECTIONS){
								for(let sec2 of sec1.SUB_SECTIONS){
									if(sec2.ul&&sec2.ul.Item.length>0){
										let item=JSON.parse(JSON.stringify(sec2.ul));
										item['catIndex']=ulgps.findIndex(gp=>gp.label==item.cat);
										item.secRef=sec.SECTION_SEQUENCE;
										allUls.push(item)
									}
					
								}
						}
						
					}
				}
			}
		}
		console.log(allUls)
		allUls.sort(function(a, b){
			return a.catIndex - b.catIndex;
		});
		let tableData=this.getSecbyId(this.contents,'fme_exec_sum_ul_0');console.log(tableData)
		let overallrow=JSON.parse(JSON.stringify(tableData.data.rows[tableData.data.rows.length-1]));
		
		let rows=tableData.data.rows;console.log(rows);
		let cols=tableData.data.cols;console.log(cols);
		tableData.data.rows=[];
		if(allUls.length>0){		
		for(let ul of allUls){console.log(ul)
			let row=[]
			let baserow=this.fmeService.ulrow;
			for(let i=0; i<cols.length; i++){
				let item=JSON.parse(JSON.stringify(baserow[i]));
				item['KEY']=cols[i].KEY;
				if(item.KEY=='No'){
					let order=0;
					for(let j=0; j<ul.catIndex+1; j++){
						if(j>0){
							order+=ulgps[j-1].subRow.length;
						}						
					}
					item.data=order+ulgps[ul.catIndex].subRow.length+1;				
					item['id']=ul.id;
					item['index']=this.getIdIndex(ul.id);
					item['htmltext']=order+ulgps[ul.catIndex].subRow.length+1;
				}else if(item.KEY=='RUL'){
					let val=(parseInt(row[i-2].data)-parseInt(row[i-1].data))
					if(isNaN(val)){
						item.data='';
						item['htmltext']='';
					}else{
						item.data=val.toString();
						item['htmltext']=val.toString();;
					}	
				}else if(item.KEY=='RERatio'){
					let val=this.getRound((row[i-1].data/row[i-3].data)*100);
					if(isNaN(val)){
						item.data='';
						item['htmltext']='';
					}else{
						item.data=val+'%';
						item['htmltext']=val+'%';
					}
				}else if(item.KEY=='ACTION'){
					let val='';
					for(let v of ul.ACTION){
						val+=v.code+',';
					}
					item.data=val.slice(0,-1);
					item['htmltext']=val.slice(0,-1);;
				}else if(item.KEY=='Srouce'){
					item['data']=ul['Source'];
					item['htmltext']=ul['Source'];
				}else{
					item['data']=ul[cols[i].KEY];
					item['htmltext']=ul[cols[i].KEY];
				}				
				console.log(item)
				row.push(item)
			}
			ulgps[ul.catIndex].subRow.push(row)
		}
	}
			let titlebase=this.fmeService.capitalTitleRow;
			for(let group of ulgps){
				let titlerow=JSON.parse(JSON.stringify(titlebase));
				titlerow[0].data='';
				titlerow[1].data=group.label;
				titlerow[1].colspan=titlebase[1].colspan;
				tableData.data.rows.push(titlerow);
				for(let sub of group.subRow){
					tableData.data.rows.push(sub);
				}
			}
			tableData.data.rows.push(overallrow);
		
	}
	getSecbyId(dataset, secId){////console.log(secId); //console.log(dataset);
		let secContent:any
		for(let item of dataset){
			if(item.id==secId){////console.log(item)
				secContent=item;
				break;
			}else{
				for(let item1 of item.SUB_SECTIONS){
					if(item1.id==secId){////console.log(item1)
						secContent=item1;
						break;
					}else{
						if(item1.SUB_SECTIONS){
						
						for(let item2 of item1.SUB_SECTIONS){
							if(item2.id==secId){////console.log(item2)
								secContent=item2;
								break;
							}
						}
						}
					}
				}
			}
		}
		////console.log(secContent)
		return secContent;
	}
	getCompanyProfiles(id){
		let inputJson={"PROCEDURE":"getcompanystylelist","USER_ID":parseInt(this.userId), 'TEMPLATE_ID':id };
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.profiles=data.STYLE_LIST;
			
		})
	}
	getGroup(){
		let arr=[];
		for(let cat of this.capitalCategory){
			let item={"label":cat.label,'id':cat.id, "subRow":[]}
			arr.push(item)
		}
		return arr
	}
	getRound(val, type?){
		let data=0;
		if(this.pcaOp.round=='Round'){
			if(type){
				data=Math.round(val*1000)/1000;
			}else if(this.pcaOp.decimal==2){
				data=Math.round(val*100)/100;
			}else if(this.pcaOp.decimal==0){
				data=Math.round(val);
			}
			
		}else if(this.pcaOp.round=='Round Up'){
			if(type){
				data=Math.ceil(val*1000)/1000;
			}else if(this.pcaOp.decimal==2){
				data=Math.ceil(val*100)/100;
			}else if(this.pcaOp.decimal==0){
				data=Math.ceil(val);
			}
			
		}else if(this.pcaOp.round=='Round Down'){
			if(type){
				data=Math.floor(val*1000)/1000;
			}else if(this.pcaOp.decimal==2){
				data=Math.floor(val*100)/100;
			}else if(this.pcaOp.decimal==0){
				data=Math.floor(val);
			}
			
		}
		
		return data;
	}
	iniFrm1105(){
		//let sectionSet=this.frmService.sectionSet;
		let subSectionSet=this.frmService.subSectionSet;
		//let childrenSet=this.frmService.childrenSet;
		//let tableSet=this.frmService.tableSet;
		//let htmlSet=this.frmService.htmlSet;
		//let JsonSet=this.frmService.JsonSet;
		let dataCat=this.frmService.dataCat;console.log(dataCat)
		let sectionSet=JSON.parse(JSON.stringify(this.frmService.frmsection));
		let data=JSON.parse(JSON.stringify(this.frmService.frmData));console.log(data)
		sectionSet['frmData']=data;
		sectionSet['frmData']['firmname']="";//this.userInfo.COMPANY_NAME;
		sectionSet['frmData']['title']='';
		sectionSet['SUB_SECTIONS']=this.frmService.sectionSet;
		for(let items of sectionSet['SUB_SECTIONS']){
			items.SUB_SECTIONS=subSectionSet[items.id];
			/*for(let i=0; i<items.SUB_SECTIONS.length; i++){
				let doc1=items.SUB_SECTIONS[i];
				if(htmlSet[items.SUB_SECTIONS[i].id]){
					doc1.htmlcontent=this.sanitizer.bypassSecurityTrustHtml(htmlSet[items.SUB_SECTIONS[i].id]);
					doc1.frmJson=JsonSet[items.SUB_SECTIONS[i].id];
				}
				for(let j=0; j<doc1.SUB_SECTIONS.length; j++){
					let subitem=doc1.SUB_SECTIONS[j]; console.log(i-1, subitem);
					if(subitem.TYPE=='1105-table'){console.log(doc1.id);console.log(items.id);
						console.log(tableSet[doc1.id]);
						console.log(tableSet[items.id]);
						if(tableSet[doc1.id]||tableSet[items.id]){
							if(tableSet[doc1.id]){
								subitem['data']=JSON.parse(JSON.stringify(tableSet[doc1.id]));
							}else if(tableSet[items.id]){
								subitem['data']=JSON.parse(JSON.stringify(tableSet[items.id]));
							}
							
							let baserow=JSON.parse(JSON.stringify(subitem.data['rows'][0]));
							subitem.data['rows']=[];
							let dataset=[];
							console.log(i,j)
							if(items.id=='frm_sec1'){
								dataset=dataCat[i-1];
							}else if(doc1.id=='frm_sec5_1'){
								dataset=dataCat[j];
							}
							console.log(dataset)
							for(let row of dataset){
								let item=JSON.parse(JSON.stringify(baserow));
								item[0].data=row.label;
								subitem.data['rows'].push(item);
								if(row['sub']){
									for(let subrow of row['sub']){
										let item1=JSON.parse(JSON.stringify(baserow));
										item1[0].data=subrow.label;
										item1[0]['sub']=true;
										subitem.data['rows'].push(item1);
									}
								}
							}							
						}
						console.log(subitem.data)						
					}
				}
			
			}*/
		}
		this.pcaOp['decimal']=2;
		console.log(sectionSet)
		this.contents.push(sectionSet); //.splice(1, 0, sectionSet);
	}
	changeFactor(no, type){
		if(type&&type=='reserve'){
			if(!Number.isInteger(no)){
				no=Math.floor(no);
				this.pcaOp.reserve=no;
			}				
			if(no>0){
				if(this.tempInfo.PCA_INDICATOR=='4099e'&&no>=15){
					this.pcaOp[type]=15;
				}else if(no>=30){
					this.pcaOp[type]=30;
				}
				this.reserveTerm=this.pcaOp.reserve;
			}else{
				this.pcaOp.reserve=1;
			}
		}
	}
	getPre(id){
		let index=this.getIdIndex(id);
		let index1=index[0];
		let index2=index[1];
		let index3=index[2];
		let dest:any;
		if(this.contents&&index3&&index3>-1){
			for(let i=index3; i>-1; i--){
				if(this.contents[index1].SUB_SECTIONS[index2]&&this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1]&&this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1].DISPLAY_SEQUENCE=='Y'){
					let item=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1];
					dest={'id':item.id, 'SECTION_SEQUENCE':item.SECTION_SEQUENCE,'SECTION_TITLE':item.SECTION_TITLE,}
					break;
				}
			}
		}
		if(!dest){
			for(let i=index2; i>-1; i--){
				if(this.contents[index1].SUB_SECTIONS[i]&&this.contents[index1].SUB_SECTIONS[i].DISPLAY_SEQUENCE=='Y'){
					let item=this.contents[index1].SUB_SECTIONS[i]
					dest={'id':item.id, 'SECTION_SEQUENCE':item.SECTION_SEQUENCE,'SECTION_TITLE':item.SECTION_TITLE,}
					break;
				}
			}
			if(!dest){
				for(let i=index1; i>-1; i--){
					if(this.contents[i].DISPLAY_SEQUENCE=='Y'){
						let item=this.contents[i];
						dest={'id':item.id, 'SECTION_SEQUENCE':item.SECTION_SEQUENCE,'SECTION_TITLE':item.SECTION_TITLE,}
						break;
					}
				}
			}
		}
		console.log(dest)			
		return dest;
	
	}
	frmData(e){console.log(e)
		this.curFrm.html=e;
		this.curFrm.secHtml=this.sanitizer.bypassSecurityTrustHtml(e);	
		console.log(this.curFrm)
	}
	ulProp:any;
	selFrmUl(doc, e, type){//console.log(doc, e.target.value, type)
		let ifLinked=this.checkFrmItem(doc.id);
		if(ifLinked){
			Swal.fire({
					icon:'info',
					title: 'This table is referenced by Freddie Mac Section, Please remove the reference first.',
				})
				let index=this.capitalCategory.findIndex(data=>data.tag==doc.cat);  
				e.target.value=index;
			return
			
		}
		let index=parseInt(e.target.value);
			if(index>-1){
				let tablesrc=this.frmService.tableSet.sec2tables.rowItem[index]; //console.log(tablesrc);
				const key = 'key';
				const costitems = this.getAllItem(tablesrc);
				const val=this.capitalCategory[index].tag;
				doc['cat']=val;
				doc['costitems']=costitems;
			}else{
				//delete doc.ul;
				delete doc.cat;
				delete doc.costitems;
			}		
		console.log(doc);	
		//this.ulProp=doc['ul'];
		this.getAllCostTable()
	}
	getAllItem(table){
		let allitems=[];
		for(let item of table){
			let recItem={'key':item.key,'checkvalue':item.key}
			allitems.push(recItem);
			if(item.sub&&item.sub.length>0){
				for(let subitem of item.sub){
					let recItem1={'key':subitem, 'parent':item.key, 'checkvalue':item.key+"--"+subitem};
					if(item.key=='Mechanical HVAC'){
						recItem1['describe']=true;
					}
					allitems.push(recItem1);
				}
				if(item.key=='Flooring'||item.key=='Cabinetry'||item.key=='Countertops and sinks'){
					let recItem1={'key':'Other', 'parent':item.key, 'other':true,'checkvalue':'other'}
					allitems.push(recItem1);					
				}					
			}
		}
		return allitems
	}
	noDataConfig(e){
		if(e.target.checked){
			this.printnodataforAppendix='N';
		}else{
			this.printnodataforAppendix='Y';
		}
		let inputJson={"PROCEDURE":"updatetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID, "APPENDIX_NODATA_MESSAGE":this.printnodataforAppendix};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.tempInfo=data;			
		})
	}
	savePDFconfig(size){
	let inputJson={"PROCEDURE":"updatetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID, "PCA_PAGE_SETUP":size};
	console.log(JSON.stringify(inputJson));
	this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		console.log(data);
		if (data.RESPONSE_STATUS=='N') {
			this.throwError(data)							
		}else{
			this.lpagesize=size;
		}		
	})
	}
	summaryType='';
	haveSummary(){
		let status=false;
		for(let doc of this.frontpages){console.log(doc)
			if(doc.TYPE=='PISUMMARY'){
				if(!this.summaryCols||this.summaryCols.length==0){
					this.summaryCols=[];
					if(doc.SUB_SECTIONS.length>0&&doc.SUB_SECTIONS[0].data&&doc.SUB_SECTIONS[0].data.cols){
						for(let col of doc.SUB_SECTIONS[0].data.cols){
						this.summaryCols.push(col.NAME);
						this.summaryColsType.push(col.inputType);
					}
					}
					
				}
				this.summaryType='PHASE I';			
				status=true;
				break
			}
		}
		for(let doc of this.contents){
			if(doc.TYPE=='PISUMMARY'){
				if(!this.summaryCols||this.summaryCols.length==0){
					this.summaryCols=[];
					if(doc.SUB_SECTIONS.length>0&&doc.SUB_SECTIONS[0].data&&doc.SUB_SECTIONS[0].data.cols){
						for(let col of doc.SUB_SECTIONS[0].data.cols){
						this.summaryCols.push(col.NAME);
						this.summaryColsType.push(col.inputType);
					}
					}
					
				}
				this.summaryType='PHASE I';			
				status=true;
				break
			}else if(doc.TYPE=='PCASUMMARY'){
				this.pcaSummaryCols=this.reportService.pcaSummaryCols;
				this.summaryType='PCA';
				status=true;
				break
			}
		}
		return status;
	}
	/*summaryData(e){
		this.curSummary.html=e;
		this.curSummary.secHtml=this.sanitizer.bypassSecurityTrustHtml(e);	
		this.curSummary.slots=this.getAllSlotId(e);
		
		
	}
	summaryText(e){
		this.curSummary.data=e;
		if(this.curSummary.id){
			let keys=["Good","Fair","Poor","ACTION"];
			let doc=this.getSecbyId(this.contents,this.curSummary.id);console.log(doc)
			doc['summaryPara'][keys[this.curSummary.index-1]]=this.curSummary.data;
		}
	}
	toSummaryAction(e){console.log(e)
		if(e.id){
			let doc=this.getSecbyId(this.contents,e.id);console.log(doc)
			doc['summaryPara']['ACTION']=e.data;
		}
	}

	selSummaryCat(doc, e, type){console.log(e)
		let val=e.target.value;console.log(val)
		if(!doc['summaryPara']){
			doc['summaryPara']={'id':doc.id,'No':'', 'Item':doc.SECTION_TITLE, 'Good':'', 'Fair':'','Poor':'', 'ACTION':"", 'SecRef':doc.SECTION_SEQUENCE, 'cat':val};
		}
		if(val.length>0){
			doc['summaryPara'][type]=val;
		}else{
			if(type=='cat'){
				delete doc.summaryPara;
			}else{
				doc['summaryPara'][type]='';
			}			
		}	
		console.log(doc['summaryPara']);	
		this.getTotalSummary();	
	}
	*/
	allSummarys=[];
	getallsummaryItems(){
		let allUls=[];
		if (this.contents){
			for(let sec of this.contents){
				if(sec.pcasummarydata){
					let item=JSON.parse(JSON.stringify(sec.pcasummarydata));
					item[0]['catIndex']=this.summaryCategory.findIndex(gp=>gp==item[0].cat);
					item[0].SecRef=sec.SECTION_SEQUENCE;
					item[0].data=sec.SECTION_SEQUENCE+' '+sec.SECTION_TITLE;
					allUls.push(item)
				}
				if(sec.SUB_SECTIONS){				
					for(let sec1 of sec.SUB_SECTIONS){
						if(sec1.pcasummarydata){
							let item1=JSON.parse(JSON.stringify(sec1.pcasummarydata));
							item1[0]['catIndex']=this.summaryCategory.findIndex(gp=>gp==item1[0].cat);
							item1[0].SecRef=sec1.SECTION_SEQUENCE;
							item1[0].data=sec1.SECTION_SEQUENCE+' '+sec1.SECTION_TITLE;
							allUls.push(item1)
						}
						if(sec1.SUB_SECTIONS){
								for(let sec2 of sec1.SUB_SECTIONS){
									if(sec2.pcasummarydata){
										let item2=JSON.parse(JSON.stringify(sec2.pcasummarydata));
										item2[0]['catIndex']=this.summaryCategory.findIndex(gp=>gp==item2[0].cat);
										item2[0].SecRef=sec2.SECTION_SEQUENCE;
										item2[0].data=sec2.SECTION_SEQUENCE+' '+sec2.SECTION_TITLE;
										allUls.push(item2)
									}
					
								}
						}
						
					}
				}
			}
		}
		return allUls
	}
	getTotalSummary(){console.log(this.summaryCategory)
		let allUls=[];
		allUls=this.getallsummaryItems();
		/*if (this.contents){
			for(let sec of this.contents){
				if(sec.pcasummarydata){
					let item=JSON.parse(JSON.stringify(sec.pcasummarydata));
					item[0]['catIndex']=this.summaryCategory.findIndex(gp=>gp==item[0].cat);
					item[0].SecRef=sec.SECTION_SEQUENCE;
					allUls.push(item)
				}
				if(sec.SUB_SECTIONS){				
					for(let sec1 of sec.SUB_SECTIONS){
						if(sec1.pcasummarydata){
							let item1=JSON.parse(JSON.stringify(sec1.pcasummarydata));
							item1[0]['catIndex']=this.summaryCategory.findIndex(gp=>gp==item1[0].cat);
							item1[0].SecRef=sec1.SECTION_SEQUENCE;
							allUls.push(item1)
						}
						if(sec1.SUB_SECTIONS){
								for(let sec2 of sec1.SUB_SECTIONS){
									if(sec2.pcasummarydata){
										let item2=JSON.parse(JSON.stringify(sec2.pcasummarydata));
										item2[0]['catIndex']=this.summaryCategory.findIndex(gp=>gp==item2[0].cat);
										item2[0].SecRef=sec2.SECTION_SEQUENCE;
										allUls.push(item2)
									}
					
								}
						}
						
					}
				}
			}
		}*/
		console.log(allUls)
		allUls.sort(function(a, b){
			return a[0].catIndex - b[0].catIndex;
		});
		this.toUL(allUls);
		//this.allSummarys=allUls; console.log(this.allSummarys);
	}
	toUL(allitems){console.log(allitems)
		let table1=this.getSecbyId(this.contents,'pca_summary_1');console.log(table1);
		table1.data.rows=[];
		let totalrow=JSON.parse(JSON.stringify(this.reportService.summaryTable[1].totalrow));    
		let catData=[];
		for(let item of allitems){
		  if(item[0].catIndex>-1){
			let index=catData.findIndex(group=>group.index==item[0].catIndex);
			if(index>-1){
			  catData[index].children.push(item)
			}else{
			  let sub={'index':item[0].catIndex, 'children':[item]};
			  catData.push(sub)
			}
		  }
		}  
		console.log(catData)
		for(let rowgroup of catData){
		  let firstrow=JSON.parse(JSON.stringify(this.reportService.summaryTable[1].firstrow));
		  firstrow[0].data=this.summaryCategory[rowgroup.index];
		  if(this.pcaOp.term=='Exclude'){
			firstrow[0]['colspan']=7;
		  }else{
			firstrow[0]['colspan']=8;
		  }
		  table1.data.rows.push(firstrow);
		  for(let row of rowgroup.children){
			let baserow=JSON.parse(JSON.stringify(this.reportService.summaryTable[1].baserow));
			for(let i=0; i<5; i++){
				if(row[i].inputType=='Checkmark'){
					baserow[i].data=row[i].data;
					//row[i].html=row[i].html;
				}else if(row[i].inputType=='text'||row[i].inputType=='option'){
					baserow[i].data=row[i].data;
					baserow[i].html=row[i].html;
					if(row[i].secHtml){
						baserow[i].secHtml=row[i].secHtml;
					}
					if(row[i].slots){
						baserow[i].slots=row[i].slots;
					}
					if(row[i].refId){
						baserow[i].refId=row[i].refId;
					}					
				}
			}
			if(this.pcaOp.term=='Exclude'){
				baserow[6]['hide']=true;
			  }else{
				baserow[6]['hide']=false;
			  }						
			table1.data.rows.push(baserow);
		  }
		} 
		if(this.pcaOp.term=='Exclude'){
			totalrow[2]['hide']=true;
		}else{
			totalrow[2]['hide']=false;
		} 
		table1.data.rows.push(totalrow); 
		let table2=this.getSecbyId(this.contents,'pca_summary_2');console.log(table1);
		if(this.pcaOp.term=='Exclude'){
			table2.data.rows[1][0]['rowhide']=true;
		}else{
			table2.data.rows[1][0]['rowhide']=false;
		}
		console.log(table1) 	
	  }
	  
	catShow=false;
	catItems='';
	catInfo:any;

	getCatItems(){
		let allsummaryitems=this.getallsummaryItems();
		if(allsummaryitems.length>0){
			Swal.fire({
				text: 'Once any record added in, the category will not allow to change anymore.'
			})
			return
		}else{
		this.catInfo='';
		let inputJson={"PROCEDURE":"gettemplatesummarycategory","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,};
		console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)							
			}else{
				if(data.SUMMARY_CATEGORY.length>0){
					this.summaryCategory=data.SUMMARY_CATEGORY.split(',');
				}
				this.catItems=data.SUMMARY_CATEGORY;
				
			}		
		})
		this.catShow=true; 
	}
		;
	}
	saveCategory(){console.log(this.catItems)
		this.loading=true;
		this.catInfo=null;
		let inputJson={"PROCEDURE":"updatetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID, "SUMMARY_CATEGORY":this.catItems};
		console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			this.loading=false;
			if (data.RESPONSE_STATUS=='N') {
				this.catInfo={'status':data.RESPONSE_STATUS, 'msg':'Summary Categories Update Failed!'}
				this.throwError(data)							
			}else{
				this.summaryCategory=data.SUMMARY_CATEGORY.split(',');
				this.catInfo={'status':data.RESPONSE_STATUS, 'msg':"Summary Categories Saved Successfully!"}
				
			}		
		})
	}
	addActionItem(item){
		let ele='#'+'actionItem';
		let text=$(ele).val().trim();	
		if(text.length>0){
			item.ACTION.push(text);			
		}
		$(ele).val('');
	}
	addToAction(label){
		this.pcacurSummary[4].ACTION.push(label);
	}
	removeActionItem(index){
		this.pcacurSummary[4].ACTION.splice(index, 1);
	}
	addCatItem(){
		let ele='#'+'catItem';
		let text=$(ele).val();	
		if(text.trim().length>0){
			if(this.catItems.length>0){
				this.catItems+=',';
			}
			this.catItems+=text.trim();					
		}
		$(ele).val('');
	}
	addToCat(label){
		//let ele='#'+'catItem';
		//$(ele).val(label);
		if(this.catItems.length>0){
			this.catItems+=',';
		}
		this.catItems+=label.trim();	
	}
	removeCatItem(index){
		let cats=this.catItems.split(',');
		cats.splice(index, 1);
		this.catItems=cats.join(',');
		console.log(this.catItems);
	}
	selCostCat(key, e, doc){
		let val=e.target.value;
		if(val.length>0){
			doc[key]=e.target.value;
		}else{
			if(doc[key]){
				delete doc[key];
			}
			
		}
	}
	/*addCheck(e){
		$(e.target).prev('input').val('✓');//"&#x2713"
	}*/	
	removePISummay(){
		if(this.summaryType=='PHASE I'){
			delete this.curSec.pisummarydata;
			this.toTatalPISummary();
		}else if(this.summaryType=='PCA'){
			delete this.curSec.pcasummarydata;
			this.getTotalSummary();
		}		
	}
	catReq:string;
	savePISummay(){
		if(this.summaryType=='PHASE I'){
			this.curSec['pisummarydata']=JSON.parse(JSON.stringify(this.picurSummary));
			this.toTatalPISummary();
			this.psShow=false;
		}else if(this.summaryType=='PCA'){
			this.catReq='';
			if(this.pcacurSummary[0]['cat']&&this.pcacurSummary[0]['cat'].length>0){
				if(this.pcacurSummary[4]['ACTION']){
					let action='';
					for(let item of this.pcacurSummary[4]['ACTION']){
						if(action.length>0){
							action+=', '+item;
						}else{
							action=item;
						}
					}
					this.pcacurSummary[4]['data']=action;
				}				
				this.curSec['pcasummarydata']=JSON.parse(JSON.stringify(this.pcacurSummary));
				this.getTotalSummary();
				this.psShow=false;
			}else{
				this.catReq='Category is required!'
			}
			
		}
		
	}
	toTatalPISummary(){
		let summarytable:any;//let summarytable=this.getSecbyId(this.contents,'phaseI_project_summary_table');
		if(this.getSecbyId(this.frontpages,'phaseI_project_summary_table')){
			summarytable=this.getSecbyId(this.frontpages,'phaseI_project_summary_table')
		}else if(this.getSecbyId(this.contents,'phaseI_project_summary_table')){
			summarytable=this.getSecbyId(this.contents,'phaseI_project_summary_table');
		}else{
			return
		}
		summarytable.data.rows=[];
		
		let cols=summarytable.data.cols; //console.log(cols)
		for(let doc of this.contents){
			if(doc.pisummarydata&&doc.pisummarydata[0]['refId']){
				let row=[];
				doc.pisummarydata[0].data=doc.SECTION_SEQUENCE+' '+doc.SECTION_TITLE;
				for(let i=0; i<cols.length; i++){
					let item={'COLUMNINTERNALNAME': 'col'+i, 'data': doc.pisummarydata[i].data, 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'};
					if(doc.pisummarydata[i]['refId']){
						item['refId']=doc.pisummarydata[i]['refId'];
					}
					if(doc.pisummarydata[i]['slots']){
						item['slots']=doc.pisummarydata[i]['slots'];
					}
					if(doc.pisummarydata[i]['html']){
						item['html']=doc.pisummarydata[i]['html'];
					}
					if(doc.pisummarydata[i]['secHtml']){
						item['secHtml']=doc.pisummarydata[i]['secHtml'];
					}
					row.push(item);
				}
				summarytable.data.rows.push(row);
			}
			if(doc.SUB_SECTIONS&&doc.SUB_SECTIONS.length>0){
				for(let doc1 of doc.SUB_SECTIONS){
					if(doc1.pisummarydata&&doc1.pisummarydata[0]['refId']){
						let row1=[];
						doc1.pisummarydata[0].data=doc1.SECTION_SEQUENCE+' '+doc1.SECTION_TITLE;
						for(let j=0; j<cols.length; j++){
							let item={'COLUMNINTERNALNAME': 'col'+j, 'data': doc1.pisummarydata[j].data, 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'};
							if(doc1.pisummarydata[j]['refId']){
								item['refId']=doc1.pisummarydata[j]['refId'];
							}
							if(doc1.pisummarydata[j]['slots']){
								item['slots']=doc1.pisummarydata[j]['slots'];
							}
							if(doc1.pisummarydata[j]['html']){
								item['html']=doc1.pisummarydata[j]['html'];
							}
							if(doc1.pisummarydata[j]['secHtml']){
								item['secHtml']=doc1.pisummarydata[j]['secHtml'];
							}
							
							row1.push(item);
						}
						summarytable.data.rows.push(row1);
					}

					if(doc1.SUB_SECTIONS&&doc1.SUB_SECTIONS.length>0){
						for(let doc2 of doc1.SUB_SECTIONS){
							if(doc2.pisummarydata&&doc2.pisummarydata[0]['refId']){
								let row2=[];
								doc2.pisummarydata[0].data=doc2.SECTION_SEQUENCE+' '+doc2.SECTION_TITLE;
								for(let k=0; k<cols.length; k++){
									let item={'COLUMNINTERNALNAME': 'col'+k, 'data': doc2.pisummarydata[k].data, 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'};
									if(doc2.pisummarydata[k]['refId']){
										item['refId']=doc2.pisummarydata[k]['refId'];
									}
									if(doc2.pisummarydata[k]['slots']){
										item['slots']=doc2.pisummarydata[k]['slots'];
									}
									if(doc2.pisummarydata[k]['html']){
										item['html']=doc2.pisummarydata[k]['html'];
									}
									if(doc2.pisummarydata[k]['secHtml']){
										item['secHtml']=doc2.pisummarydata[k]['secHtml'];
									}
									row2.push(item);
								}
								summarytable.data.rows.push(row2);
							}
						}
					}

				}
				
			}
		}
		//console.log(summarytable.data.rows);
		
	}
	addPICol(e, col?){
		if(col){
			this.summaryCols.push(col)
		}else{
			let ele='#'+'scolInput';
			let text=$(ele).val().trim();//console.log(text);
			if(text.length>0){
				this.summaryCols.push(text);
				$(ele).val('');
			}
		}
		this.summaryColsType.push('text');	
	}
	removeSummaryCol(index){
		this.summaryCols.splice(index, 1);
		this.summaryColsType.splice(index, 1);
	}
	
	addColType(e, i){
		this.summaryColsType[i]=e.target.value;
	}
	pisummaryShow=false;
	picurSummary=[];
	pcacurSummary=[];
	pcaSummaryCols=[];
	picurcol:any;
	psShow=false;
	editPs(doc){console.log(this.summaryCols, this.summaryColsType, doc)
		this.curSec=doc;
		if(this.summaryStatus&&this.tempInfo.PCA_INDICATOR=='Y'){
			if(doc.pcasummarydata){
				this.pcacurSummary=JSON.parse(JSON.stringify(doc.pcasummarydata));
			}else{
				this.pcacurSummary=[{'col':'Project Summary Category','data':doc.SECTION_SEQUENCE+" "+doc.SECTION_TITLE, 'refId':doc.id, 'inputType':'option', 'cat':''}]
					for(let col of this.pcaSummaryCols){
						let item:any;
						if(col.Type=='text'){
							item={'data':'', 'html':'', 'secHtml':null, 'col':col.Name, 'inputType':col.Type, 'slots':[]};				
						}else if(col.Type=='option'){				
							item={'data':'', 'col':col.Name, 'inputType':col.Type, 'ops':this.reportService.actionItemOps, 'ACTION':[]};
						}else{				
							item={'data':'', 'col':col.Name, 'inputType':col.Type};
						}
						this.pcacurSummary.push(item);
					}
				console.log(this.pcacurSummary);
			}
		}else{
			if(doc.pisummarydata){
				this.picurSummary=JSON.parse(JSON.stringify(doc.pisummarydata));
			}else{
				this.picurSummary=[{'col':'Report Section','data':doc.SECTION_SEQUENCE+" "+doc.SECTION_TITLE, 'refId':doc.id, 'inputType':'text'}]
				for(let i=1; i<this.summaryCols.length; i++){
					let item:any;
					if(this.summaryColsType[i]=='text'){
						item={'data':'', 'html':'', 'secHtml':null, 'col':this.summaryCols[i], 'inputType':this.summaryColsType[i], 'slots':[]};				
					}else{				
						item={'data':'', 'col':this.summaryCols[i], 'inputType':this.summaryColsType[i]};
					}
					this.picurSummary.push(item);
				}
			}
			console.log(this.picurSummary)
		}
		this.catReq='';
		this.psShow=true;
	}
	picurSummaryItem:any
	toSummaryEdit(doc, col){
		this.picurSummaryItem=doc;
		this.pisummaryShow=true;
		this.picurcol=col;		
	}
	pisummaryData(e){
		if(e.length>0){
			this.picurSummaryItem['html']=e;
			this.picurSummaryItem['secHtml']=this.sanitizer.bypassSecurityTrustHtml(e);
			this.picurSummaryItem['slots']=this.getAllSlotId(e)
		}else{
			this.picurSummaryItem['html']='';
			this.picurSummaryItem['secHtml']=null;
			this.picurSummaryItem['slots']=[];
		}		
	}
	pisummaryText(e){
		if(e.length>0){
			this.picurSummaryItem['data']=e;
		}else{
			this.picurSummaryItem['data']='';
		}		
	}
	changeOpItem(type?){
		if(this.summaryStatus){
			let data1=this.getSecbyId(this.contents, 'pca_summary_2');
			let data2=this.getSecbyId(this.contents, 'pca_summary_3');
			let data='Replacement Reserves, w/'+this.pcaOp.reserve+' year, '+parseFloat(this.pcaOp.inflation).toString()+'% escalation';
			let header1='$/'+this.pcaOp.multiplier;
			let header2='$/'+this.pcaOp.multiplier+'/Year';
			data2.data.rows[0][0].data='Replacement Reserves';
			data2.data.rows[1][0].data=data;
			data1.data.cols[2].NAME=header1;
			data2.data.cols[2].NAME=header1;
			data2.data.cols[3].NAME=header2;
		}		
	}
	addFOItem(e, item){
		let ele=$(e.target).prev('input')
		let text=ele.val().trim();
		if(!item.FO){
			item.FO=[];
		}	
		if(text.length>0){
			item.FO.push(text);			
		}
		ele.val('');
	}
	/*addFODefaultItem(item){
		let ele=$('#defaultFO');
		let text=ele.val().trim();
		item.DefaultFO=text;			
		ele.val('');
	}
	toDefault(label){
		let ele=$('#defaultFO');
		let text=ele.val().trim();
		ele.val(text+' '+label)
	}*/
	removeFOItem(item, index){
		item.FO.splice(index, 1);
	}
	insertFOItem(item){//console.log(text)
		this.itemIndex++;
		let text='';
		if(item.html){
			text=item.html.slice(3, -4);
		}else{
			text=item;
		}
		let data={'index':this.itemIndex,'content':text, 'type':'FO'};			
		this.curSec['addedItem']=data;
		this.curSec['reqIndex']=this.itemIndex;
	}
	resetTableModify(doc){
		this.curCell=null;
		this.preCell={'row':0,'col':0};
		this.curCol=null;
		//this.curCap=null;
		this.selectedHeaderType
		this.curHeader
		this.selectedHeaderType='';
   		this.selectedHRow=-1;
		if(doc.data){
			for(let row of doc.data.rows){
				if(row.selected){
					delete row.selected;
				}
			}
		}
		
	}
	tableShow=false;
	preCell:any;
	modifyTable(doc){console.log(doc);
		this.resetTableModify(doc);
		this.curSec=doc;
		this.pageIndex=this.getFrontIdIndex(doc.id);//console.log('first',this.pageIndex);
		this.curIndex=this.getIdIndex(doc.id);//console.log('first',this.curIndex)
		if(this.pageIndex){
			this.selectedEditor='F'
		}else if(this.curIndex){
			this.selectedEditor='P'
		}
		this.tableShow=true;
		this.addHBefore=false;
		let that=this;
		//setTimeout(() => {
		//	this.hotkeyIcon.nativeElement.click();
		//},1000)
		
		//this.selectCell(doc, 0, doc.data.cols[0], doc.data.rows[0].items[0]);		
	}
	naviCell(e){
		//console.log(e);
		const container = this.edittableContainer.nativeElement; 
		const editrows= $(".editrow");//console.log(editrows)
		const h=editrows[this.preCell.row].offsetHeight+2; //console.log(h)		
		this.curCell=null;
		let rows=this.curSec.data.rows.length-1;
		let cols=this.curSec.data.cols.length-1;
		if(e=='ArrowDown'&&this.preCell.row<rows){
			this.preCell.row++;
			if(this.curSec.data.rows[this.preCell.row].items[0].colspan){
				this.preCell.col=0;
			}
			if(this.preCell.row>1){							
				if(container){
					container.scrollBy({ top: h, behavior: 'smooth' }); // Scrolls down by 100 pixels
				}				
			}
		}
		if(e=='ArrowRight'){
			if(this.preCell.col<cols){
				if(!this.curSec.data.rows[this.preCell.row].items[0].colspan){
					this.preCell.col++;
				}
			}else if(this.preCell.col==cols&&this.preCell.row<rows){
				this.preCell.row++;
				this.preCell.col=0;
			}			
		}
		if(e=='ArrowUp'&&this.preCell.row>0){
			this.preCell.row--;
			if(this.curSec.data.rows[this.preCell.row].items[0].colspan){
				this.preCell.col=0;
			}
			if(this.preCell.row>1){	
				const h1=editrows[this.preCell.row-1].offsetHeight-2; 				
				if(container){
					container.scrollBy({ top: -h1, behavior: 'smooth' }); // Scrolls down by 100 pixels
				}
				
			}
		}
		if(e=='ArrowLeft'&&this.preCell.col>0){
			this.preCell.col--;
		}
		let cell=this.curSec.data.rows[this.preCell.row].items[this.preCell.col];
		let col=this.curSec.data.cols[this.preCell.col];
		//this.selectCell(this.curSec, this.preCell.row, col, cell);
	}
	shortCut(type){
		let cell=this.curSec.data.rows[this.preCell.row].items[this.preCell.col];
		switch(type) {
			case 'c':
				this.copyCell(cell);
			 	break;
			case 'v':
				this.pasteCell(cell);
			  	break;
			case 'm':
				this.addCheckmark(cell);
			  	break;
			case ' ':
				this.clearCheckmark(cell);
			  	break;
			default:
			  // code block
		}
	}
	editCell(){
		let cell=this.curSec.data.rows[this.preCell.row].items[this.preCell.col];//console.log(cell)
		let col=this.curSec.data.cols[this.preCell.col];//console.log(col)
		this.selectCell(this.curSec, this.preCell.row, col, cell);
	}
	toNextCell(){
		this.curCell=null;
		let rows=this.curSec.data.rows.length-1;
		let cols=this.curSec.data.cols.length-1;
		if(this.preCell.col<cols){
			this.preCell.col++;
		}else if(this.preCell.col==cols&&this.preCell.row<rows){
			this.preCell.row++;
			this.preCell.col=0;
		}
		let cell=this.curSec.data.rows[this.preCell.row].items[this.preCell.col];
		let col=this.curSec.data.cols[this.preCell.col];
		this.selectCell(this.curSec, this.preCell.row, col, cell);
	}
	toEditCell(doc, index, col, cell){
		if(!cell['colspan']&&col['lock']){
			//Swal.fire('Column is locked, can not edit');
			return
		}
		/*if(doc.data['locked']&&doc.data['locked']['row'].indexOf(index)>-1){
			Swal.fire('Row is locked, can not edit');
			return
		}*/
		if(doc.data&&doc.data.rows[index]&&doc.data.rows[index]['lock']){
			//Swal.fire('Row is locked, can not edit');
			return
		}
		if(this.curCell&&(index!=this.selectedCell.row!=index||this.selectedCell.col!=col)){
			$('#overlay2').css('display','block');
				this.saveCell(doc);
				//this.toCell(doc)
				//this.zone.run(()=>{
				setTimeout(() => {		//console.log(this.curCell)	
					this.selectCell(doc, index, col, cell)
					$('#overlay2').css('display','none');
				}, 500);	
			//})
		}else{
			this.selectCell(doc, index, col, cell)
		}
		/*setTimeout(() => {
			let ele=
			this.hotkeyIcon.nativeElement.click();
		},1000)*/
	}
	setPageSize(doc,e){
		if(e.target.checked){
			doc['landscape']=true;
		}else{
			doc['landscape']=false;
		}		
	}
	defaultShow=false;
	eriscurcol=null;
	toDefaultEdit(col){
		this.defaultShow=true;
		this.eriscurcol=col;
		if(!this.eriscurcol.DefaultFO){
			this.eriscurcol['DefaultFO']={'html':'','data':'', 'slots':[]};	
		}
	}
	defaultData(e){
		if(this.eriscurcol['DefaultFO'].length>0){
			this.eriscurcol['DefaultFO']={'html':'','data':'', 'slots':[]};	
		}
		if(e.length>0){
			this.eriscurcol['DefaultFO']['html']=e;
			this.eriscurcol['DefaultFO']['secHtml']=this.sanitizer.bypassSecurityTrustHtml(e);
			this.eriscurcol['DefaultFO']['slots']=this.getAllSlotId(e)
		}else{
			this.eriscurcol['DefaultFO']['html']='';
			this.eriscurcol['DefaultFO']['secHtml']=null;
			this.eriscurcol['DefaultFO']['slots']=[];
		}
		
	}
	defaultText(e){
		if(e.length>0){
			this.eriscurcol['DefaultFO']['data']=e;
		}else{
			this.eriscurcol['DefaultFO']['data']='';
		}
	}
	reorderTableData(tabledata){//console.log(tabledata)
		for(let i=0; i<tabledata.cols.length; i++){
			tabledata.cols[i].INTERNALNAME='col'+i;			
		}
		for(let row of tabledata.rows){
			for(let i=0; i<tabledata.cols.length; i++){
				if(row.items[i]){
					row.items[i].COLUMNINTERNALNAME=tabledata.cols[i].INTERNALNAME;	
				}
						
			}
		}
	}
	checkFrmItem(id){
		let linked=false;
		for(let sec of this.contents){
			if(sec.TYPE=='1105'){//console.log(sec.frmData)
				let secdata=sec.frmData.sec2tablesdata;//console.log(secdata)
				for(let sec1 of secdata){
					for(let row of sec1.rows){
						if(row[0].costtable&&row[0].costtable==id){
							linked=true;
							break
						}
					}
				}
			}
		}
		return linked
	}
	searchText='';
	replaceText="";
	checkOn=true;
	caseOn=false;
	matchShow=false;
	allMatchtext='';
	allMatch=0;
	checkOnAll=false;
	checking=false;
	spellCheckErr=''
	async spellCheckAll(){
		this.checkOnAll=!this.checkOnAll;
		if(!this.checkOnAll){
			this.matchShow=false;
			this.allMatch=0;
			this.allMatchtext='';
			return
		}		
		this.checking=true;
		this.matchShow=true;
		this.spellCheckErr='';
		this.curId=null; 
		this.allMatchtext='';
		this.searchText="";
		this.replaceText="";
		this.replaceShow=false;
		//let allMatched=[]
		let data:string;
		data=this.getAllText();
		let textarray=this.divideText2(data);// console.log(textarray)
		try {
			let arr=[]	
			for(let chunk of textarray){
				//this.reportService.checkAll(data).subscribe(response => {
				//console.log(chunk.length)
				const response = await this.reportService.checkAll(chunk).toPromise();
				let allMatched=response['result'][0]['matches'];//console.log(allMatched)
				let chunkarr=this.getAllMatch(chunk, allMatched);	//console.log(chunkarr)
				if(chunkarr.length>0){
					arr.push(... chunkarr);
				}			
				//console.log(this.allMatchtext);
			}
			//console.log(arr.length)
			let uniqueArray = arr.filter(function(item, pos) {
				return arr.indexOf(item) == pos;
			})
			this.allMatch=uniqueArray.length;
			if(this.allMatchtext.length>0){
				for(let key of uniqueArray){
					this.allMatchtext+='|'+key;
				}
			}else{
				this.allMatchtext=uniqueArray[0]
				for(let key of uniqueArray.slice(0)){
					this.allMatchtext+='|'+key;
				}
			}	
			//console.log(this.allMatch);
			//console.log(this.allMatchtext);
			this.checkOnAll=true;
			this.checking=false;
		} catch (error) {//console.log(error)	
			this.spellCheckErr='There was an error! '+ error;
			this.checking=false;	
		}		
	}
	getAllMatch(data, allMatched){
		//this.allMatch+=allMatched.length;
			let arr=[];
			if(allMatched&&allMatched.length>0){
				for(let item of allMatched){
					let word=data.substring ( item.offset, item.offset+item.length);
					let t={'text':word, 'suggestions':item.suggestions};
					arr.push(word);					
				}				
			}
			return arr
	}
	spellCheck(){//console.log(WEBSPELLCHECKER)
		this.curId=null;
		this.checkOn=!this.checkOn;
		let wscInstances = WEBSPELLCHECKER.getInstances()[0];//console.log(wscInstances)
		if(!wscInstances) return
		//console.log(wscInstances.isDisabled())
		if(this.checkOn){
			wscInstances.enable();
		}else{
			wscInstances.disable();
		}		
	}
	replacing=false;
	replaceAllText(){
		this.searchText=this.searchText.trim();
		if(!this.searchText) return
		let validstext= this.checkCha(this.searchText);
		if(validstext){
			Swal.fire({
				icon: 'info',
				title: "Find and Replace cannot run using Special Characters !@#$%^&*()+=\[\]{}:\\|<>\/?~. Please adjust your search.",				
            })
			return
		}
		if(this.replaceText.length>0){
			let validtext=this.checkCha(this.replaceText);
			if(validtext){
				Swal.fire({
					icon: 'info',
					title: "Find and Replace cannot run using Special Characters !@#$%^&*()+=\[\]{}:\\|<>\/?~. Please adjust your search.",				
				})
				return
			}
		}
		
		this.replacing=true;
		this.curId=null;
		//const re = new RegExp("\\b("+this.searchText+"(?=(?:[^><]*<[^<>]*>)*[^><]*$))\\b", 'igm');
		const re = new RegExp("\\b"+this.searchText+"(?!([^<]*?)>)\\b",'igm')
		const replaceString=this.replaceText;
		//const replaceHtml=' '+this.replaceText+' ';
		let ifReplace=false;
		let iftitle=false;
		
		/*for(let appendix of this.appendices.SUB_SECTIONS){
			let result = appendix.SECTION_TITLE.match(re);
			if(result&&result.length>0){console.log(appendix)
				appendix.SECTION_TITLE=appendix.SECTION_TITLE.replace(re, replaceString);
				ifReplace=true;					
			}
		}
		if(ifReplace){
			this.autoSave('appendix update',"appendix update","appendix update");
			ifReplace=false
		}
		*/
		try{
			for(let sec of this.frontpages){
				if(sec.SECTION_TITLE&&sec.SECTION_TITLE.length>0){
					let result = sec.SECTION_TITLE.match(re);
					if(result&&result.length>0){
						sec.SECTION_TITLE=sec.SECTION_TITLE.replace(re, replaceString);					
					}
				}
				if(sec.text&&sec.text.length>0){
					sec.text=sec.text.replace(re, replaceString);
					sec.text=this.retriveRFKEY(sec.text);
					sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);					
				}
				if(sec.SUB_SECTIONS){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.SECTION_TITLE&&sec1.SECTION_TITLE.length>0){
						let result = sec1.SECTION_TITLE.match(re);
						if(result&&result.length>0){
							sec1.SECTION_TITLE=sec1.SECTION_TITLE.replace(re, replaceString);					
						}
					}
					if(sec1.text&&sec1.text.length>0){
						sec1.text=sec1.text.replace(re, replaceString);
						sec1.text=this.retriveRFKEY(sec1.text);
						sec1.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec1.text);	
					}else if(sec1.TYPE=='TABLE'&&sec1.data&&(!sec1.data['erisName'])&&(sec1.id!='phaseI_project_summary_table')){
						this.checkExtraHeaderLock(re, replaceString, sec1.data);
						if(!sec1.data['locked']||(!sec1.data['locked']['header'])){//no header Lock
							for(let col of sec1.data.cols){
								let result = col.NAME.match(re);
								if(result&&result.length>0){
									col.NAME=col.NAME.replace(re, replaceString);
									col.NAME=this.retriveRFKEY(col.NAME);
									col.text=col.text.replace(re, replaceString);
									if(col.htmltext){
										col.htmltext=this.sanitizer.bypassSecurityTrustHtml(col.NAME);
									}
								}
							}
							
						}
						for(let row of sec1.data.rows){
							if(row['lock']){//row Lock
								continue
							}else{
								if(row.items&&row.items.length>0){
									for(let i=0; i<row.items.length; i++){//console.log(item)
										let item=row.items[i]
										if(sec1.data.cols[i]['lock']||item['lock']){//column lock/cell lock
											continue
										}else{
											if(item.htmltext&&item.htmltext.length>0){
												//item.DATA=item.DATA.replace(re, replaceString);
												item.htmltext=item.htmltext.replace(re, replaceString);	
												item.htmltext=this.retriveRFKEY(item.htmltext);
												item.DATA=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
											}	
										}								
									}
								}
							}
						}
						
					}/*else if(sec1.id=='phaseI_project_summary_table'){
						for(let row of sec1.data.rows){//console.log(row)
							for(let item of row){//console.log(item)
								if(item.html&&item.html.length>0){
									item.html=item.html.replace(re, replaceString);
									item.secHtml=item.secHtml.replace(re, replaceString);	
								}
							}
							
						}
					}else if(sec1.TYPE=='PHOTOS'&&sec1.photos.length>0){
						for(let photo of sec1.photos){
							if(photo.FILE_DESCRIPTION&&photo.FILE_DESCRIPTION.length>0){
								photo.FILE_DESCRIPTION=photo.FILE_DESCRIPTION.replace(re, replaceString);									
							}
						}
					}*/
				}
				}
			}
			for(let sec of this.contents){
				if(sec.SECTION_TITLE&&sec.SECTION_TITLE.length>0){
					let result = sec.SECTION_TITLE.match(re);
					if(result&&result.length>0){
						sec.SECTION_TITLE=sec.SECTION_TITLE.replace(re, replaceString);
						iftitle=true
					}
				}
				if(sec.text&&sec.text.length>0){
					sec.text=sec.text.replace(re, replaceString);
					//sec.htmltext=sec.htmltext.replace(re, replaceString);	
					sec.text=this.retriveRFKEY(sec.text);
					sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);
				}
				if(sec.pisummarydata&&sec.pisummarydata.length>1){
					for(let item of sec.pisummarydata){//console.log(row)
						if(item.html&&item.html.length>0){
							let result = item.html.match(re);
							if(result&&result.length>0){
								item.html=item.html.replace(re, replaceString);
								item.secHtml=item.secHtml.replace(re, replaceString);
								ifReplace=true
							}	
						}					
					}
				}else if(sec.pcasummarydata&&sec.pcasummarydata.length>1){
					for(let item of sec.pcasummarydata){//console.log(row)
						if(!item.cat&&item.inputType!='Checkmark'){
							let result = item.data.match(re);
							if(result&&result.length>0){
								item.data=item.data.replace(re, replaceString);
								ifReplace=true	
								//item.secHtml=item.secHtml.replace(re, replaceString);	
							}
						}					
					}
				}
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.SECTION_TITLE&&sec1.SECTION_TITLE.length>0){
						let result = sec1.SECTION_TITLE.match(re);
						if(result&&result.length>0){
							sec1.SECTION_TITLE=sec1.SECTION_TITLE.replace(re, replaceString);
							iftitle=true
						}
					}
					if(sec1.text&&sec1.text.length>0){
						sec1.text=sec1.text.replace(re, replaceString);
						sec1.text=this.retriveRFKEY(sec1.text);
						//sec1.htmltext=sec1.htmltext.replace(re, replaceString);	
						sec1.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec1.text);
					}else if(sec1.TYPE=='TABLE'&&sec1.data&&(!sec1.data['erisName'])){
						this.checkExtraHeaderLock(re, replaceString, sec1.data);
						if(!sec1.data['locked']||(!sec1.data['locked']['header'])){//no header Lock
							for(let col of sec1.data.cols){
								let result = col.NAME.match(re);
								if(result&&result.length>0){
									col.NAME=col.NAME.replace(re, replaceString);
									col.NAME=this.retriveRFKEY(col.NAME);
									col.text=col.text.replace(re, replaceString);
									if(col.htmltext){
										col.htmltext=this.sanitizer.bypassSecurityTrustHtml(col.NAME);
									}
								}
								
							}
						}						
						for(let row of sec1.data.rows){
							if(row['lock']){//row Lock
								continue
							}else{
								if(row.items&&row.items.length>0){
									for(let i=0; i<row.items.length; i++){//console.log(item)
										let item=row.items[i]
										if(sec1.data.cols[i]['lock']||item['lock']){//column lock/cell lock
											continue
										}else{
											if(item.htmltext&&item.htmltext.length>0){
												//item.DATA=item.DATA.replace(re, replaceString);
												item.htmltext=item.htmltext.replace(re, replaceString);	
												item.htmltext=this.retriveRFKEY(item.htmltext);
												item.DATA=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
											}
										}
										
									}
								}
							}
							
						}
					
					}/*else if(sec1.TYPE=='TABLE'&&sec1.data&&sec1.data['erisName']){
							for(let col of sec1.data.cols){
								if(col.NAME&&col.INTERNALNAME!="ES_RID"&&col.NAME.length>0){
									let result = col.NAME.match(re);
									if(result&&result.length>0){
										col.NAME=col.NAME.replace(re, replaceString);
										if(col.text){
											col.text=col.text.replace(re, replaceString);
										}
									
									}
								}
							}
					}*/else if(sec1.id=='pca_summary_0'){
						for(let row of sec1.data.rows){//console.log(row)
							for(let item of row){//console.log(item)
								if(item.htmltext&&item.htmltext.length>0){
									item.htmltext=item.htmltext.replace(re, replaceString);
									item.htmltext=this.retriveRFKEY(item.htmltext);
									//item.secHtml=item.secHtml.replace(re, replaceString);	
									item.secHtml=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);	
								}
							}
							
						}
					}else if(sec1.TYPE=='PHOTOS'&&sec1.photos.length>0){
						for(let photo of sec1.photos){
							if(photo.FILE_DESCRIPTION&&photo.FILE_DESCRIPTION.length>0){
								photo.FILE_DESCRIPTION=photo.FILE_DESCRIPTION.replace(re, replaceString);									
							}
						}
					}
					if(sec1.pisummarydata&&sec1.pisummarydata.length>1){
						for(let item of sec1.pisummarydata){//console.log(row)
							if(item.html&&item.html.length>0){
								let result = item.html.match(re);
								if(result&&result.length>0){
									item.html=item.html.replace(re, replaceString);
									item.html=this.retriveRFKEY(item.html);
									item.secHtml=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);	
									ifReplace=true	
								}	
							}					
						}
					}else if(sec1.pcasummarydata&&sec1.pcasummarydata.length>1){
						for(let item of sec1.pcasummarydata){//console.log(row)
							if(!item.cat&&item.inputType!='Checkmark'){
								let result = item.data.match(re);
										if(result&&result.length>0){
											item.data=item.data.replace(re, replaceString);
											ifReplace=true	
											//item.secHtml=item.secHtml.replace(re, replaceString);
										}	
							}					
						}
					}
					if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
					for(let sec2 of sec1.SUB_SECTIONS){
						if(sec2.SECTION_TITLE&&sec2.SECTION_TITLE.length>0){
							let result = sec2.SECTION_TITLE.match(re);
							if(result&&result.length>0){
								sec2.SECTION_TITLE=sec2.SECTION_TITLE.replace(re, replaceString);
								iftitle=true
							}
						}					
						if(sec2.text&&sec2.text.length>0){
							sec2.text=sec2.text.replace(re, replaceString);
							//sec2.htmltext=sec2.htmltext.replace(re, replaceString);	
							sec2.text=this.retriveRFKEY(sec2.text);
							sec2.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec2.text);
						}else if(sec2.TYPE=='TABLE'&&sec2.data&&(!sec2.data['erisName'])){
							this.checkExtraHeaderLock(re, replaceString, sec2.data);
							if(!sec2.data['locked']||(!sec2.data['locked']['header'])){//no header Lock
								for(let col of sec2.data.cols){
									let result = col.NAME.match(re);
									if(result&&result.length>0){
										col.NAME=col.NAME.replace(re, replaceString);
										col.NAME=this.retriveRFKEY(col.NAME);
										col.text=col.text.replace(re, replaceString);
										if(col.htmltext){
											col.htmltext=this.sanitizer.bypassSecurityTrustHtml(col.NAME);
										}
									}
								}
							}
						for(let row of sec2.data.rows){
							if(row['lock']){//row Lock
								continue
							}else{
								if(row.items&&row.items.length>0){
									for(let i=0; i<row.items.length; i++){//console.log(item)
										let item=row.items[i]
										if(sec2.data.cols[i]['lock']||item['lock']){//column lock/cell lock
											continue
										}else{
											if(item.htmltext&&item.htmltext.length>0){
												//item.DATA=item.DATA.replace(re, replaceString);
												item.htmltext=item.htmltext.replace(re, replaceString);	
												item.htmltext=this.retriveRFKEY(item.htmltext);
												item.DATA=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
											}
										}
									}
								}
							}
						}
					
						}/*else if(sec2.TYPE=='TABLE'&&sec2.data&&sec2.data['erisName']){
							for(let col of sec2.data.cols){
								if(col.NAME&&col.INTERNALNAME!="ES_RID"&&col.NAME.length>0){
									let result = col.NAME.match(re);
									if(result&&result.length>0){
										col.NAME=col.NAME.replace(re, replaceString);
										if(col.text){
											col.text=col.text.replace(re, replaceString);
										}
									
									}
								}
							}
						}*/else if(sec2.TYPE=='PHOTOS'&&sec2.photos.length>0){
							for(let photo of sec2.photos){
								if(photo.FILE_DESCRIPTION&&photo.FILE_DESCRIPTION.length>0){
									photo.FILE_DESCRIPTION=photo.FILE_DESCRIPTION.replace(re, replaceString);									
								}
							}
						}
						if(sec2.pisummarydata&&sec2.pisummarydata.length>1){
							for(let item of sec2.pisummarydata){//console.log(row)
								if(item.html&&item.html.length>0){
									let result = item.html.match(re);
										if(result&&result.length>0){
											item.html=item.html.replace(re, replaceString);
											item.html=this.retriveRFKEY(item.html);
											item.secHtml=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);											
											ifReplace=true	
										}	
								}					
							}
						}else if(sec2.pcasummarydata&&sec2.pcasummarydata.length>1){
							for(let item of sec2.pcasummarydata){//console.log(row)
								if(!item.cat&&item.inputType!='Checkmark'){
									let result = item.data.match(re);
										if(result&&result.length>0){
											item.data=item.data.replace(re, replaceString);
											ifReplace=true	
											//item.secHtml=item.secHtml.replace(re, replaceString);	
										}
									}					
							}
						}
				
					}
				}}
				}
			}
		} catch (e) {
			console.log('Replace All Error: ' + e);
			Swal.fire({
				icon: 'info',
				text: "Replacing encounter some errors, please try again",				
			})
			this.replacing=false;
		}
			if(this.summaryStatus&&ifReplace){
				if(this.summaryType=='PHASE I'){
					this.toTatalPISummary();
				}else if(this.summaryType=='PCA'){
					this.getTotalSummary();
				}
			}
			if(this.tempInfo.PCA_INDICATOR=='4099e'&&iftitle){
				this.getTotalUl()
			}
		this.saveTemplate()
	}
	curMatch=0;
	findNext(){
		this.curId=null;
		let matches=$('mark');
		for(let matche of matches){
			matche.style['border']='none'
		}
		if(this.curMatch<matches.length-1){
			this.curMatch++
		}else{
			this.curMatch=0
		}
		//console.log(matches[this.curMatch]);
		if(matches[this.curMatch]){
			this.scroll(matches[this.curMatch].id);	
			matches[this.curMatch].style['border']='#f88411 4px solid';
		}
		//matches[this.curMatch].style['background-color']='red'	;
	}
	replaceShow=false;
	replaceShow1=false;
	findPrev(){
		this.curId=null;
		let matches=$('mark');
		for(let matche of matches){
			matche.style['border']='none'
		}
		if(this.curMatch>0){
			this.curMatch--
		}else{
			this.curMatch=matches.length-1
		}
		//console.log(matches[this.curMatch]);
		//matches[this.curMatch].style['background-color']='red';
		if(matches[this.curMatch]){
			
			this.scroll(matches[this.curMatch].id);	
			matches[this.curMatch].style['border']='#f88411 4px solid';
		}
		
	}
	seclectedId='';
	replaceSingle(){
		this.searchText=this.searchText.trim();
		if(!this.searchText) return
		let validstext= this.checkCha(this.searchText);
		if(validstext){
			Swal.fire({
				icon: 'info',
				title: "Find and Replace dcannot run using Special Characters !@#$%^&*()+=\[\]{}:\\|<>\/?~. Please adjust your search.",				
            })
			return
		}
		if(this.replaceText){
			let valietext=this.checkCha(this.replaceText);
			if(valietext){
				Swal.fire({
					icon: 'info',
					title: "Find and Replace cannot run using Special Characters !@#$%^&*()+=\[\]{}:\\|<>\/?~. Please adjust your search.",				
				})
				return
			}
		}
		
		this.curId=null;
		//if(this.replaceText.trim().length==0) return
		let matches=$('mark');
		if(matches.length==0) return
		this.replacing=true;
		//const re = new RegExp("\\b("+this.searchText+"\\b)", 'igm');
		//const re = new RegExp("\\b("+this.searchText+"(?=(?:[^><]*<[^<>]*>)*[^><]*$))\\b", 'igm');
		const re = new RegExp("\\b"+this.searchText+"(?!([^<]*?)>)\\b",'igm')
		const replaceString=this.replaceText;
		//let matches=$('mark'); console.log(matches)
		//console.log(matches[0].id)
		//this.scroll(matches[0].id)	
		let selectedele= matches[this.curMatch];//console.log(selectedele.id)
		if(!selectedele) {
			this.replacing=false;
			return
		}
		let newid=Utils.uniqueIdGenerator();
		selectedele.id=newid;
		let rf=$(selectedele).parent(); //console.log(rf); //console.log(rf.attr('class'))
		let ele=$(selectedele).closest(".replaceContainer");//console.log(ele)
		let id=$(selectedele).closest(".replaceContainer").attr('data-id');	//console.log(id)//$(elem).parents(".myClass");
		let secx=$(selectedele).closest(".replaceContainer").attr('data-x');//console.log(secx)
		let secy=$(selectedele).closest(".replaceContainer").attr('data-y');//console.log(secy)
		let secv=$(selectedele).closest(".replaceContainer").attr('data-v');//console.log(secv)
		let secw=$(selectedele).closest(".replaceContainer").attr('data-w');//console.log(secw)
		let secz=$(selectedele).closest(".replaceContainer").attr('data-z');//console.log(secz)
		let type=$(selectedele).closest(".replaceContainer").attr('data-type');	//console.log(type)
		let sec=this.getSecbyId(this.contents,id); //console.log(sec);
		//console.log(matches)
		let secMatchs=[];
		for(let item of matches){
			let itemid=$(item).closest(".replaceContainer").attr('data-id');
			if(type=='text'||type=='title'){
				if(itemid==id){
					secMatchs.push(item)
				}
			}else if(type=='table'||type=='pitable'||type=='pstable'){
				let x=parseInt($(item).closest(".replaceContainer").attr('data-x'));
				let y=parseInt($(item).closest(".replaceContainer").attr('data-y'));
				let v=parseInt($(item).closest(".replaceContainer").attr('data-v'));
				let w=parseInt($(item).closest(".replaceContainer").attr('data-w'));
				let z=parseInt($(item).closest(".replaceContainer").attr('data-z'));
				if(secv>-1||secw>-1||secz>-1){
					if(itemid==id&&((secx==x&&(secz==z||secw==w))||secv==v)){//console.log(itemid, x, y)
						secMatchs.push(item)
					}
				}else if(secy>-1&&y>-1){
					if(itemid==id&&secx==x&&secy==y){//console.log(itemid, x, y)
						secMatchs.push(item)
					}
				}else if(!(secy>-1)&&(!(y>-1))){//console.log(itemid, x, y)
					if(itemid==id&&secx==x){
						secMatchs.push(item)
					}
				}			
			}else if(type=='photo'){
				let x=parseInt($(item).closest(".replaceContainer").attr('data-x'));
				if(itemid==id&&secx==x){
					secMatchs.push(item)
				}
			}			
		}
		//console.log(secMatchs)
		let secIndex=secMatchs.findIndex(item=>item.id==newid); //console.log(secIndex);
		if(secIndex==-1){
			this.replacing=false;
			return
		} 
		if(!sec){
			sec=this.getSecbyId(this.frontpages,id); console.log(sec);
		}
		if(rf.attr('class')&&rf.attr('class')=='placeholder'){
			//console.log(rf)
			///let status=rf.attr('data-status');
			//if(status=='N'){
				this.replacing=false;
				Swal.fire({
					html: 'Repeat Field has no content!'
				})
				return
		//	}
		}
		if(type=='text'){
			let result = sec.text.match(re);
			if(result.length>-1){
				//sec.text=sec.text.replace(re, replaceString);
				sec.text=this.replaceIndex(sec.text, re, secIndex, replaceString);
				//sec.htmltext=sec.htmltext.replace(re, replaceString);	
				sec.text=this.retriveRFKEY(sec.text);
				sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);
			}			
		}else if(type=='title'){
			//sec.SECTION_TITLE=sec.SECTION_TITLE.replace(re, replaceString);	
			sec.SECTION_TITLE=this.replaceIndex(sec.SECTION_TITLE, re, secIndex, replaceString);
			if(this.summaryStatus){
				if(this.summaryType=='PHASE I'){
					this.toTatalPISummary();
				}else if(this.summaryType=='PCA'){
					this.getTotalSummary();
				}
			}
			if(this.tempInfo.PCA_INDICATOR=='4099e'){
				this.getTotalUl();
			}		
		}else if(type=='table'){
			let x=parseInt(ele.attr('data-x'));
			let y=parseInt(ele.attr('data-y'));
			let w=parseInt(ele.attr('data-w'));
			let z=parseInt(ele.attr('data-z'));
			let v=parseInt(ele.attr('data-v'));
			console.log(x, y, w, z, v)
			console.log(sec.data)
			if(v>-1){//caption
				let item=sec.data.caption;console.log(item)
				item.text=this.replaceIndex(item.text, re, secIndex, replaceString);
				if(item.NAME&&item.NAME.length>0){
					//item.text=item.text.replace(re, replaceString);	
					item.NAME=this.replaceIndex(item.NAME, re, secIndex, replaceString);
					item.NAME=this.retriveRFKEY(item.NAME);
					item.htmltext=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
				}
			}else if(w>-1){//after header
				if(sec.data&&sec.data['locked']&&sec.data['locked']['afterHeaders'].length>0){
					if(sec.data['locked']['afterHeaders'].indexOf(x)>-1){
						this.replacing=false;
						//Swal.fire('Header is locked, can not edit');
						return
					}					
				}
				let item=sec.data['afterHeaders'][x][w];console.log(item)
				item.text=this.replaceIndex(item.text, re, secIndex, replaceString);console.log(item.text)
				if(item.NAME&&item.NAME.length>0){
					item.NAME=this.replaceIndex(item.NAME, re, secIndex, replaceString);console.log(item.NAME)
					item.NAME=this.retriveRFKEY(item.NAME);
					item.htmltext=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
				}	
			}else if(z>-1){//before header
				if(sec.data&&sec.data['locked']&&sec.data['locked']['beforeHeaders'].length>0){
					if(sec.data['locked']['beforeHeaders'].indexOf(x)>-1){
						this.replacing=false;
						//Swal.fire('Header is locked, can not edit');
						return
					}					
				}
				let item=sec.data['beforeHeaders'][x][z];console.log(item)
				item.text=this.replaceIndex(item.text, re, secIndex, replaceString);
				if(item.NAME&&item.NAME.length>0){
					//item.text=item.text.replace(re, replaceString);	
					item.NAME=this.replaceIndex(item.NAME, re, secIndex, replaceString);
					item.NAME=this.retriveRFKEY(item.NAME);
					item.htmltext=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
				}
			}else if(y>-1){
				if(sec.data&&sec.data.rows[x]&&sec.data.rows[x]['lock']){
					this.replacing=false;
					//Swal.fire('Row is locked, can not edit');
					return				
				}
				if(sec.data&&sec.data.cols[y]&&sec.data.cols[y]['lock']){
					this.replacing=false;
					//Swal.fire('Column is locked, can not edit');
					return
				}
				let item=sec.data.rows[x].items[y];
				if(item['lock']){
					this.replacing=false;
					//Swal.fire('Cell content is locked, can not edit');
					return
				}
				//item.data=item.data.replace(re, replaceString);
				item.data=this.replaceIndex(item.data, re, secIndex, replaceString);
				if(item.htmltext&&item.htmltext.length>0){
					//item.htmltext=item.htmltext.replace(re, replaceString);	
					item.htmltext=this.replaceIndex(item.htmltext, re, secIndex, replaceString);
					item.htmltext=this.retriveRFKEY(item.htmltext);
					item.DATA=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
				}	
			}else{
				if(sec.data&&sec.data['locked']&&sec.data['locked']['header']){
					this.replacing=false;
					//Swal.fire('Header is locked, can not edit');
					return
				}
				let item=sec.data.cols[x];console.log(item)
				//item.NAME=item.NAME.replace(re, replaceString);
				item.text=this.replaceIndex(item.text, re, secIndex, replaceString);
				if(item.NAME&&item.NAME.length>0){
					//item.text=item.text.replace(re, replaceString);	
					item.NAME=this.replaceIndex(item.NAME, re, secIndex, replaceString);
					item.NAME=this.retriveRFKEY(item.NAME);
					item.htmltext=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
				}	
			}
					
		}else if(type=='pitable'){
			let x=parseInt(ele.attr('data-x'));
			let y=parseInt(ele.attr('data-y'));
			let id=sec.data.rows[x][0].refId;
			let oriSec=this.getSecbyId(this.contents, id);
			let item:any;
			if(oriSec.pisummarydata){
				item=oriSec.pisummarydata[y];
			}else if(oriSec.pcasummarydata){
				item=oriSec.pcasummarydata[y];
			}
			console.log(oriSec)
			if(item.secHtml){console.log(item)
				//item.data=item.data.replace(re, replaceString);
				item.data=this.replaceIndex(item.data, re, secIndex, replaceString);
				//item.html=item.html.replace(re, replaceString);	
				item.html=this.replaceIndex(item.html, re, secIndex, replaceString);
				item.html=this.retriveRFKEY(item.html);
				item.secHtml=this.sanitizer.bypassSecurityTrustHtml(item.html);
			}else{console.log(item)
				//item.data=item.data.replace(re, replaceString);
				item.data=this.replaceIndex(item.data, re, secIndex, replaceString);
				if(item.ACTION){
					item.ACTION=item.data.split(',')
				}
				
				//item.html=item.html.replace(re, replaceString);	
			}	
			if(this.summaryStatus){
				if(this.summaryType=='PHASE I'){
					this.toTatalPISummary();
				}else if(this.summaryType=='PCA'){
					this.getTotalSummary();
				}
			}	
		}else if(type=='pstable'){
			let x=parseInt(ele.attr('data-x'));console.log(x)
			let y=parseInt(ele.attr('data-y'));console.log(y)
			let item=sec.data.rows[x][y];console.log(item)
			if(item.htmltext&&item.htmltext.length>0){
				//item.data=item.data.replace(re, replaceString);	
				item.data=this.replaceIndex(item.data, re, secIndex, replaceString);
				//item.htmltext=item.htmltext.replace(re, replaceString);	
				item.htmltext=this.replaceIndex(item.htmltext, re, secIndex, replaceString);
				item.htmltext=this.retriveRFKEY(item.htmltext);
				item.secHtml=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
			}else{
				//item.data=item.data.replace(re, replaceString);	
				item.data=this.replaceIndex(item.data, re, secIndex, replaceString);
				//item.htmltext=item.htmltext.replace(re, replaceString);	
				//item.secHtml=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
			}
				
		}/*else if(type=='eris'){
			let ifReplace=false
			let x=parseInt(ele.attr('data-x'));//console.log(x)
			let y=parseInt(ele.attr('data-y'));//console.log(y)
			
			if(!y){
				let col=sec.data.cols[x];//console.log(item)
				col.NAME=col.NAME.replace(re, replaceString);
			}			
		}*/else if(type=='photo'){
			let index=parseInt(ele.attr('data-x'));
			sec.photos[index].FILE_DESCRIPTION=sec.photos[index].FILE_DESCRIPTION.replace(re, replaceString);			
		}
		this.saveTemplate();
		
	}
	getAllText(){
		let data="";
		for(let page of this.frontpages){
			if(page.SECTION_TITLE&&page.SECTION_TITLE.length>0){
				data+=page.SECTION_TITLE+" "
			}
			if(page.text&&page.text.length>0){
				data+=page.text+" ";
			}
			if(page.SUB_SECTIONS&&page.SUB_SECTIONS.length>0){
				for(let page1 of page.SUB_SECTIONS){
					if(page1.SECTION_TITLE&&page1.SECTION_TITLE.length>0){
						data+=page1.SECTION_TITLE+" "
					}
					if(page1.text&&page1.text.length>0){
						data+=page1.text+" "
					}
					if(page1.TYPE=='TABLE'){
						if(page1.data){
							for(let header of this.headertype){
								if(page1.data[header]&&page1.data[header].length>0){
									for(let hrow of page1.data[header]){
										for(let hcell of hrow){
											data+=hcell.text+" "
										}
									}	
								}
							}
							for(let col of page1.data.cols){
								data+=col.text+" "
							}
							for(let row of page1.data.rows){
								if(row.items){
									for(let cell of row.items){
										if(cell.htmltext&&cell.htmltext.length>0){
											data+=cell.htmltext+" ";
										}else if(cell.data&&cell.data.length>0){
											data+=cell.htmltext+" ";
										}
									}
								}else{
									for(let cell of row){
										if(cell.html&&cell.html.length>0){
											data+=cell.html+" ";
										}else if(cell.htmltext&&cell.htmltext.length>0){
											data+=cell.htmltext+" ";
										}else if(cell.data&&cell.data.length>0){
											data+=cell.data+" ";
										}
									}
								}
								
								
							}
						}
						
					}
				}
			}
			
			
		}
		for(let sec of this.contents){
			if(sec.SECTION_TITLE&&sec.SECTION_TITLE.length>0){
				data+=sec.SECTION_TITLE+" ";
			}
			if(sec.text&&sec.text.length>0){
				data+=sec.text+" "
			}
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.SECTION_TITLE&&sec1.SECTION_TITLE.length>0){
						data+=sec1.SECTION_TITLE+" ";
					}
					if(sec1.text&&sec1.text.length>0){
						data+=sec1.text+" "
					}
					if(sec1.TYPE=='TABLE'||sec1.TYPE=='PITABLE'||sec1.id=='pca_summary_1'||sec1.id=='pca_summary_0'){
						if(sec1.data){
							if(sec1.TYPE=='TABLE'){
								for(let header of this.headertype){
										if(sec1.data[header]&&sec1.data[header].length>0){
											for(let hrow of sec1.data[header]){
												for(let hcell of hrow){
													data+=hcell.text+" "
												}
											}	
										}
									}
								for(let col of sec1.data.cols){
									if(col.NAME&&col.NAME){
										if(col.INTERNALNAME&&col.INTERNALNAME=="ES_RID") continue
										data+=col.NAME+" "
									}else if(col.text&&col.text.length>0){
										data+=col.text+" "
									}
								}
							}
							for(let row of sec1.data.rows){
								if(row.items&&row.items.length>0){
									for(let cell of row.items){console.log(cell)
										if(cell.htmltext&&cell.htmltext.length>0){
											data+=cell.htmltext+" ";
										}else if(cell.data&&cell.data.length>0){
											data+=cell.data+" ";
										}
									}
								}else{
									for(let cell of row){
										if(cell.html&&cell.html.length>0){
											data+=cell.html+" ";
										}else if(cell.htmltext&&cell.htmltext.length>0){
											data+=cell.htmltext+" ";
										}else if(cell.HTML&&cell.HTML.length>0){
											data+=cell.HTML+" ";
										}else if(cell.DATA&&cell.DATA.length>0){
											if(cell.COLUMNINTERNALNAME&&cell.COLUMNINTERNALNAME=="ES_RID") continue
											data+=cell.DATA+" ";
										}else if(cell.data&&cell.data.length>0){
											data+=cell.data+" ";
										}
									}
								}								
							}
						}						
					}
					if(sec1.TYPE=='PHOTOS'&&sec1.photos.length>0){
						for(let photo of sec1.photos){
							if(photo.FILE_DESCRIPTION&&photo.FILE_DESCRIPTION.length>0){
								data+=photo.FILE_DESCRIPTION+" ";									
							}
						}
					}
					if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
						for(let sec2 of sec1.SUB_SECTIONS){
							if(sec2.SECTION_TITLE&&sec2.SECTION_TITLE.length>0){
								data+=sec2.SECTION_TITLE+" ";
							}
							if(sec2.text){
								data+=sec2.text+" "
							}
							if(sec2.TYPE=='TABLE'){
								if(sec2.data){
									for(let header of this.headertype){
										if(sec2.data[header]&&sec2.data[header].length>0){
											for(let hrow of sec2.data[header]){
												for(let hcell of hrow){
													data+=hcell.text+" "
												}
											}	
										}
									}
									for(let col of sec2.data.cols){
										if(col.NAME&&col.NAME){
											if(col.INTERNALNAME&&col.INTERNALNAME=="ES_RID") continue
											data+=col.NAME+" "
										}else if(col.text&&col.text.length>0){
											data+=col.text+" "
										}
									}
									for(let row of sec2.data.rows){
										if(row.items){
											for(let cell of row.items){
												if(cell.htmltext&&cell.htmltext.length>0){
													data+=cell.htmltext+" ";
												}else if(cell.data&&cell.data.length>0){
													data+=cell.data+" ";
												}												
											}
										}else{
											for(let cell of row){
												if(cell.html&&cell.html.length>0){
													data+=cell.html+" ";
												}else if(cell.htmltext&&cell.htmltext.length>0){
													data+=cell.htmltext+" ";
												}else if(cell.HTML&&cell.HTML.length>0){
													data+=cell.HTML+" ";
												}else if(cell.DATA&&cell.DATA.length>0){
													if(cell.COLUMNINTERNALNAME&&cell.COLUMNINTERNALNAME=="ES_RID") continue
													data+=cell.DATA+" ";
												}else if(cell.data&&cell.data.length>0){
													data+=cell.data+" ";
												}
											}
										}								
									}
								}						
							}
							if(sec2.TYPE=='PHOTOS'&&sec2.photos.length>0){
								for(let photo of sec2.photos){
									if(photo.FILE_DESCRIPTION&&photo.FILE_DESCRIPTION.length>0){
										data+=photo.FILE_DESCRIPTION+" ";									
									}
								}
							}
							
						}
					}
				}
			}
			
			
		}
		//console.log(data)
		data=data.replace(/\&nbsp;/g, ' ').replace(/<[^>]*>?/gm, '').replace(/[^a-zA-Z0-9]/g, " ");//console.log(data)
		return data
	}
	replaceToggle(){
		this.curId=null; 
		this.listid=null;
		this.replaceShow=!this.replaceShow;
		this.searchText="";
		this.allMatchtext='';
		this.replaceText="";
		this.matchShow=false;
		this.checkOnAll=false;
		this.caseOn=false;
		this.curMatch=0
	}
	retriveRFKEY(text){//console.log(text)
		let that=this;
		let cleanText = text.replace(/[,#!$%\^&\*;.:_`~]/g, '');//replace(/[,\/#!$%\^&\*;:{}=\-_`~()]/g, '');
		let slots=$(cleanText).find('.placeholder');
		slots.each(function(){
			let id=$(this).data('id');
			let index=that.slots.findIndex(slot=>slot.SLOT_ID==id);//console.log(index);
			if(index>-1){
				let slotItem=that.slots[index];
				let a1=$(this).prop('outerHTML');						
				$(this).html('{'+slotItem.KEY+'}');
				let a2=$(this).prop('outerHTML');	
				text=text.replaceAll(a1, a2);				
			}			
		})
		//console.log(text)
		return text		
	}
	replaceIndex(text, string, at, repl) {
		let m=0;
		let newtext=text.replace(string, function(match) {
			m++
			 if(m === at+1 ) return repl;
	 
			 return match;
		 });
		 return newtext
	}
	checkCha(str){//console.log(str)
		const specialChars =this.reportService.specialChar;//console.log(specialChars)// /[`!@#$%^&*()+=\[\]{}:\\|<>\/~]/;///[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
		const result = specialChars.split('').some(specialChar1 => {
			if (str.includes(specialChar1)) {
			  return true;
			}
		
			return false;
		  });
		//let result = specialChars.test(str);
		//console.log(result)
		return result
	}		 
			
	companyGroupIndicator = false;
	getCompanyGroupIndicator() {
		let getcompanyinfoJson = { "PROCEDURE": "getcompanyprofile", "USER_ID": parseInt(this.userId) };
		this.reportService.univeralService(JSON.stringify(getcompanyinfoJson)).subscribe(data => {console.log(data)
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return;
			}

			if (data.COMPANY_GROUP_IND === 'Y') {
				this.companyGroupIndicator = true;							
			} else {
				this.companyGroupIndicator = false;
			}
		});
	}
	openPara(e, field, index1, index2, index3?){console.log(this.contents, field, index1, index2)
		if(!field){
			this.curFrm={'html':'<p></p>','text':'', 'secHtml':null, 'addedItem':null, 'index1':index1, 'index2':index2};
		}else{
			if(index3>-1){
				let id=this.contents[index1].SUB_SECTIONS[index2].id;
				if(id=='frm1104-2-2'){
					this.curFrm=this.contents[index1].SUB_SECTIONS[index2].data.sub[10].otherDetail.providers[index3]
					this.curFrm['index1']=index1;
					this.curFrm['index2']=index2;
					this.curFrm['index3']=index3;
				}
			}else{
				this.curFrm=this.contents[index1].SUB_SECTIONS[index2].data[field];
				this.curFrm['index1']=index1;
				this.curFrm['index2']=index2;
			}
			
		}
		this.frmShow=true;				
	  }
	  validateInput(e, data, field, type?){
		let value=e.target.value;
		if(value&&parseInt(value)>-1){
			if(type){
				e.target.value=this.getRound1(value, 1);
			}else{
				e.target.value=this.getRound1(value, 0);
			}
		  
		}else{
		  e.target.value=0;
		}
		data[field]=e.target.value;
	  }
	  curUnit={
		"BedroomCount": 0,
		"BathroomCount": 0,
		"AvgSquareFeetNumber": 0,
		"StyleType": "Garden or Flat",
		"PptyUnitTypeOccupiedUnitCount": 0,
		"VacantUnitCount": 0,
		"PptyUnitTypeDownUnitCount": 0,
		"PptyUnitTypeOtherUnitCount": 0,
		"PptyUnitTypeOccupiedInspectedUnitCount": 0,
		"PptyUnitTypeVacantInspectedUnitCount": 0,
		"PptyUnitTypeDownInspectedUnitCount": 0,
		"PptyUnitTypeOtherInspectedUnitCount": 0
		};
	  insertUnit(){
		let group=this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix; console.log(group)
		let newUnit=JSON.parse(JSON.stringify(this.curUnit))
		group.push(newUnit);
	  }
	  deleteUnit(){
		Swal.fire({
				icon:'warning',
				title: 'This will erase the last line. Is this what you want to do?',
				confirmButtonText: 'Yes',
				showCancelButton: true,
				backdrop:false,
			preConfirm: () => {
		  let group=this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix; console.log(group)
		  group.pop();
		  this.addUnit1();
		  this.addUnit2();
		  this.getTotalUnit();	
		  this.getTotalUnit1();	  
		}
	  })
	  }	
	  addUnit1(e?, index?, field?){
		if(index>-1){
		  let value=e.target.value;
		  if(value&&parseInt(value)>-1){
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix[index][field]=parseInt(value);
		  }else{
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix[index][field]=0;
		  }
		}    
		console.log(this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix)
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOccupiedUnitCount=0;
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalVacantUnitCount=0;
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.PptyTotalDownUnitCount=0;
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOtherUnitCount=0;
		for(let row of this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix){
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOccupiedUnitCount+=row.PptyUnitTypeOccupiedUnitCount;
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalVacantUnitCount+=row.VacantUnitCount;
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.PptyTotalDownUnitCount+=row.PptyUnitTypeDownUnitCount;
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOtherUnitCount+=row.PptyUnitTypeOtherUnitCount;
		}
		this.getTotalUnit();
		this.getTotalUnit1();
				
	  }
	  addUnit2(e?, index?, field?){
		if(index>-1){
		  let value=e.target.value;
		  if(value&&parseInt(value)>-1){
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix[index][field]=parseInt(value);
		  }else{
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix[index][field]=0;
		  }
		}  
		console.log(this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix)
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlOccupiedInspectedUnitCount=0;
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlVacantInspectedUnitCount=0;
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlDownInspectedUnitCount=0;
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlOtherInspectedUnitCount=0;
		for(let row of this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix){
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlOccupiedInspectedUnitCount+=row.PptyUnitTypeOccupiedInspectedUnitCount;
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlVacantInspectedUnitCount+=row.PptyUnitTypeVacantInspectedUnitCount;
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlDownInspectedUnitCount+=row.PptyUnitTypeDownInspectedUnitCount;
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlOtherInspectedUnitCount+=row.PptyUnitTypeOtherInspectedUnitCount;
		}
		this.getTotalUnit();
		
	  }
	  addUnit3(index,e?, field?){
		if(index>-1){
		  let value=e.target.value;
		  if(value&&parseInt(value)>-1){
			this.contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[index][field]=parseInt(value);
		  }else{
			this.contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[index][field]=0;
		  }
		}
		//console.log(this.PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[0])
		let item=this.contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[index];
		item.UnitCount=item.OccupiedUnitCount+item.VacantUnitCount+item.DownUnitCount;
		this.getTotalUnit();		
	  }
	  getTotalUnit(){
		let item1=this.contents[1].SUB_SECTIONS[0].data.summary;
		let item2=this.contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix;
		let item3=this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal;
		item1.RsdntlTotalUnitCount=item3.TotalOccupiedUnitCount+item3.TotalVacantUnitCount+item3.PptyTotalDownUnitCount+item3.TotalOtherUnitCount;//+item2.RsdntlOccupiedInspectedUnitCount+item2.RsdntlVacantInspectedUnitCount+item2.RsdntlDownInspectedUnitCount+item2.RsdntlOtherInspectedUnitCount;
		item1.CommercialTotalUnitCount=item2[0].UnitCount+item2[1].UnitCount;
		item1.TotalUnitCount=item1.RsdntlTotalUnitCount+item1.CommercialTotalUnitCount
	  }
	  
	  getTotalUnit1(){
		let dataset=this.contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail;console.log(dataset)
		let total=0;
		const keys=Object.keys(dataset);
		for(let key of keys){
			if(dataset[key]>0){
				/*if(key=='unequal'){
					delete dataset.unequal;
				}*/
				total+=dataset[key];
			}
		}
		console.log(total)
		if(total==this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOtherUnitCount){
			this.contents[1].SUB_SECTIONS[0].data['unequal']=false;
		}else{
			this.contents[1].SUB_SECTIONS[0].data['unequal']=true;
		}		
	  }
	  addUnit4(e,field){
		let value=e.target.value;
		let dataset=this.contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail;
		if(value&&parseInt(value)>-1){
			dataset[field]=parseInt(value);
		}else{
			dataset[field]=0;
		}
		this.getTotalUnit1();		
	  }
	  unitrow=1;
	  toFlat(){
		if(this.tempInfo.PHASE1_TYPE&&this.tempInfo.PHASE1_TYPE=='1103'){
			if(this.contents[2].SUB_SECTIONS[0].data.units.length==0){
				this.unitrow=5;
				for(let i=0; i<20; i++){
					this.contents[2].SUB_SECTIONS[0].data.units.push("");
				} 
			}else{
				this.unitrow=Math.ceil(this.contents[2].SUB_SECTIONS[0].data.units.length/4);  
				//if(this.unitrow<5){
				//	this.unitrow=5
				//}    
			}
			return
		}
		if(this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.length==0){
			this.unitrow=1
		}else{
			this.unitrow=Math.ceil(this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.length/4);      
		}
		console.log(this.unitrow)
	  }
	  public bedroomList=['0BR', '1BR', '2BR', '3BR', '4BR', '5BR'];
	  public bedroomStatus=['O = occupied', 'V = vacant', 'D = down','R = Other'];
	  insertUnitRow(){
		this.unitrow++;
		if(this.tempInfo.PHASE1_TYPE&&this.tempInfo.PHASE1_TYPE=="1103"){
			for(let i=0; i<4; i++){
				this.contents[2].SUB_SECTIONS[0].data.units.push("");
			} 
			return
		}
		let item={
			"UnitType": "",
			"SlrDesignatedUnitId": "",
			"OccupancyStatusType": ""
			}
			for(let i=0; i<4; i++){
				this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.push(JSON.parse(JSON.stringify(item)));
			} 
	  }
	  deleteUnitRow(){
		Swal.fire({
			icon:'warning',
			title: 'This will erase the last line. Is this what you want to do?',
			confirmButtonText: 'Yes',
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				if(this.tempInfo.PHASE1_TYPE&&this.tempInfo.PHASE1_TYPE=="1103"){
					for(let i=0; i<4; i++){
						this.contents[2].SUB_SECTIONS[0].data.units.pop();
					} 
					this.unitrow--;
					return
				}      
				for(let i=0; i<4; i++){
					if(this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[i]){
						this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.pop();
					}     
				}
				this.unitrow--;
			}
		})
	  } 
	  public sec3type1=[0,1,4,5]; //[0,1,4,5,6,7]; 
	  public sec3type2=[2,3]; 
	  insertVoliationRow(){
		let item={
			'Location':'',
			"OnRecord":'',
			"Description":''
		  }
		  this.contents[1].SUB_SECTIONS[1].data.ViolationRecord.push(item);
	  }
	  deleteVoliationRow(){
		Swal.fire({
			icon:'warning',
			title: 'This will erase the last line. Is this what you want to do?',
			confirmButtonText: 'Yes',
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {      
				this.contents[1].SUB_SECTIONS[1].data.ViolationRecord.pop();
			}
		})
	  }
	  clearOther(secInfo){
		secInfo.detail.status='';
		if(secInfo.needRepair){
			secInfo.needRepair.status='';
		}
		
	  }
	  insertViolationRow(doc){
		let baserow=JSON.parse(JSON.stringify(doc.baserow));
		doc.list.push(baserow)
	  }
	  deleteViolationRow(doc){
		Swal.fire({
			icon:'warning',
			title: 'This will erase the last line. Is this what you want to do?',
			confirmButtonText: 'Yes',
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {      
				doc.list.pop();
			}
		})
	  }
	  insertMaterials(doc){
		let baserow=JSON.parse(JSON.stringify(doc.baserow));
		doc.materials.push(baserow)
	  }
	  deleteMaterials(doc){
		Swal.fire({
			icon:'warning',
			title: 'This will erase the last line. Is this what you want to do?',
			confirmButtonText: 'Yes',
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {      
				doc.materials.pop();
			}
		})
	  }
	  addBedroomType(val, rowIndex, colindex,  field){
		let index=4*rowIndex+colindex;; console.log(index)
		if(!this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index]){
			let item={
				"UnitType": "",
				"SlrDesignatedUnitId": "",
				"OccupancyStatusType": ""
			  }
			this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index]=item;
		}
		this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index][field]=val;				
	  }
	  addStaus(val, rowIndex, colindex,  field){
		let index=4*rowIndex+colindex; console.log(index)
		let status=Array.from(val)[0];
		if(!this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index]){
			let item={
				"UnitType": "",
				"SlrDesignatedUnitId": "",
				"OccupancyStatusType": ""
			  }
			this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index]=item;
		}
		this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index][field]=status;				
	  }
	  addinput(e, rowIndex, colindex,  field){
		let val=e.target.value.trim();
		let index=4*rowIndex+colindex; console.log(index)
		if(!this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index]){
			let item={
				"UnitType": "",
				"SlrDesignatedUnitId": "",
				"OccupancyStatusType": ""
			  }
			this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index]=item;
		}
		this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index][field]=val;
	  }
	  addinput1(e, rowIndex, colindex,  field){
		let val=e.target.value.trim().slice(0,1);
		let index=4*rowIndex+colindex; console.log(index)
		if(!this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index]){
			let item={
				"UnitType": "",
				"SlrDesignatedUnitId": "",
				"OccupancyStatusType": ""
			  }
			this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index]=item;
		}
		this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index][field]=val;
	  }
	  addUnitId(e, rowIndex, colindex, field?){
		let val=e.target.value.trim();
		let index=4*rowIndex+colindex;
		if(this.tempInfo.PHASE1_TYPE&&this.tempInfo.PHASE1_TYPE=="1103"){
			this.contents[2].SUB_SECTIONS[0].data.units[index]=val;
			return
		}
		if(!this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index]){
			let item={
				"UnitType": "",
				"SlrDesignatedUnitId": "",
				"OccupancyStatusType": ""
			  }
			this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index]=item;
		}
		this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index][field]=val;
	  }
	  addListParties(data){
		let item= {
		  "Name":{'html':'', 'secHtml':null, 'text':''},
		  "Title":{'html':'', 'secHtml':null, 'text':''},
		  "Company":{'html':'', 'secHtml':null, 'text':''},
		  "Affiliation":{'html':'', 'secHtml':null, 'text':''},
		  "Comment":{'html':'', 'secHtml':null, 'text':''},
		};
		data.push(item);
	  }
	  deleteListParties(data){
		Swal.fire({
				icon:'warning',
				title: 'This will erase the last line. Is this what you want to do?',
				confirmButtonText: 'Yes',
				showCancelButton: true,
				backdrop:false,
			preConfirm: () => {		  
				data.pop();	  
			}
	  	})		
	  }
	  selectNone(e, data){
		if(e.target.value=="X"){
			data.checkItem=['','','','','','','','',''];
		}
	  }
	  selectItem(e, data){
		if(e.target.value=="X"){
			data.None='';
		}
	  }	
	  summaryCheck(e, item, field){
		if(e.target.checked){
			item[field]='Y';
			if(field=="acceptable"){
				item.notacceptable='N';
				item.requireFurther='N';
			}else if(field=="notacceptable"){
				item.acceptable='N';
			}else if(field=="requireFurther"){
				item.acceptable='N';
			}
			
		}else{
			item[field]='N';
		}
	}
	selectRate(e, item, rate){
		//if(e.target.checked){
			item.rate=rate;  
		//}
		
	}
	
	getAllDeficiencies(){
		let crs=[];
		let prs=[];
		let pr90s=[];
		let ors=[];
		let adds=[];
		let crstotal=0;
		let prstotal=0;
		let pr90stotal=0;
		//let orstotal=0;
		let addstotal=0;
		if(this.tempInfo?.PCA_INDICATOR!='frm1104') return
		for(let sec of this.contents){
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.data.otherDetail&&sec1.data.otherDetail.hasDeficiencies=='YES'){console.log(sec1.data)
						for(let item of sec1.data.otherDetail.deficiencies){
							if(item.status=='YES'){
								if(item.cost&&item.cost>0){
									item.cost=this.getRound1(item.cost, 2);
								}else if(item.cost&&item.cost<0){
									item.cost=0;
								}
								item['location']=sec1.SECTION_TITLE;
								if(item.type=="crs"){
									crs.push(item);
									crstotal+=item.cost;
								}else if(item.type=="pr90s"){
									pr90s.push(item);
									pr90stotal+=item.cost;
								}else if(item.type=="prs"){
									prs.push(item);
									prstotal+=item.cost;
								}else if(item.type=="ors"){
									ors.push(item);
								}else if(item.type=="adds"){
									adds.push(item);
									addstotal+=item.cost;
								}
							}
						}
					}else if(sec1.data.deficiencies){
						for(let item of sec1.data.deficiencies){
							if(item.status=='YES'){
								if(item.cost&&item.cost>0){
									item.cost=this.getRound1(item.cost, 2);
								}else if(item.cost&&item.cost<0){
									item.cost=0;
								}
								item['location']=sec1.SECTION_TITLE;
								if(item.type=="crs"){
									crs.push(item);
									crstotal+=item.cost;
								}else if(item.type=="pr90s"){
									pr90s.push(item);
									pr90stotal+=item.cost;
								}else if(item.type=="prs"){
									prs.push(item);
									prstotal+=item.cost;
								}else if(item.type=="ors"){
									ors.push(item);
								}else if(item.type=="adds"){
									adds.push(item);
									addstotal+=item.cost;
								}
							}
						}
					}
					if(sec1.data.sub&&sec1.data.sub.length>0){
						for(let sec2 of sec1.data.sub){
							if(sec2.otherDetail&&sec2.otherDetail.hasDeficiencies=='YES'){
								for(let item of sec2.otherDetail.deficiencies){console.log(sec2)
									if(item.cost&&item.cost>0){
										item.cost=this.getRound1(item.cost, 2);
									}else if(item.cost&&item.cost<0){
										item.cost=0;
									}
									item['location']=sec2.subcat;
									if(item.status=='YES'){
										if(item.type=="crs"){
											crs.push(item);
											crstotal+=item.cost;
										}else if(item.type=="pr90s"){
											pr90s.push(item);
											pr90stotal+=item.cost;
										}else if(item.type=="prs"){
											prs.push(item);
											prstotal+=item.cost;
										}else if(item.type=="ors"){
											ors.push(item);
										}else if(item.type=="adds"){
											adds.push(item);
											addstotal+=item.cost;
										}
									}
								}
							}
						}
					}
				}
				
			}
			
		}
		let doc=this.contents[4].SUB_SECTIONS[0].data;
		doc.summarydata['adds']=adds;
		doc.summarydata['crs']=crs;
		doc.summarydata['pr90s']=pr90s;
		doc.summarydata['prs']=prs;
		doc.summarydata['ors']=ors;
		doc.summarylabel[0].total=addstotal;
		doc.summarylabel[1].total=crstotal;
		doc.summarylabel[2].total=pr90stotal;
		doc.summarylabel[3].total=prstotal;
		//console.log(doc)
	}
	USDollar = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		//trailingZeroDisplay: 'stripIfInteger',
	});
	getRound1(val, decimal, type?){//console.log(val, decimal, type)
		let data=0;
			if(this.pcaOp.round=='Round'){
				if(type){
					data=Math.round(val*1000)/1000;
				}else if(decimal==2){
					data=Math.round(val*100)/100;
				}else if(decimal==1){
					data=Math.round(val*10)/10;
				}else if(decimal==0){
					data=Math.round(val);
				}
				
			}else if(this.pcaOp.round=='Round Up'){
				if(type){
					data=Math.ceil(val*1000)/1000;
				}else if(decimal==2){
					data=Math.ceil(val*100)/100;
				}else if(decimal==1){
					data=Math.round(val*10)/10;
				}else if(decimal==0){
					data=Math.ceil(val);
				}
				
			}else if(this.pcaOp.round=='Round Down'){
				if(type){
					data=Math.floor(val*1000)/1000;
				}else if(decimal==2){
					data=Math.floor(val*100)/100;
				}else if(decimal==1){
					data=Math.round(val*10)/10;
				}else if(decimal==0){
					data=Math.floor(val);
				}
				
			}
			//console.log(data)
			return data;
		}
		ifdeficiencies(e, doc){
			if(e.target.value=='YES'){
				doc.otherDetail.hasDeficiencies='YES';
			}else{
				doc.otherDetail.hasDeficiencies='NO';
			}
		}
		setvalue(e, item){//console.log(e.target.value)
			let value=e.target.value;
			if(value>-1){
				item.cost=this.getRound1(value, 0);	
				e.target.value=item.cost;
			}else{
				e.target.value=0;
			}
			//console.log(item)
		}
		addTableClass(e, doc){
			//console.log(e.target.value, type);
			let val=e.target.value.trim();
			if(val){
				doc['borderClass']=val;
			}else if(doc['borderClass']){
				delete doc.borderClass;
			}		
			console.log(doc)
		}
		groupList=[];
		groups=[];
		async getUserGroups(){
			let inputJson={"PROCEDURE":"getcompanygroups","USER_ID":parseInt(this.userId), "ACTIVE_ONLY":"Y"};
			console.log(JSON.stringify(inputJson));
			let data= await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
				console.log(data);
				this.loading=false;
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)							
				}else{
					this.groups=data.GROUP_LIST;					
				}		
					
		}
		groupShow=false;
		groupEditPermission=false;
		async checkgrouppermission(){
			let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 50};
			console.log(checkUserInputJson);
			let checkResponse= await this.reportService.univeralService(JSON.stringify(checkUserInputJson)).toPromise();
				console.log(checkResponse)
				if (checkResponse.RESPONSE_STATUS=='N') {
					this.throwError(checkResponse)
				}else{
					if (checkResponse.USER_PERMISSION == 'N') {
						this.groupEditPermission=false;		//this.throwError(checkResponse)		
					} else if (checkResponse.USER_PERMISSION == 'Y'){
						this.groupEditPermission = true;
					}
				}		
		}
		async getTempGroup(){
			await this.checkgrouppermission();
			//await this.getUserGroups();
			this.groupNone=false;
			let inputJson={"PROCEDURE":"gettemplategroups","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID};
			console.log(JSON.stringify(inputJson));
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);
				this.loading=false;
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)							
				}else{
					this.groupList=[];
					this.groups=data.TEMPLATE_GROUP_LIST;
					if(data.ALL_GROUPS=='Y'){
						this.groupAll=true;
						for(let g of data.TEMPLATE_GROUP_LIST){
							if(g.SELECTED_TEMPLATE=='Y'){
								this.groupList.push(g.GROUP_ID);
							}
							
						}
					}else{
						this.groupAll=false;
						if(data.TEMPLATE_GROUP_LIST.length>0){
						for(let g of data.TEMPLATE_GROUP_LIST){
							if(g.SELECTED_TEMPLATE=='Y'){
								this.groupList.push(g.GROUP_ID);
							}
							
						}
					}
					}
					
										
				}		
			})	
		}
		updateTempGroup(){
			if(!this.groupEditPermission) return
			let inputJson={"PROCEDURE":"updatetemplategroups","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID};
			if(this.groupAll){
				inputJson['GROUP_LIST']='All';
			}else if(this.groupList.length>0){
				inputJson['GROUP_LIST']=this.groupList.join(",");
			}
			console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)							
				}else{
					let Toast=Swal.mixin({
							toast: true,						
							position: 'center',
							showConfirmButton: false,
							timer: 3000
						})
					Toast.fire({
						icon: 'success',
						title: data.MESSAGE
					})					
				}	
			})	
		}
	groupAll=false;
	groupNone=false;
	setGroupList(e, id){
		if(e.target.checked){
			if(id=='all'){
				this.groupList=[];
				for(let group of this.groups){
					this.groupList.push(group.GROUP_ID);
				}
				this.groupNone=false;
			}if(id=='none'){
				this.groupList=[];
				this.groupNone=true;
				this.groupAll=false;
			}else{
				if(this.groupList.indexOf(id)==-1){
					this.groupList.push(id);
				}
				this.groupNone=false;
			}
			
		}else if(id!='all'){
			let index=this.groupList.indexOf(id)
			if(index>-1){
				this.groupList.splice(index,1);
			}
		}
	}
	divideText2(text) {
		let maxBytes=environment.api.spellcheckmaxbyte;
		const encoder = new TextEncoder();
		const words = text.split(/\s+/);//console.log(words) 
		//const words=this.splitAndRemoveDuplicates(text); console.log(words) 
		let parts = [];
		let currentPart = [];
		let currentSize = 0;

		for (let word of words) {
			let wordSize = encoder.encode(word + ' ').length;

			if (currentSize + wordSize > maxBytes) {
				parts.push(currentPart.join(' '));
				currentPart = [];
				currentSize = 0;
			}

			currentPart.push(word);
			currentSize += wordSize;
		}

		if (currentPart.length > 0) {
			parts.push(currentPart.join(' '));
		}
		//console.log(parts.length)
    	return parts;
	}
	splitAndRemoveDuplicates(inputString) {
		// Split the string into an array of words
		let wordsArray = inputString.split(/\s+/);
	
		// Use a Set to remove duplicates
		let uniqueWords = [...new Set(wordsArray)];
	
		return uniqueWords;
	}
	openHFPage(id){
		let inputJson={"PROCEDURE":"getheaderfooterbyid", "USER_ID":parseInt(this.userId), "HEADERFOOTER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);					
			}else{console.log(data)
				if(data.HF_DATA&&data.HF_DATA.length>0){
					let htData=JSON.parse(data.HF_DATA);
					if(htData.inputType&&htData.inputType=='HTML'){
						let dataInput=htData.inputType;
 						let savedHTML=this.sanitizer.bypassSecurityTrustHtml(htData.text); 
					
					//this.titleService.setTitle("Footer"+' - ');
					//this.location.go('/cover/Footer-'+data.HEADERFOOTER_ID.toString());
					let newWin = window.open('',data.HF_TITLE);
					newWin.document.write(htData.text);
					newWin.document.close()
					//let new_window = window.open(URL.createObjectURL(new Blob([htData.text], { type: "text/html" })))
					
				}
				}				
			}
		})		
	}
	allowPhase1PS='N';
	getAllowPhase1PS(id){
		let inputJson={"PROCEDURE":"getallowphase1ps","USER_ID":parseInt(this.userId),"TEMPLATE_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);					
			}else{console.log(data)
				this.allowPhase1PS=data.ALLOW_PHASE1_PS;	
			}
		})
	}
	checkExtraHeaderLock(re, replaceString, data){
		if(data['caption']){
			let col =data['caption']
			let result = col.NAME.match(re);
			if(result&&result.length>0){
				col.NAME=col.NAME.replace(re, replaceString);
				col.NAME=this.retriveRFKEY(col.NAME);
				col.text=col.text.replace(re, replaceString);
				if(col.htmltext){
					col.htmltext=this.sanitizer.bypassSecurityTrustHtml(col.NAME);
				}
			}							
		}
		if(data['beforeHeaders']&&data['beforeHeaders'].length>0){
			for(let i=0; i<data['beforeHeaders'].length; i++){
				if(data['locked']&&data['locked']['beforeHeaders'].length>0){//beforeHeaders lock
					if(data['locked']['beforeHeaders'].indexOf(i)>-1){
						continue
					}
				}
				for(let col of data['beforeHeaders'][i]){
					let result = col.NAME.match(re);
					if(result&&result.length>0){
						col.NAME=col.NAME.replace(re, replaceString);
						col.NAME=this.retriveRFKEY(col.NAME);
						col.text=col.text.replace(re, replaceString);
						if(col.htmltext){
							col.htmltext=this.sanitizer.bypassSecurityTrustHtml(col.NAME);
						}
					}
				}
			}
		}
		if(data['afterHeaders']&&data['afterHeaders'].length>0){
			for(let i=0; i<data['afterHeaders'].length; i++){
				if(data['locked']&&data['locked']['afterHeaders'].length>0){//afterHeaders lock
					if(data['locked']['afterHeaders'].indexOf(i)>-1){
						continue
					}
				}
				for(let col of data['afterHeaders'][i]){
					let result = col.NAME.match(re);
					if(result&&result.length>0){
						col.NAME=col.NAME.replace(re, replaceString);
						col.NAME=this.retriveRFKEY(col.NAME);
						col.text=col.text.replace(re, replaceString);
						if(col.htmltext){
							col.htmltext=this.sanitizer.bypassSecurityTrustHtml(col.NAME);
						}
					}
				}
			}
		}
	}
	copyTableData(data){//console.log(data);
		this.clipBoard=data;
			Swal.fire({
				icon: 'success',
				title: "Table copied! Choose an existing table or create a new table to paste the copied table."
			})
	}
	pasteTableData(type, id){console.log(this.clipBoard, this.selectedEditor)
		let that=this;
		if(this.clipBoard){
			Swal.fire({
				icon:'warning',
				title: 'Existing table content will be overwritten by the copied table content upon pasting. Would you like to continue?',
				confirmButtonText: 'Paste',
				showLoaderOnConfirm: true,
				showCancelButton: true,
				backdrop:false,
				preConfirm: () => {
					this.selectedCell=null;
					let copied=JSON.parse(JSON.stringify(that.clipBoard));
					if(type=='F'){
						this.toFContentData('data', copied.data, '');
						if(that.clipBoard.landscape){
							this.toFContentData('landscape', copied.landscape, '');
						}
						if(that.clipBoard.SECTION_TITLE){
							this.toFContentData('SECTION_TITLE', copied.SECTION_TITLE, '');
						}
					}else if(type=='O'){
						this.toContentData('data', copied.data, '');
						if(that.clipBoard.landscape){
							this.toContentData('landscape', copied.landscape, '');
						}
						if(that.clipBoard.SECTION_TITLE){
							this.toContentData('SECTION_TITLE', copied.SECTION_TITLE, '');
						}
					}
					this.zone.run(()=>{this.autoSave();})			
				}
			})
		}else{
			Swal.fire({
			icon:'info',
			title: 'Please copy a table first.',
			})
		}
	}
	customizedTablesave(){
		if(this.curCell){
			this.itemIndex++;
			this.curCell['reqIndex']=this.itemIndex;
			this.toCell(this.curSec.id);	
		}else if(this.selectedHeaderType&&this.curHeader){
			this.toCol(this.curSec.id,this.selectedHeaderType)
		}else if(!this.selectedHeaderType&&this.curHeader){
			this.toCol(this.curSec.id)
		}	
		this.saveTemplate();			
	}
	/*htmlstring=[
		`<div>
			<label style="font-weight:bold; font-size:10px; font-family: Arial"><label id="sig-label">Signature Label</label></label>
			<div style="height:40px; line-height:40px; margin:0; border-bottom: 2px solid black">
				<img id="sig-img" src="/assets/images/signature.jpg" alt="signature" width="200" height="50" style="height:38px; width:auto;vertical-align:bottom; margin-bottom: 4px;margin-left:4px">
			</div>
			<label id="sig-name" style="font-size:11px; margin:5px; font-family:Arial">Add Your Name Here</label><br>
			<label id="sig-title" style="font-size:11px; margin:5px; font-family:Arial">Add Your Title Here</label>
		</div>`,
		`<div>
			<label style="font-weight:bold; font-size:10px; font-family: Arial"><label id="sig-label">Signature Label</label></label>
			<div style="height:40px; line-height:40px" >
				<img id="sig-img" src="/assets/images/signature.jpg" alt="signature" width="200" height="50" style="height:38px; width:auto;vertical-align:bottom; margin-bottom: 4px;margin-left:4px">
			</div>
			<label id="sig-name" style="font-size:11px; margin:5px; font-family:Arial">Add Your Name Here</label><br>
			<label id="sig-title" style="font-size:11px; margin:5px; font-family:Arial">Add Your Title Here</label>
		</div>`,
	`<div>
		<div style="height:40px; line-height:40px; margin:0;">
            <img id="sig-img" src="/assets/images/signature.jpg" alt="signature" width="200" height="50" style="height:38px;width:auto;vertical-align:bottom; margin-bottom: 4px;margin-left:4px">
        </div>
        <label id="sig-name" style="font-size:11px; margin:5px; font-family:Arial;">Add Your Name Here</label><br>
        <label id="sig-title" style="font-size:11px; margin:5px; font-family:Arial;">Add Your Title Here</label>        
	</div>`,
	`<div style="padding:10px;">
		<div style="height:40px; line-height:40px; margin:0; border-bottom: 2px solid black">
            <img id="sig-img" src="/assets/images/signature.jpg" alt="signature" width="200" height="50" style="height:38px;width:auto;vertical-align:bottom; margin-bottom: 4px;margin-left:4px">
        </div>
        <label id="sig-name" style="font-size:11px; margin:5px; font-family:Arial">Add Your Name Here</label><br>
        <label id="sig-title" style="font-size:11px; margin:5px; font-family:Arial">Add Your Title Here</label>        
	</div>`,
	`<div style="padding:10px; border: 1px solid black">
		<div style="height:40px; line-height:40px; margin:0;">
            <img id="sig-img" src="/assets/images/signature.jpg" alt="signature" width="200" height="50" style="height:38px;width:auto;vertical-align:bottom; margin-bottom: 4px;margin-left:4px">
        </div>
        <label id="sig-name" style="font-size:11px; margin:5px; font-family:Arial">Add Your Name Here</label><br>
        <label id="sig-title" style="font-size:11px; margin:5px; font-family:Arial">Add Your Title Here</label><br>
        <label style="font-size:11px; margin:5px; font-family:Arial">Date: <span id="sig-date">Add Your Date Here</span></label>
	</div>`,
	`<div>
		<div style="height:40PX; line-height:40PX; margin:0; border-bottom: 2px solid black">
            <img id="sig-img" src="/assets/images/signature.jpg" alt="signature" width="200" height="50" style="display:block; height:38px; width:auto; vertical-align:bottom; margin-top: 4px;margin-bottom: 4px; margin-left: auto; margin-right: auto;">
        </div>
        <p id="sig-name" style="font-size:11px; margin:5px;  font-family:Arial; text-align:center">Add Your Name Here</p>
        <p id="sig-title" style="font-size:11px; margin:5px;  font-family:Arial; text-align:center">Add Your Title Here</p>
	</div>`,
	`<div>
		<div style="display:flex;width:100%; text-align: left; height: 40px" class="alignLeft">
			<div style="height:20px; height:20px; align-self: flex-end; white-space: nowrap"><label id="sig-label" style="font-family:Arial;font-size:10pt">Signature Label</label></div>
			<div style="border-bottom: 1px solid black;flex: 1;align-self: flex-end; height: 40px">
				<img id="sig-img" src="/assets/images/signature.jpg" alt="signature" style="height:38px; max-width:100%; margin-bottom: 2px; margin-left: 10px">
			</div>		
		</div>
		<p id="sig-name" style="font-family:Arial;font-weight:bold;margin-top: 10px;font-size:10pt">Add Your Name Here</p>
		<p id="sig-title" style="font-family:Arial;font-weight:bold;margin-top: 5px;font-size:10pt">Add Your Title Here</p>
	</div>`]
	
	getbase64fromhtml(){
		let allbase64=[];
		for(let ht of this.htmlstring){
			let base64string=this.htmlToBase64(ht);
			allbase64.push(base64string);
		}
		console.log(allbase64);
		this.check64(allbase64);
	}
	htmlToBase64(htmlContent) {
		// Convert HTML string to Base64
		return btoa(htmlContent);
	}
	check64(allbase64){
		let allele=[]
		for(let ht of allbase64){
			let ele=atob(ht);
			allele.push(ele);
		}
		console.log(allele);
	}*/
	newPcaTableSetting=[{'start':1, 'end':this.pcaOp.reserve, 'selected':false}, {'start':null, 'end':null, 'selected':false}, {'start':null, 'end':null, 'selected':false}];
	pcaTableSetting:any[]
	pcaTableValidate=true;
	pcaTableSize='all';
	savePcaTableConfig(e, type, doc){//console.log(type, value)
		let val=e.target.value;		
		this.pcaTableSize=val;
		if(val=='split'){
			if(!doc['pcaTableSetting']){
				this.pcaTableSetting=this.newPcaTableSetting
				if(this.pcaOp.reserve>24){
					this.pcaTableSetting[0]={'start':1, 'end':12, 'selected':true};
					this.pcaTableSetting[1]={'start':13, 'end':24, 'selected':true};
					this.pcaTableSetting[2]={'start':25, 'end':this.pcaOp.reserve, 'selected':true};
				}else if(this.pcaOp.reserve>12){
					this.pcaTableSetting[0]={'start':1, 'end':12, 'selected':true};
					this.pcaTableSetting[1]={'start':13, 'end':this.pcaOp.reserve, 'selected':true};					
				}else{
					this.pcaTableSetting[0]={'start':1, 'end':this.pcaOp.reserve, 'selected':true};
				}
			}
		}
	}
	setPcaTablePage(e, tableNum:number){
		if(e.target.checked){
			let val1=parseInt($('#start'+tableNum).val());
			let val2=parseInt($('#end'+tableNum).val());
			if(!this.pcaTableSetting[tableNum]){
				this.pcaTableSetting[tableNum]={'start':null, 'end':null, 'selected':true}
			}
			this.pcaTableSetting[tableNum]['selected']=true;
			this.pcaTableSetting[tableNum]['start']=isNaN(val1) ? null : val1;
			this.pcaTableSetting[tableNum]['end']=isNaN(val2) ? null : val2;
		}else{
			this.pcaTableSetting[tableNum]['selected']=false;
		}
	}
	savePcaTablePage(doc, ele){
		let ifvalid = true;
		if(this.pcaTableSize=='split'){
			ifvalid=this.validatePcaTableSetting();
		}
		if(ifvalid){
			doc.tableSize=this.pcaTableSize;
			if(this.pcaTableSize=='split'){
				doc['pcaTableSetting']=this.pcaTableSetting;
			}else{
				delete doc['pcaTableSetting']
			}	
			this.saveTemplate();
			if(ele){
				ele.hide();
			}	
		}
	}
	checkPcaTableSetting(doc){
		if(doc&&doc.TYPE=='PCATABLE'&&doc['ZOOM']){
			if(!doc.tableSize){
				doc.tableSize='all';
				
			}
			this.pcaTableSize=doc.tableSize;
			if(doc.tableSize=='split'&&doc['pcaTableSetting']){
				this.pcaTableSetting=doc['pcaTableSetting'];	
			}		
		}
	}
	validatePcaTableSetting(){
		this.pcaTableValidate=true;
		if(this.pcaTableSetting.length>0){
			for(let tableset of this.pcaTableSetting){
				if(tableset.selected){
					if(!tableset.start||!tableset.end){
						this.pcaTableValidate=false;
					}else if(tableset.start>tableset.end){
						this.pcaTableValidate=false;
					}else if(tableset.start<1||tableset.end>this.pcaOp.reserve){
						this.pcaTableValidate=false;
					}
				}
			}
			if(this.pcaTableSetting[2].selected){
				if(this.pcaTableSetting[0].selected&&this.pcaTableSetting[1].selected){
					if((this.pcaTableSetting[0].end!=this.pcaTableSetting[1].start-1)||(this.pcaTableSetting[1].end!=this.pcaTableSetting[2].start-1)||this.pcaTableSetting[2].end<this.pcaOp.reserve){
						this.pcaTableValidate=false;
					}
				}else{
					this.pcaTableValidate=false;
				}
			}else if(this.pcaTableSetting[1].selected){
				if(this.pcaTableSetting[0].selected){
					if(this.pcaTableSetting[0].end!=this.pcaTableSetting[1].start-1||this.pcaTableSetting[1].end<this.pcaOp.reserve){
						this.pcaTableValidate=false;
					}
				}else{
					this.pcaTableValidate=false;
				}
			}else if(this.pcaTableSetting[0].selected){
				if(this.pcaTableSetting[0].end<this.pcaOp.reserve){
					this.pcaTableValidate=false;
				}
			}
		}
		return this.pcaTableValidate;
	}
}